webpackJsonp([1],Array(20).concat([
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLASSTING_REDIRECT_URI */
/* unused harmony export CLASSTING_ACCOUNTS_URL */
/* unused harmony export CLASSTING_OIDC_CLIENT_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLASSTING_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CT_VIEWER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CT_STORE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MINERVA_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NATIVE_APP_NAME; });
/* unused harmony export BILL_API_URL */
/* unused harmony export PERF_API_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOG_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GA_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLASSTING_AI_INTRO_WEB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLASSTING_FULL_AUTH_URL; });
/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USER_TUTORIAL_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLASSTING_OPEN_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONTENT_REPORTS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLASSTING_PAY_WEB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_randomstring__);


var CLASSTING_REDIRECT_URI = window.location.origin + '/oauth_callback/classting';
var CLASSTING_ACCOUNTS_URL = "https://accounts.classting.com";
var CLASSTING_OIDC_CLIENT_ID = "bktqTXxY2jy5fLAvHNg1i";
var CLASSTING_URL = "https://www.classting.com";
var CT_VIEWER_URL = "https://cl-viewer.classting.com";
var CT_STORE_URL = "https://store-web.classting.com";
var MINERVA_API_URL = "https://clapi.classting.com/v1";
var NATIVE_APP_NAME = "classting";
var BILL_API_URL = "https://bill.classting.com/plugins/cbill-plugin/v1";
var PERF_API_URL = "https://perf-api.classting.com/v1";
var LOG_URL = "https://wlog.classting.net/learning.api";
var GA_ID = "UA-30499296-24";
var CLASSTING_AI_INTRO_WEB = "https://ai.classting.com";
var CLASSTING_FULL_AUTH_URL = [CLASSTING_ACCOUNTS_URL + '/oidc/auth', '?client_id=' + CLASSTING_OIDC_CLIENT_ID, '&response_type=id_token+token', '&scope=openid+email+profile', '&nonce=' + __WEBPACK_IMPORTED_MODULE_0_randomstring___default.a.generate(10), '&redirect_uri=' + CLASSTING_REDIRECT_URI].join('');

var VERSION = __webpack_require__.i({"NODE_ENV":"production","CLASSTING_ACCOUNTS_URL":"https://accounts.classting.com","CLASSTING_OIDC_CLIENT_ID":"bktqTXxY2jy5fLAvHNg1i","CLASSTING_REDIRECT_URI":"https://perf-web.classting.com/oauth_callback/classting","CT_VIEWER_URL":"https://cl-viewer.classting.com","CLASSTING_URL":"https://www.classting.com","CT_STORE_URL":"https://store-web.classting.com","MINERVA_API_URL":"https://clapi.classting.com/v1","CLASSTING_OPEN_API_URL":"https://api.classting.com/v2","BILL_API_URL":"https://bill.classting.com/plugins/cbill-plugin/v1","PERF_API_URL":"https://perf-api.classting.com/v1","CLASSTING_PAY_WEB":"https://pay-web.classting.com","LOG_URL":"https://wlog.classting.net/learning.api","CLASSTING_AI_INTRO_WEB":"https://ai.classting.com","GA_ID":"UA-30499296-24","NATIVE_APP_NAME":"classting","CONTENT_REPORTS_CONFIG":{"url":"https://hooks.slack.com/services/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","channel":"#report_lclectures"},"AI_FIRESTORE_COLLECTION":"classting-ai"}).VERSION;
var USER_TUTORIAL_KEY = 'learning_user_tutorial';
var CLASSTING_OPEN_API_URL = "https://api.classting.com/v2";
var CONTENT_REPORTS_CONFIG = {"url":"https://hooks.slack.com/services/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","channel":"#report_lclectures"};
var CLASSTING_PAY_WEB = "https://pay-web.classting.com";

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* unused harmony export removeToken */
/* harmony export (immutable) */ __webpack_exports__["e"] = setCountryCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = setAcceptLanguage;
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__(897);



var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

http.defaults.headers.post['Content-Type'] = 'application/json';

function setToken(token) {
  if (token) {
    http.defaults.headers.common.Authorization = 'Bearer ' + token;
  }
}

function removeToken() {
  delete http.defaults.headers.common.Authorization;
}

function setCountryCode(countryCode) {
  http.defaults.headers.common['Country-Code'] = countryCode || 'KR';
}

function setAcceptLanguage(language) {
  http.defaults.headers.common['accept-language'] = language || 'ko';
}

function install(Vue, _ref) {
  var store = _ref.store,
      router = _ref.router;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* default */])(http, store, router);

  Object.defineProperty(Vue.prototype, '$http', {
    get: function get() {
      return http;
    }
  });
}

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getSchoolYear: function getSchoolYear(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, 'school_year', 0);
    },
    getName: function getName(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item, 'name');
    },
    getTranslatedName: function getTranslatedName(item) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(item, 'id')) {
        return this.getName(item);
      }

      return this.$t(this.getName(item));
    }
  }
});

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getIntFormat: function getIntFormat(num, useNegative) {
      if (useNegative && num) {
        return parseInt(num, 10);
      }

      if (num && num > 0) {
        return parseInt(num, 10);
      }

      return 0;
    },
    getRatio: function getRatio(num, total) {
      if (total === 0) {
        return 0;
      }

      return num / total * 100;
    },
    getSum: function getSum(numList) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["sum"])(numList);
    },
    getToCommas: function getToCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getFormatCount: function getFormatCount(count) {
      var firsrtLimit = 10000;
      var secondLimit = 100000000;

      if (count >= firsrtLimit && count < secondLimit) {
        return (count / firsrtLimit).toFixed(0) + '\uB9CC';
      }

      if (count >= secondLimit) {
        return (count / secondLimit).toFixed(0) + '\uC5B5';
      }

      return count;
    }
  }
});

/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1334)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1575),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54010d8f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_USER_RELATIONSHIPS = 'auth/SET_USER_RELATIONSHIPS';
var SET_PROPERTY = 'auth/SET_PROPERTY';
var SET_DEVICE = 'auth/SET_DEVICE';
var SET_TOKEN = 'auth/SET_TOKEN';
var SET_USER = 'auth/SET_USER';
var SIGN_OUT = 'auth/SIGN_OUT';
var SET_LICENCE = 'auth/SET_LICENCE';
var SET_PREMIUM_SCHOOL = 'auth/SET_PREMIUM_SCHOOL';
var SET_GRADES = 'auth/SET_GRADES';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_USER_RELATIONSHIPS: SET_USER_RELATIONSHIPS,
  SET_PROPERTY: SET_PROPERTY,
  SET_TOKEN: SET_TOKEN,
  SET_USER: SET_USER,
  SIGN_OUT: SIGN_OUT,
  SET_DEVICE: SET_DEVICE,
  SET_LICENCE: SET_LICENCE,
  SET_PREMIUM_SCHOOL: SET_PREMIUM_SCHOOL,
  SET_GRADES: SET_GRADES
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_CHECKED_TUTORIALS = 'tutorials/SET_CHECKED_TUTORIALS';
var CHECK_TUTORIAL = 'tutorials/CHECK_TUTORIAL';

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CHECKED_TUTORIALS: SET_CHECKED_TUTORIALS,
  CHECK_TUTORIAL: CHECK_TUTORIAL
});

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61b4ef35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1348)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1592),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins__ = __webpack_require__(903);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  strict: "production" !== 'production',

  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["a" /* default */],
  plugins: __WEBPACK_IMPORTED_MODULE_5__plugins__["a" /* default */],

  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__
}));

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(825);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_BOOKMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_BOOKMARKS_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BOOKMARKS_LECTURES; });
var RESET_BOOKMARKS = 'bookmarks/RESET_BOOKMARKS';
var RESET_BOOKMARKS_POSITION = 'bookmarks/RESET_BOOKMARKS_POSITION';
var SET_BOOKMARKS_LECTURES = 'bookmarks/SET_BOOKMARKS_LECTURES';

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(837);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ASSIGNMENT_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CLASS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_ASSIGNMENTS; });
var SET_ASSIGNMENTS = 'assignment/SET_ASSIGNMENTS';
var SET_ASSIGNMENT_STATS = 'assignment/SET_ASSIGNMENT_STATS';
var SET_CLASSES = 'aassignment/SET_CLASSES';
var SET_CLASS_ID = 'aassignment/SET_CLASSES_ID';
var RESET_ASSIGNMENTS = 'aassignment/RESET_ASSIGNMENTS';

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(847);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CAT_SUBJECT_DOMAINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_CAT_SUBJECT_DOMAINS; });
/* unused harmony export SET_SELECTED_SUBJECT_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CAT_STATS; });
var SET_CAT_SUBJECT_DOMAINS = 'cat-domain/SET_CAT_SUBJECT_DOMAINS';
var RESET_CAT_SUBJECT_DOMAINS = 'cat-domain/RESET_CAT_SUBJECT_DOMAINS';
var SET_SELECTED_SUBJECT_ID = 'cat-domain/SET_SELECTED_SUBJECT_ID';
var SET_CAT_STATS = 'cat-domain/SET_CAT_STATS';

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CAT_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CAT_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIVE_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CAT_CONFIGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PROFICIENCY_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_FILTER_PROFICIENCY_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_FILTER_PROFICIENCY_RANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SELECTED_SUBJECT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_CHILD_PROFICIENCY_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_CHILD_PROFICIENCY_RANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SELECTED_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_VIDEO_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_CARD_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_SELECTED_LECTURE_SUBJECT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_SUBJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_RECOMMEND_VIDEO_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_RECOMMEND_CARD_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_BUSY; });
/* unused harmony export SET_COUNTRIES */
/* unused harmony export SET_USER_COUNTRY */
var SET_CAT_SUBJECT = 'cat/SET_CAT_SUBJECT';
var SET_CAT_DOMAIN = 'cat/SET_CAT_DOMAIN';
var SET_ACTIVE_ASSIGNMENT = 'cat/SET_ACTIVE_ASSIGNMENT';
var SET_CAT_CONFIGS = 'cat/SET_CAT_CONFIGS';
var SET_PROFICIENCY_HISTORY = 'cat/SET_PROFICIENCY_HISTORY';
var SET_FILTER_PROFICIENCY_HISTORY = 'cat/SET_FILTER_PROFICIENCY_HISTORY';
var SET_FILTER_PROFICIENCY_RANK = 'cat/SET_FILTER_PROFICIENCY_RANK';
var SET_SELECTED_SUBJECT_ID = 'cat/SET_SELECTED_SUBJECT_ID';
var SET_CHILD_PROFICIENCY_HISTORY = 'cat/SET_CHILD_PROFICIENCY_HISTORY';
var SET_CHILD_PROFICIENCY_RANK = 'cat/SET_CHILD_PROFICIENCY_RANK';
var SET_SELECTED_CHILD = 'cat/SET_SELECTED_CHILD';
var SET_VIDEO_LECTURES = 'cat/SET_VIDEO_LECTURES';
var SET_CARD_LECTURES = 'cat/SET_CARD_LECTURES';
var SET_SELECTED_LECTURE_SUBJECT_ID = 'cat/SET_SELECTED_LECTURE_SUBJECT_ID';
var SET_SUBJECTS = 'cat/SET_SUBJECTS';
var SET_RECOMMEND_VIDEO_LECTURES = 'video-lectures/SET_RECOMMEND_VIDEO_LECTURES';
var SET_RECOMMEND_CARD_LECTURES = 'card-lectures/SET_RECOMMEND_CARD_LECTURES';
var SET_BUSY = 'cat/SET_BUSY';
var SET_COUNTRIES = 'cat/SET_COUNTRIES';
var SET_USER_COUNTRY = 'cat/SET_USER_COUNTRY';

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LEARNING_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_LEARNING_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DOMAIN_PROFICIENCY_RANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_DOMAIN_PROFICIENCY_RANK; });
var SET_LEARNING_ELEMENT = 'cat-proficiency/SET_LEARNING_ELEMENT';
var RESET_LEARNING_ELEMENT = 'cat-proficiency/RESET_LEARNING_ELEMENT';
var SET_DOMAIN = 'cat-proficiency/SET_DOMAIN';
var SET_DOMAIN_PROFICIENCY_RANK = 'cat-proficiency/SET_DOMAIN_PROFICIENCY_RANK';
var RESET_DOMAIN_PROFICIENCY_RANK = 'cat-proficiency/RESET_DOMAIN_PROFICIENCY_RANK';

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SUBSCRIPTIONS_COURSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_SUBSCRIPTIONS_COURSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_SUBSCRIPTIONS_COURSES_POSITION; });
var SET_SUBSCRIPTIONS_COURSES = 'course/SET_SUBSCRIPTIONS_COURSES';
var RESET_SUBSCRIPTIONS_COURSES = 'course/RESET_SUBSCRIPTIONS_CARD_COURSES';
var RESET_SUBSCRIPTIONS_COURSES_POSITION = 'course/RESET_SUBSCRIPTIONS_COURSES_POSITION';

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(871);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_DOMAIN_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_DOMAIN_LECTURES_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DOMAIN_LECTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LEARNING_ELEMENT; });
var RESET_DOMAIN_LECTURES = 'domain-lectures/RESET_DOMAIN_LECTURES';
var RESET_DOMAIN_LECTURES_POSITION = 'domain-lectures/RESET_DOMAIN_LECTURES_POSITION';
var SET_DOMAIN_LECTURES = 'domain-lectures/SET_DOMAIN_LECTURES';
var SET_LEARNING_ELEMENT = 'domain-lectures/SET_LEARNING_ELEMENT';

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });





/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getRouteQuery']), {
    isBrowserView: function isBrowserView() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.getRouteQuery.source);
    },
    isDesktop: function isDesktop() {
      return this.isBrowserView || !this.$mobile.isMobile();
    }
  })
});

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 531 */,
/* 532 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1361)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bb205c48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1346)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7038d564",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1312)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-056381ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bac4c56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1351)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1595),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7af41aae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export components */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionAchievedModal__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionAchievedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionAchievedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubheaderNavItem__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubheaderNavItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubheaderNavItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DesktopSubheader__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DesktopSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DesktopSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasicNumberLine__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasicNumberLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BasicNumberLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicLineGauge__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasicLineGauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BasicLineGauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NoHeaderLayout__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NoHeaderLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NoHeaderLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalContainer__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LoadingBounce__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LoadingBounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__LoadingBounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesktopHeader__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DesktopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DesktopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BasicModal__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BasicModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BasicModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MainLayout__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MainLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__MainLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AppHeader__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BasicCard__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BasicCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__BasicCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineGauge__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineGauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__LineGauge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SubHeader__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SubHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SubHeaderTab__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SubHeaderTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__SubHeaderTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeftImageCard__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeftImageCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__LeftImageCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ImageCard__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ImageCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ImageCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TextCard__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TextCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__TextCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__VideoCard__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__VideoCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__VideoCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Lvideo__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Lvideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Lvideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Layout__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Card__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__NavigationBar__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__NavigationBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__NavigationBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ProgressBar__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ToggleSwitch__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ToggleSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ToggleSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CourseCard__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CourseCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__CourseCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CustomModal__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CustomModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__CustomModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ReportContentModal__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ReportContentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ReportContentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Radio__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__EmptyContent__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__EmptyContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__EmptyContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PrimeSnackBar__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PrimeSnackBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__PrimeSnackBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__LicenceModal__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__LicenceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__LicenceModal__);



































var components = {
  MissionAchievedModal: __WEBPACK_IMPORTED_MODULE_1__MissionAchievedModal___default.a,
  SubheaderNavItem: __WEBPACK_IMPORTED_MODULE_2__SubheaderNavItem___default.a,
  DesktopSubheader: __WEBPACK_IMPORTED_MODULE_3__DesktopSubheader___default.a,
  BasicNumberLine: __WEBPACK_IMPORTED_MODULE_4__BasicNumberLine___default.a,
  BasicLineGauge: __WEBPACK_IMPORTED_MODULE_5__BasicLineGauge___default.a,
  NoHeaderLayout: __WEBPACK_IMPORTED_MODULE_6__NoHeaderLayout___default.a,
  ModalContainer: __WEBPACK_IMPORTED_MODULE_7__ModalContainer___default.a,
  LoadingBounce: __WEBPACK_IMPORTED_MODULE_8__LoadingBounce___default.a,
  DesktopHeader: __WEBPACK_IMPORTED_MODULE_9__DesktopHeader___default.a,
  BasicModal: __WEBPACK_IMPORTED_MODULE_10__BasicModal___default.a,
  MainLayout: __WEBPACK_IMPORTED_MODULE_11__MainLayout___default.a,
  AppHeader: __WEBPACK_IMPORTED_MODULE_12__AppHeader___default.a,
  BasicCard: __WEBPACK_IMPORTED_MODULE_13__BasicCard___default.a,
  LineGauge: __WEBPACK_IMPORTED_MODULE_14__LineGauge___default.a,
  SubHeader: __WEBPACK_IMPORTED_MODULE_15__SubHeader___default.a,
  SubHeaderTab: __WEBPACK_IMPORTED_MODULE_16__SubHeaderTab___default.a,
  LeftImageCard: __WEBPACK_IMPORTED_MODULE_17__LeftImageCard___default.a,
  ImageCard: __WEBPACK_IMPORTED_MODULE_18__ImageCard___default.a,
  TextCard: __WEBPACK_IMPORTED_MODULE_19__TextCard___default.a,
  VideoCard: __WEBPACK_IMPORTED_MODULE_20__VideoCard___default.a,
  Lvideo: __WEBPACK_IMPORTED_MODULE_21__Lvideo___default.a,
  Layout: __WEBPACK_IMPORTED_MODULE_22__Layout___default.a,
  Card: __WEBPACK_IMPORTED_MODULE_23__Card___default.a,
  NavigationBar: __WEBPACK_IMPORTED_MODULE_24__NavigationBar___default.a,
  ProgressBar: __WEBPACK_IMPORTED_MODULE_25__ProgressBar___default.a,
  ToggleSwitch: __WEBPACK_IMPORTED_MODULE_26__ToggleSwitch___default.a,
  CourseCard: __WEBPACK_IMPORTED_MODULE_27__CourseCard___default.a,
  CustomModal: __WEBPACK_IMPORTED_MODULE_28__CustomModal___default.a,
  ReportContentModal: __WEBPACK_IMPORTED_MODULE_29__ReportContentModal___default.a,
  Radio: __WEBPACK_IMPORTED_MODULE_30__Radio___default.a,
  EmptyContent: __WEBPACK_IMPORTED_MODULE_31__EmptyContent___default.a,
  PrimeSnackBar: __WEBPACK_IMPORTED_MODULE_32__PrimeSnackBar___default.a,
  LicenceModal: __WEBPACK_IMPORTED_MODULE_33__LicenceModal___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (name) {
    Vue.component(name, components[name]);
  });
}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export directives */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mdl__ = __webpack_require__(895);



var directives = {
  mdl: __WEBPACK_IMPORTED_MODULE_1__mdl__["a" /* default */]
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(directives).forEach(function (name) {
    Vue.directive(name, directives[name]);
  });
}

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ko_KR_json__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ko_KR_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ko_KR_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zh_TW_json__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zh_TW_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__zh_TW_json__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'ko',
  fallbackLocale: 'ko',
  messages: {
    ko: __WEBPACK_IMPORTED_MODULE_2__ko_KR_json___default.a,
    'zh-tw': __WEBPACK_IMPORTED_MODULE_3__zh_TW_json___default.a
  }
}));

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mobile */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);




var Mobile = function () {
  function Mobile() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mobile);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Mobile, [{
    key: 'callNative',

    /* eslint-disable */
    value: function callNative(url) {
      if (this.isIOS()) {
        window.location = url;
      } else {
        if (!window.ctandroid) {
          // android under 4.2
          window.prompt(url);
        } else {
          window.ctandroid.submitFromWeb(url);
        }
      }
    }
  }, {
    key: 'openNewWebView',
    value: function openNewWebView(url) {
      this.callNative('ctjscall://open?source=' + __WEBPACK_IMPORTED_MODULE_2__config__["e" /* NATIVE_APP_NAME */] + '&url=' + encodeURIComponent(url));
    }
  }, {
    key: 'closeWebView',
    value: function closeWebView() {
      this.callNative('ctjscall://close?source=' + __WEBPACK_IMPORTED_MODULE_2__config__["e" /* NATIVE_APP_NAME */]);
    }
  }, {
    key: 'isMobile',
    value: function isMobile() {
      return this.isIOS() || this.isAndroid();
    }
  }, {
    key: 'isIOS',
    value: function isIOS() {
      var userAgent = window.navigator.userAgent;

      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isAndroid',
    value: function isAndroid() {
      var userAgent = window.navigator.userAgent;

      if (userAgent.match(/android/i)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'callActionbar',
    value: function callActionbar(isVisible) {
      this.callNative('ctjscall://navigation?source=classting&is_visible=' + isVisible);
    }
  }, {
    key: 'getClasstingAndroidVersion',
    value: function getClasstingAndroidVersion() {
      var userAgent = window.navigator.userAgent;
      var regex = /classting_android,\s([0-9]).([0-9]).([0-9])*/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        var currentVersion = Number(match.slice(1, 4).join(''));
        return currentVersion;
      }

      return 0;
    }
  }, {
    key: 'getAndroidVersion',
    value: function getAndroidVersion() {
      var userAgent = window.navigator.userAgent;
      var regex = /android\s([0-9]*)/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return match[1];
      }

      return 0;
    }
  }, {
    key: 'isClasstingClient',
    value: function isClasstingClient() {
      return this.isClasstingIos() || this.isClasstingAndroid();
    }
  }, {
    key: 'isClasstingAndroid',
    value: function isClasstingAndroid() {
      var userAgent = window.navigator.userAgent;
      var regex = /classting_android,\s([0-9])*/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isClasstingIos',
    value: function isClasstingIos() {
      var userAgent = window.navigator.userAgent;
      var regex = /classting_iphone/;
      var match = regex.exec(userAgent.toLowerCase());

      if (match) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isOldAndroid',
    value: function isOldAndroid() {
      if (this.isAndroid() && this.compareVersions(this.getAndroidVersion(), '5.0.0') < 0) {
        return true;
      }

      return false;
    }
  }, {
    key: 'compareVersions',
    value: function compareVersions(left, right) {
      if (!(typeof left === 'string' && typeof right === 'string')) {
        return false;
      }

      var a = left.split('.');
      var b = right.split('.');
      var len = Math.max(a.length, b.length);

      for (var i = 0; i < len; i += 1) {
        if (a[i] && !b[i] && parseInt(a[i], 10) > 0 || parseInt(a[i], 10) > parseInt(b[i], 10)) {
          return 1;
        } else if (b[i] && !a[i] && parseInt(b[i], 10) > 0 || parseInt(a[i], 10) < parseInt(b[i], 10)) {
          return -1;
        }
      }

      return 0;
    }
  }]);

  return Mobile;
}();

var mobile = new Mobile();

function install(Vue) {
  Object.defineProperty(Vue.prototype, '$mobile', {
    get: function get() {
      return mobile;
    }
  });
}

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__beforeEachRoutes__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__afterEachRoutes__ = __webpack_require__(898);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { y: 0 };
  },


  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* router */]))
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__beforeEachRoutes__["a" /* default */])(router);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__afterEachRoutes__["a" /* default */])(router);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_MobileCallback__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_MobileCallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_MobileCallback__);



var router = [{
  name: 'auth.oauthCallback',
  path: '/oauth_callback/:provider',
  component: __WEBPACK_IMPORTED_MODULE_0__views_OAuthCallback___default.a,
  meta: {
    requiresAuth: false
  }
}, {
  name: 'auth.mobileCallback',
  path: '/mobile_callback/:provider',
  component: __WEBPACK_IMPORTED_MODULE_1__views_MobileCallback___default.a,
  meta: {
    requiresAuth: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setToken"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["setDevice"] = setDevice;
/* harmony export (immutable) */ __webpack_exports__["fetchUser"] = fetchUser;
/* harmony export (immutable) */ __webpack_exports__["fetchUserRelationships"] = fetchUserRelationships;
/* harmony export (immutable) */ __webpack_exports__["setUserInStore"] = setUserInStore;
/* harmony export (immutable) */ __webpack_exports__["setUserPropertyInStore"] = setUserPropertyInStore;
/* harmony export (immutable) */ __webpack_exports__["setUserRelationships"] = setUserRelationships;
/* harmony export (immutable) */ __webpack_exports__["signOut"] = signOut;
/* harmony export (immutable) */ __webpack_exports__["checkUserToken"] = checkUserToken;
/* harmony export (immutable) */ __webpack_exports__["fetchUserLicence"] = fetchUserLicence;
/* harmony export (immutable) */ __webpack_exports__["setUserLicence"] = setUserLicence;
/* harmony export (immutable) */ __webpack_exports__["fetchPremiumSchool"] = fetchPremiumSchool;
/* harmony export (immutable) */ __webpack_exports__["setPremiumSchool"] = setPremiumSchool;
/* harmony export (immutable) */ __webpack_exports__["fetchGrades"] = fetchGrades;
/* harmony export (immutable) */ __webpack_exports__["setGrades"] = setGrades;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(231);








function setToken(_ref, token) {
  var commit = _ref.commit,
      state = _ref.state;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_TOKEN, token);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(token);
}

function setDevice(_ref2, device) {
  var commit = _ref2.commit,
      state = _ref2.state;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_DEVICE, device);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(device);
}

function fetchUser(_ref3) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* MINERVA_API_URL */] + '/users/sign-in', {}).then(function (res) {
    return dispatch('setUserInStore', res.data);
  }).then(function (userInfo) {
    return dispatch('checkUserTutorial').then(function () {
      return userInfo;
    });
  }).catch(function (err) {
    if (err.response && err.response.status === 404) {
      console.error('user not found in DB!');
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  }).catch(function (err) {
    // TODO: handle error
    dispatch('setToken', '');

    console.error('err while fetching user:', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchUserRelationships(_ref4) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* MINERVA_API_URL */] + '/users/relationships').then(function (res) {
    return dispatch('setUserRelationships', res.data.data);
  }).catch(function (err) {
    console.error('err while fetching user relationships', err);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setUserInStore(_ref5, userInfo) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_USER, userInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(userInfo);
}

function setUserPropertyInStore(_ref6, setInfo) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PROPERTY, setInfo);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setUserRelationships(_ref7, userRelationshipList) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_USER_RELATIONSHIPS, userRelationshipList);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function signOut(_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SIGN_OUT);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function checkUserToken(_ref9) {
  var state = _ref9.state;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(state.token)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.token);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('NO_TOKEN');
}

function fetchUserLicence(_ref10) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* MINERVA_API_URL */] + '/users/me/current-user-licence').then(function (res) {
    return dispatch('setUserLicence', res.data);
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setUserLicence(_ref11, userLicence) {
  var commit = _ref11.commit,
      state = _ref11.state;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_LICENCE, userLicence);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(userLicence);
}

function fetchPremiumSchool(_ref12) {
  var dispatch = _ref12.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* MINERVA_API_URL */] + '/is-premium-school ').then(function (res) {
    return dispatch('setPremiumSchool', res.data);
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setPremiumSchool(_ref13, premiumSchool) {
  var commit = _ref13.commit,
      state = _ref13.state;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PREMIUM_SCHOOL, premiumSchool);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(premiumSchool);
}

function fetchGrades(_ref14) {
  var dispatch = _ref14.dispatch;

  return __WEBPACK_IMPORTED_MODULE_3__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* MINERVA_API_URL */] + '/grades').then(function (res) {
    return dispatch('setGrades', res.data);
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function setGrades(_ref15, grades) {
  var commit = _ref15.commit,
      state = _ref15.state;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_GRADES, grades);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(grades);
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isSignedIn"] = isSignedIn;
/* harmony export (immutable) */ __webpack_exports__["currentUser"] = currentUser;
/* harmony export (immutable) */ __webpack_exports__["currentUserId"] = currentUserId;
/* harmony export (immutable) */ __webpack_exports__["currentUserGrade"] = currentUserGrade;
/* harmony export (immutable) */ __webpack_exports__["currentUserRole"] = currentUserRole;
/* harmony export (immutable) */ __webpack_exports__["currentUserName"] = currentUserName;
/* harmony export (immutable) */ __webpack_exports__["currentUserCountryCode"] = currentUserCountryCode;
/* harmony export (immutable) */ __webpack_exports__["currentUserLanguage"] = currentUserLanguage;
/* harmony export (immutable) */ __webpack_exports__["isPrimeSupportCountry"] = isPrimeSupportCountry;
/* harmony export (immutable) */ __webpack_exports__["isSupportedGrade"] = isSupportedGrade;
/* harmony export (immutable) */ __webpack_exports__["isTeacherUser"] = isTeacherUser;
/* harmony export (immutable) */ __webpack_exports__["isParentUser"] = isParentUser;
/* harmony export (immutable) */ __webpack_exports__["userRelationships"] = userRelationships;
/* harmony export (immutable) */ __webpack_exports__["userChildrenList"] = userChildrenList;
/* harmony export (immutable) */ __webpack_exports__["getIsDevice"] = getIsDevice;
/* harmony export (immutable) */ __webpack_exports__["isPrime"] = isPrime;
/* harmony export (immutable) */ __webpack_exports__["userLicence"] = userLicence;
/* harmony export (immutable) */ __webpack_exports__["isUserLicence"] = isUserLicence;
/* harmony export (immutable) */ __webpack_exports__["isPremiumSchool"] = isPremiumSchool;
/* harmony export (immutable) */ __webpack_exports__["isSubscriptionUser"] = isSubscriptionUser;
/* harmony export (immutable) */ __webpack_exports__["getGradeMap"] = getGradeMap;
/* harmony export (immutable) */ __webpack_exports__["getSupportCountries"] = getSupportCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function isSignedIn(state) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.user);
}

function currentUser(state) {
  return state.user;
}

function currentUserId(state) {
  if (!state.user) {
    return null;
  }

  return state.user.id;
}

function currentUserGrade(state) {
  if (!state.user) {
    return null;
  }

  return state.user.grade || 0;
}

function currentUserRole(state) {
  if (!state.user) {
    return null;
  }

  return state.user.role;
}

function currentUserName(state, getters) {
  return getters.currentUser.name;
}

function currentUserCountryCode(state, getters) {
  return getters.currentUser.country_code || 'KR';
}

function currentUserLanguage(state, getters) {
  return getters.currentUser.language;
}

function isPrimeSupportCountry(state, getters) {
  return getters.currentUserCountryCode === 'KR';
}

function isSupportedGrade(state, getters) {
  return getters.currentUserGrade > 2;
}

function isTeacherUser(state, getters) {
  return getters.currentUserRole === 'teacher';
}

function isParentUser(state, getters) {
  return getters.currentUserRole === 'parent';
}

function userRelationships(state) {
  return state.userRelationships;
}

function userChildrenList(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["values"])(state.userRelationships).filter(function (relation) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(relation, 'child');
  }).map(function (relation) {
    return relation.child;
  });
}

function getIsDevice(state) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.device);
}

function isPrime(state) {
  return state.user.is_prime;
}

function userLicence(state) {
  return state.userLicence;
}

function isUserLicence(state) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(state.userLicence)) {
    return false;
  }

  return true;
}

function isPremiumSchool(state) {
  return state.premiumSchool && state.premiumSchool.is_premium_school;
}

function isSubscriptionUser(state, getters) {
  return getters.isPrime || getters.isUserLicence || getters.isPremiumSchool;
}

function getGradeMap(state) {
  return state.gradeMap || {};
}

function getSupportCountries(state) {
  return state.supportCountries;
}

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(824);







var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module, plugin: __WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* default */] });

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(231);



var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PROPERTY, function (state, _ref) {
  var property = _ref.property,
      value = _ref.value;

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.user, property, value);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_TOKEN, function (state, token) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'token', token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_USER, function (state, user) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'user', user);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SIGN_OUT, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state, 'token');
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state, 'user');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_DEVICE, function (state, device) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'device', device);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_USER_RELATIONSHIPS, function (state, userRelationshipList) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'userRelationships', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.userRelationships, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(userRelationshipList, function (eachRelation) {
    return eachRelation.id;
  })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_LICENCE, function (state, userLicence) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'userLicence', userLicence);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_PREMIUM_SCHOOL, function (state, premiumSchool) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'premiumSchool', premiumSchool);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_GRADES, function (state, grades) {
  var initGrade = {
    0: { name: 'common.all_grade' },
    9999: { name: 'common.grade_placeholder' },
    null: { name: 'common.others' }
  };

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'gradeMap', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, initGrade, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keyBy"])(grades, 'id')));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(231);





function subscribe(store) {
  store.subscribe(function (mutation, _ref) {
    var Auth = _ref.Auth;

    switch (mutation.type) {
      case __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_TOKEN:
        {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__plugins_http__["c" /* setToken */])(Auth.token);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_USER:
        {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('userId', Auth.user.user_id);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('dimension1', Auth.user.role);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('dimension2', Auth.user.grade_id);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('dimension3', Auth.user.school_id);
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$ga.set('dimension4', Auth.user.zipcode);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__plugins_http__["d" /* setAcceptLanguage */])(Auth.user.language);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__plugins_http__["e" /* setCountryCode */])(Auth.user.country_code);
          break;
        }

      default:
        {
          break;
        }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  subscribe(store);
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  user: {},
  device: {},
  userRelationships: {},
  userLicence: {},
  gradeMap: {},
  supportCountries: ['KR', 'TW']
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Bookmark__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Bookmark__);


var router = [{
  name: 'bookmark',
  path: '/bookmark',
  component: __WEBPACK_IMPORTED_MODULE_0__views_Bookmark___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchBookmarksVideoLectures"] = fetchBookmarksVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["resetBookmarks"] = resetBookmarks;
/* harmony export (immutable) */ __webpack_exports__["resetBookmarksPosition"] = resetBookmarksPosition;
/* harmony export (immutable) */ __webpack_exports__["fetchBookmarksCardLectures"] = fetchBookmarksCardLectures;
/* harmony export (immutable) */ __webpack_exports__["setBookmarksLectures"] = setBookmarksLectures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(364);






function fetchBookmarksVideoLectures(_ref) {
  var dispatch = _ref.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/bookmarks/video-lectures', { params: filters }).then(function (res) {
    return dispatch('setBookmarksLectures', {
      bookmarksLectures: res.data,
      lectureType: filters.lectureType || 1
    });
  });
}

function resetBookmarks(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* RESET_BOOKMARKS */]);
}

function resetBookmarksPosition(_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* RESET_BOOKMARKS_POSITION */]);
}

function fetchBookmarksCardLectures(_ref4) {
  var dispatch = _ref4.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/bookmarks/card-lectures', { params: filters }).then(function (res) {
    return dispatch('setBookmarksLectures', {
      bookmarksLectures: res.data,
      lectureType: filters.lectureType || 2
    });
  });
}

function setBookmarksLectures(_ref5, _ref6) {
  var commit = _ref5.commit;
  var bookmarksLectures = _ref6.bookmarksLectures,
      lectureType = _ref6.lectureType;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_BOOKMARKS_LECTURES */], { bookmarksLectures: bookmarksLectures, lectureType: lectureType });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(bookmarksLectures);
}

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFilterBookmarks"] = getFilterBookmarks;
/* harmony export (immutable) */ __webpack_exports__["getFilterBookmarksPosition"] = getFilterBookmarksPosition;
function getFilterBookmarks(state) {
  return state.filterBookmarks;
}

function getFilterBookmarksPosition(state) {
  return state.filterBookmarksPosition;
}

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(831);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(364);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* RESET_BOOKMARKS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterBookmarks', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_BOOKMARKS_POSITION */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterBookmarksPosition', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_BOOKMARKS_LECTURES */], function (state, _ref) {
  var bookmarksLectures = _ref.bookmarksLectures,
      lectureType = _ref.lectureType;

  if (!state.filterBookmarks[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterBookmarks, lectureType, []);
  }

  if (!state.filterBookmarksPosition[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterBookmarksPosition, lectureType, 1);
  }

  var lecturesPosition = Number(state.filterBookmarksPosition[lectureType] + 1);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterBookmarksPosition, lectureType, lecturesPosition);

  var lecturesConcat = state.filterBookmarks[lectureType].concat(bookmarksLectures);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterBookmarks, lectureType, lecturesConcat);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  filterBookmarks: {},
  filterBookmarksPosition: {}
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_RecommendCardLecture__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_RecommendCardLecture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_RecommendCardLecture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CardLectureView__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CardLectureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_CardLectureView__);



var router = [{
  name: 'recommend-card-lecture',
  path: '/recommend/card',
  component: __WEBPACK_IMPORTED_MODULE_0__views_RecommendCardLecture___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}, {
  name: 'card-lecture-view',
  path: '/card/:cardId(\\d+)',
  component: __WEBPACK_IMPORTED_MODULE_1__views_CardLectureView___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createCardLectureViews"] = createCardLectureViews;
/* harmony export (immutable) */ __webpack_exports__["fetchCardLecture"] = fetchCardLecture;
/* harmony export (immutable) */ __webpack_exports__["fetchCardLectures"] = fetchCardLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchCardLectureIsLiked"] = fetchCardLectureIsLiked;
/* harmony export (immutable) */ __webpack_exports__["createCardLectureLike"] = createCardLectureLike;
/* harmony export (immutable) */ __webpack_exports__["removeCardLectureLike"] = removeCardLectureLike;
/* harmony export (immutable) */ __webpack_exports__["fetchCardLectureIsBookmarked"] = fetchCardLectureIsBookmarked;
/* harmony export (immutable) */ __webpack_exports__["createCardLectureBookmark"] = createCardLectureBookmark;
/* harmony export (immutable) */ __webpack_exports__["removeCardLectureBookmark"] = removeCardLectureBookmark;
/* harmony export (immutable) */ __webpack_exports__["fetchSimilarCardLectures"] = fetchSimilarCardLectures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);




function createCardLectureViews(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var lectureId = _ref2.lectureId,
      params = _ref2.params;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/views', params);
}

function fetchCardLecture(_ref3, lectureId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId).then(function (res) {
    return res.data;
  });
}

function fetchCardLectures(_ref4) {
  var dispatch = _ref4.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchCardLectureIsLiked(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var lectureId = _ref6.lectureId,
      userId = _ref6.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/liked-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createCardLectureLike(_ref7, lectureId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/likes').then(function () {
    return true;
  });
}

function removeCardLectureLike(_ref8, lectureId) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/likes').then(function () {
    return false;
  });
}

function fetchCardLectureIsBookmarked(_ref9, _ref10) {
  var dispatch = _ref9.dispatch;
  var lectureId = _ref10.lectureId,
      userId = _ref10.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/bookmarked-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createCardLectureBookmark(_ref11, lectureId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/bookmarks').then(function () {
    return true;
  });
}

function removeCardLectureBookmark(_ref12, lectureId) {
  var dispatch = _ref12.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/bookmarks').then(function () {
    return false;
  });
}

function fetchSimilarCardLectures(_ref13, _ref14) {
  var dispatch = _ref13.dispatch;
  var filters = _ref14.filters,
      lectureId = _ref14.lectureId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/' + lectureId + '/similar-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(836);


var module = {
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatAssignment__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatAssignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_CatAssignment__);


var router = [{
  name: 'cat-assignment',
  path: '/assignment',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CatAssignment___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchFilterAssignments"] = fetchFilterAssignments;
/* harmony export (immutable) */ __webpack_exports__["setFilterAssignments"] = setFilterAssignments;
/* harmony export (immutable) */ __webpack_exports__["fetchAssignmentStats"] = fetchAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterAssignmentStats"] = fetchFilterAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["setFilterAssignmentStats"] = setFilterAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["fetchClasses"] = fetchClasses;
/* harmony export (immutable) */ __webpack_exports__["setClasses"] = setClasses;
/* harmony export (immutable) */ __webpack_exports__["setClassId"] = setClassId;
/* harmony export (immutable) */ __webpack_exports__["setAssignmentPosition"] = setAssignmentPosition;
/* harmony export (immutable) */ __webpack_exports__["resetAssignments"] = resetAssignments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(367);







function fetchFilterAssignments(_ref, filters) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/assignments', { params: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["omitBy"])(filters, function (item) {
      return item === 'all';
    }) }).then(function (res) {
    return dispatch('setFilterAssignments', {
      classId: filters.class_id || 0,
      status: filters.status,
      assignments: res.data
    });
  });
}

function setFilterAssignments(_ref2, _ref3) {
  var commit = _ref2.commit;
  var classId = _ref3.classId,
      status = _ref3.status,
      assignments = _ref3.assignments;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_ASSIGNMENTS */], { classId: classId, status: status, assignments: assignments });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignments);
}

function fetchAssignmentStats(_ref4) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/assignment-stats').then(function (res) {
    return dispatch('setFilterAssignmentStats', {
      classId: 0,
      assignmentStats: res.data
    });
  });
}

function fetchFilterAssignmentStats(_ref5, classId) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/assignment-stats?class_id=' + classId).then(function (res) {
    return dispatch('setFilterAssignmentStats', {
      classId: classId,
      assignmentStats: res.data
    });
  });
}

function setFilterAssignmentStats(_ref6, _ref7) {
  var commit = _ref6.commit;
  var classId = _ref7.classId,
      assignmentStats = _ref7.assignmentStats;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* SET_ASSIGNMENT_STATS */], { classId: classId, assignmentStats: assignmentStats });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(assignmentStats);
}

function fetchClasses(_ref8, userId) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["l" /* CLASSTING_OPEN_API_URL */] + '/users/' + userId + '/joined_classes').then(function (res) {
    return dispatch('setClasses', res.data);
  });
}

function setClasses(_ref9, classes) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* SET_CLASSES */], classes);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(classes);
}

function setClassId(_ref10, classId) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* SET_CLASS_ID */], classId);
}

function setAssignmentPosition(_ref11, _ref12) {
  var commit = _ref11.commit;
  var classId = _ref12.classId,
      assignmentPosition = _ref12.assignmentPosition;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["SET_ASSIGNMENT_POSITION"], classId, assignmentPosition);
}

function resetAssignments(_ref13) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* RESET_ASSIGNMENTS */]);
}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getAssignments"] = getAssignments;
/* harmony export (immutable) */ __webpack_exports__["getAssignmentStats"] = getAssignmentStats;
/* harmony export (immutable) */ __webpack_exports__["getClasses"] = getClasses;
/* harmony export (immutable) */ __webpack_exports__["getSelectedClassId"] = getSelectedClassId;
/* harmony export (immutable) */ __webpack_exports__["getAssignmentPosition"] = getAssignmentPosition;
function getAssignments(state, getters) {
  return state.assignments[getters.getSelectedClassId];
}

function getAssignmentStats(state, getters) {
  return state.assignmentStats[getters.getSelectedClassId];
}

function getClasses(state) {
  return state.classes;
}

function getSelectedClassId(state) {
  return state.classId || 0;
}

function getAssignmentPosition(state, getters) {
  return state.assignmentPosition[getters.getSelectedClassId];
}

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(840);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(367);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_ASSIGNMENTS */], function (state, _ref) {
  var classId = _ref.classId,
      assignments = _ref.assignments,
      status = _ref.status;

  if (!state.assignments[classId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignmentPosition, classId, {});
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignments, classId, {});
  }

  if (!state.assignments[classId][status]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignmentPosition[classId], status, 1);
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignments[classId], status, []);
  }

  var result = state.assignments[classId][status].concat(assignments);
  var position = Number(state.assignmentPosition[classId][status] + 1);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignmentPosition[classId], status, position);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignments[classId], status, result);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_ASSIGNMENTS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'assignmentPosition', {});
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'assignmentStats', {});
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'assignments', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_ASSIGNMENT_STATS */], function (state, _ref2) {
  var classId = _ref2.classId,
      assignmentStats = _ref2.assignmentStats;

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.assignmentStats, classId, assignmentStats);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_CLASSES */], function (state, classes) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'classes', classes);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_CLASS_ID */], function (state, classId) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'classId', classId);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  assignments: {},
  assignmentStats: {},
  classes: {},
  assignmentPosition: {}
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatDomainView__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatDomainView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_CatDomainView__);


var router = [{
  name: 'cat-domain-view',
  path: '/domain',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CatDomainView___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchCatDomains"] = fetchCatDomains;
/* harmony export (immutable) */ __webpack_exports__["setCatSubjectDomains"] = setCatSubjectDomains;
/* harmony export (immutable) */ __webpack_exports__["resetCatSubjectDomains"] = resetCatSubjectDomains;
/* harmony export (immutable) */ __webpack_exports__["fetchCatStats"] = fetchCatStats;
/* harmony export (immutable) */ __webpack_exports__["setCatStats"] = setCatStats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(369);






function fetchCatDomains(_ref, filters) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/cat-domains', { params: filters }).then(function (res) {
    return dispatch('setCatSubjectDomains', {
      catSubjectDomains: res.data,
      subjectId: filters.subject_id
    });
  });
}

function setCatSubjectDomains(_ref2, _ref3) {
  var commit = _ref2.commit;
  var subjectId = _ref3.subjectId,
      catSubjectDomains = _ref3.catSubjectDomains;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_CAT_SUBJECT_DOMAINS */], { subjectId: subjectId, catSubjectDomains: catSubjectDomains });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(catSubjectDomains);
}

function resetCatSubjectDomains(_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* RESET_CAT_SUBJECT_DOMAINS */]);
}

function fetchCatStats(_ref5, filters) {
  var dispatch = _ref5.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/cl-cat-stats', { params: filters }).then(function (res) {
    return dispatch('setCatStats', {
      catStats: res.data,
      subjectId: filters.subject_id
    });
  });
}

function setCatStats(_ref6, _ref7) {
  var commit = _ref6.commit;
  var subjectId = _ref7.subjectId,
      catStats = _ref7.catStats;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_CAT_STATS */], { subjectId: subjectId, catStats: catStats });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(catStats);
}

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getCatSubjectDomains"] = getCatSubjectDomains;
/* harmony export (immutable) */ __webpack_exports__["getCatStats"] = getCatStats;
/* harmony export (immutable) */ __webpack_exports__["getSubjectDomainPosition"] = getSubjectDomainPosition;
function getCatSubjectDomains(state) {
  return state.catSubjectDomains || {};
}

function getCatStats(state) {
  return state.catStats;
}

function getSubjectDomainPosition(state) {
  return state.catSubjectDomainsPosition;
}

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(846);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(369);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_CAT_SUBJECT_DOMAINS */], function (state, _ref) {
  var subjectId = _ref.subjectId,
      catSubjectDomains = _ref.catSubjectDomains;

  if (!state.catSubjectDomains[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.catSubjectDomains, subjectId, []);
  }

  if (!state.catSubjectDomainsPosition[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.catSubjectDomainsPosition, subjectId, 1);
  }

  var domainPosition = Number(state.catSubjectDomainsPosition[subjectId] + 1);
  var domainList = state.catSubjectDomains[subjectId].concat(catSubjectDomains);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.catSubjectDomainsPosition, subjectId, domainPosition);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.catSubjectDomains, subjectId, domainList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_CAT_STATS */], function (state, _ref2) {
  var subjectId = _ref2.subjectId,
      catStats = _ref2.catStats;

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.catStats, subjectId, catStats);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* RESET_CAT_SUBJECT_DOMAINS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'catSubjectDomainsPosition', {});
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'catSubjectDomains', {});
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  catSubjectDomains: {},
  catStats: {},
  catSubjectDomainsPosition: {}
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatMain__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_CatMain__);


var router = [{
  name: 'cat-main',
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CatMain___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setSelectedSubjectId"] = setSelectedSubjectId;
/* harmony export (immutable) */ __webpack_exports__["fetchCatSubject"] = fetchCatSubject;
/* harmony export (immutable) */ __webpack_exports__["setCatSubjects"] = setCatSubjects;
/* harmony export (immutable) */ __webpack_exports__["fetchCatDomain"] = fetchCatDomain;
/* harmony export (immutable) */ __webpack_exports__["setCatDomains"] = setCatDomains;
/* harmony export (immutable) */ __webpack_exports__["fetchActiveAssignments"] = fetchActiveAssignments;
/* harmony export (immutable) */ __webpack_exports__["setActiveAssignments"] = setActiveAssignments;
/* harmony export (immutable) */ __webpack_exports__["creatCatCard"] = creatCatCard;
/* harmony export (immutable) */ __webpack_exports__["fetchCatConfigs"] = fetchCatConfigs;
/* harmony export (immutable) */ __webpack_exports__["setCatConfigs"] = setCatConfigs;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterProficiencyHistory"] = fetchFilterProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["setFilterProficiencyHistory"] = setFilterProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterProficiencyRank"] = fetchFilterProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["setFilterProficiencyRank"] = setFilterProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["fetchChildProficiencyHistory"] = fetchChildProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["setChildProficiencyHistory"] = setChildProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["fetchChildProficiencyRank"] = fetchChildProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["setChildProficiencyRank"] = setChildProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["setSelectedChild"] = setSelectedChild;
/* harmony export (immutable) */ __webpack_exports__["setSelectedLectureSubjectId"] = setSelectedLectureSubjectId;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterVideoLectures"] = fetchFilterVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["setFilterVideoLectures"] = setFilterVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterCardLectures"] = fetchFilterCardLectures;
/* harmony export (immutable) */ __webpack_exports__["setFilterCardLectures"] = setFilterCardLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchSubjects"] = fetchSubjects;
/* harmony export (immutable) */ __webpack_exports__["setSubjects"] = setSubjects;
/* harmony export (immutable) */ __webpack_exports__["fetchMainRecommendVideoLectures"] = fetchMainRecommendVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["setRecommendVideoLectures"] = setRecommendVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchMainRecommendCardLectures"] = fetchMainRecommendCardLectures;
/* harmony export (immutable) */ __webpack_exports__["setRecommendCardLectures"] = setRecommendCardLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterRecommendVideoLectures"] = fetchFilterRecommendVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchFilterRecommendCardLectures"] = fetchFilterRecommendCardLectures;
/* harmony export (immutable) */ __webpack_exports__["setBusy"] = setBusy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(371);






function setSelectedSubjectId(_ref, subjectId) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_SELECTED_SUBJECT_ID */], subjectId);
}

function fetchCatSubject(_ref2) {
  var dispatch = _ref2.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/subjects?is_specialized=true').then(function (res) {
    return dispatch('setCatSubjects', res.data);
  });
}

function setCatSubjects(_ref3, catSubjects) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_CAT_SUBJECT */], catSubjects);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(catSubjects);
}

function fetchCatDomain(_ref4, subjectsCount) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/cat-domains?per_page=' + subjectsCount).then(function (res) {
    return dispatch('setCatDomains', res.data);
  });
}

function setCatDomains(_ref5, catDomains) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_CAT_DOMAIN */], catDomains);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(catDomains);
}

function fetchAssignmentsStatus(status) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/assignments?status=' + status).then(function (res) {
    return res.data;
  });
}

function fetchActiveAssignments(_ref6, status) {
  var dispatch = _ref6.dispatch;

  return fetchAssignmentsStatus(status).then(function (activeAssignments) {
    return dispatch('setActiveAssignments', activeAssignments);
  });
}

function setActiveAssignments(_ref7, activeAssigments) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_ACTIVE_ASSIGNMENT */], activeAssigments);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(activeAssigments);
}

function creatCatCard(_ref8, _ref9) {
  var dispatch = _ref8.dispatch;
  var domainId = _ref9.domainId,
      quizCount = _ref9.quizCount;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/cats/', {
    quiz_count: quizCount,
    domain_id: domainId
  }).then(function (res) {
    return res.data;
  });
}

function fetchCatConfigs(_ref10) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/cat-configs').then(function (res) {
    return dispatch('setCatConfigs', res.data);
  });
}

function setCatConfigs(_ref11, catConfigs) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_CAT_CONFIGS */], catConfigs);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(catConfigs);
}

function fetchUserProficiencyHistory(filters) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/cl-proficiency-history', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchFilterProficiencyHistory(_ref12) {
  var dispatch = _ref12.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetchUserProficiencyHistory(filters).then(function (data) {
    return dispatch('setFilterProficiencyHistory', {
      proficiencyHistory: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function setFilterProficiencyHistory(_ref13, proficiencyHistory) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_FILTER_PROFICIENCY_HISTORY */], proficiencyHistory);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proficiencyHistory);
}

function fetchUserProficiencyRank(filters) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/cl-proficiency-rank', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchFilterProficiencyRank(_ref14) {
  var dispatch = _ref14.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  fetchUserProficiencyRank(filters).then(function (data) {
    return dispatch('setFilterProficiencyRank', {
      proficiencyRank: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function setFilterProficiencyRank(_ref15, proficiencyRank) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* SET_FILTER_PROFICIENCY_RANK */], proficiencyRank);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proficiencyRank);
}

function fetchChildProficiencyHistory(_ref16, filters) {
  var dispatch = _ref16.dispatch;

  fetchUserProficiencyHistory(filters).then(function (data) {
    return dispatch('setChildProficiencyHistory', {
      proficiencyHistory: data,
      subjectId: filters.subject_id || 0,
      childId: filters.child_id
    });
  });
}

function setChildProficiencyHistory(_ref17, _ref18) {
  var commit = _ref17.commit;
  var childId = _ref18.childId,
      subjectId = _ref18.subjectId,
      proficiencyHistory = _ref18.proficiencyHistory;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_CHILD_PROFICIENCY_HISTORY */], { childId: childId, subjectId: subjectId, proficiencyHistory: proficiencyHistory });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proficiencyHistory);
}

function fetchChildProficiencyRank(_ref19, filters) {
  var dispatch = _ref19.dispatch;

  return fetchUserProficiencyRank(filters).then(function (data) {
    return dispatch('setChildProficiencyRank', {
      proficiencyRank: data,
      subjectId: filters.subject_id || 0,
      childId: filters.child_id
    });
  });
}

function setChildProficiencyRank(_ref20, _ref21) {
  var commit = _ref20.commit;
  var childId = _ref21.childId,
      subjectId = _ref21.subjectId,
      proficiencyRank = _ref21.proficiencyRank;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_CHILD_PROFICIENCY_RANK */], { childId: childId, subjectId: subjectId, proficiencyRank: proficiencyRank });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proficiencyRank);
}

function setSelectedChild(_ref22, selectedChild) {
  var commit = _ref22.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_SELECTED_CHILD */], selectedChild);
}

function setSelectedLectureSubjectId(_ref23, selectedLectureSubjectId) {
  var commit = _ref23.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_SELECTED_LECTURE_SUBJECT_ID */], selectedLectureSubjectId);
}

function fetchVideoLectures(filters) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchFilterVideoLectures(_ref24) {
  var dispatch = _ref24.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetchVideoLectures(filters).then(function (data) {
    return dispatch('setFilterVideoLectures', {
      videoLectures: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function setFilterVideoLectures(_ref25, _ref26) {
  var commit = _ref25.commit;
  var videoLectures = _ref26.videoLectures,
      subjectId = _ref26.subjectId;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* SET_VIDEO_LECTURES */], { videoLectures: videoLectures, subjectId: subjectId });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoLectures);
}

function fetchCardLectures(filters) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchFilterCardLectures(_ref27) {
  var dispatch = _ref27.dispatch;
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetchCardLectures(filters).then(function (data) {
    return dispatch('setFilterCardLectures', {
      cardLectures: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function setFilterCardLectures(_ref28, _ref29) {
  var commit = _ref28.commit;
  var cardLectures = _ref29.cardLectures,
      subjectId = _ref29.subjectId;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* SET_CARD_LECTURES */], { cardLectures: cardLectures, subjectId: subjectId });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardLectures);
}

function fetchSubjects(_ref30) {
  var dispatch = _ref30.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/subjects').then(function (res) {
    return dispatch('setSubjects', res.data);
  });
}

function setSubjects(_ref31, subjects) {
  var commit = _ref31.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* SET_SUBJECTS */], subjects);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(subjects);
}

function fetchRecommendVideoLectures(params) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/recommendations/video-lectures', { params: params }).then(function (res) {
    return res.data;
  });
}

function fetchMainRecommendVideoLectures(_ref32, filters) {
  var dispatch = _ref32.dispatch;

  return fetchRecommendVideoLectures(filters).then(function (data) {
    return dispatch('setRecommendVideoLectures', data);
  });
}

function setRecommendVideoLectures(_ref33, videoLectures) {
  var commit = _ref33.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_RECOMMEND_VIDEO_LECTURES */], videoLectures);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoLectures);
}

function fetchRecommendCardLectures(params) {
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/recommendations/card-lectures', { params: params }).then(function (res) {
    return res.data;
  });
}

function fetchMainRecommendCardLectures(_ref34, filters) {
  var dispatch = _ref34.dispatch;

  return fetchRecommendCardLectures(filters).then(function (data) {
    return dispatch('setRecommendCardLectures', data);
  });
}

function setRecommendCardLectures(_ref35, cardLectures) {
  var commit = _ref35.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_RECOMMEND_CARD_LECTURES */], cardLectures);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cardLectures);
}

function fetchFilterRecommendVideoLectures(_ref36, filters) {
  var dispatch = _ref36.dispatch;

  return fetchRecommendVideoLectures(filters).then(function (data) {
    return dispatch('setFilterVideoLectures', {
      videoLectures: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function fetchFilterRecommendCardLectures(_ref37, filters) {
  var dispatch = _ref37.dispatch;

  return fetchRecommendCardLectures(filters).then(function (data) {
    return dispatch('setFilterCardLectures', {
      cardLectures: data,
      subjectId: filters.subject_id || 0
    });
  });
}

function setBusy(_ref38, busy) {
  var commit = _ref38.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_BUSY */], busy);
}

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getCatSubjects"] = getCatSubjects;
/* harmony export (immutable) */ __webpack_exports__["getDomains"] = getDomains;
/* harmony export (immutable) */ __webpack_exports__["getCatDomains"] = getCatDomains;
/* harmony export (immutable) */ __webpack_exports__["getActiveAssignments"] = getActiveAssignments;
/* harmony export (immutable) */ __webpack_exports__["getFilterLecturesSubjects"] = getFilterLecturesSubjects;
/* harmony export (immutable) */ __webpack_exports__["getFilterSubjects"] = getFilterSubjects;
/* harmony export (immutable) */ __webpack_exports__["getSelectedSubjectId"] = getSelectedSubjectId;
/* harmony export (immutable) */ __webpack_exports__["getFilterProficiencyHistory"] = getFilterProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["getCurrentScore"] = getCurrentScore;
/* harmony export (immutable) */ __webpack_exports__["getAverageScore"] = getAverageScore;
/* harmony export (immutable) */ __webpack_exports__["getAverageScoreRate"] = getAverageScoreRate;
/* harmony export (immutable) */ __webpack_exports__["getCurrentScoreRate"] = getCurrentScoreRate;
/* harmony export (immutable) */ __webpack_exports__["getProficiencyHistory"] = getProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["getOrderProficiencyHistory"] = getOrderProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["getLastScore"] = getLastScore;
/* harmony export (immutable) */ __webpack_exports__["getChangedScore"] = getChangedScore;
/* harmony export (immutable) */ __webpack_exports__["getFilterProficiencyRank"] = getFilterProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["getProficiencyRank"] = getProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["getPreviousProficiencyRank"] = getPreviousProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["getSchoolName"] = getSchoolName;
/* harmony export (immutable) */ __webpack_exports__["getSchoolPosition"] = getSchoolPosition;
/* harmony export (immutable) */ __webpack_exports__["getSchoolTotal"] = getSchoolTotal;
/* harmony export (immutable) */ __webpack_exports__["isSchoolTotal"] = isSchoolTotal;
/* harmony export (immutable) */ __webpack_exports__["getSchoolRate"] = getSchoolRate;
/* harmony export (immutable) */ __webpack_exports__["getPreviousSchoolPosition"] = getPreviousSchoolPosition;
/* harmony export (immutable) */ __webpack_exports__["getPreviousSchoolTotal"] = getPreviousSchoolTotal;
/* harmony export (immutable) */ __webpack_exports__["getPreviousSchoolRate"] = getPreviousSchoolRate;
/* harmony export (immutable) */ __webpack_exports__["getGradePosition"] = getGradePosition;
/* harmony export (immutable) */ __webpack_exports__["getGradeTotal"] = getGradeTotal;
/* harmony export (immutable) */ __webpack_exports__["isGradeTotal"] = isGradeTotal;
/* harmony export (immutable) */ __webpack_exports__["getGradeRate"] = getGradeRate;
/* harmony export (immutable) */ __webpack_exports__["getChangedSchoolRate"] = getChangedSchoolRate;
/* harmony export (immutable) */ __webpack_exports__["getPreviousGradePosition"] = getPreviousGradePosition;
/* harmony export (immutable) */ __webpack_exports__["getPreviousGradeTotal"] = getPreviousGradeTotal;
/* harmony export (immutable) */ __webpack_exports__["getPreviousGradeRate"] = getPreviousGradeRate;
/* harmony export (immutable) */ __webpack_exports__["getChangedGradeRate"] = getChangedGradeRate;
/* harmony export (immutable) */ __webpack_exports__["getChangedScores"] = getChangedScores;
/* harmony export (immutable) */ __webpack_exports__["getGrowthSubject"] = getGrowthSubject;
/* harmony export (immutable) */ __webpack_exports__["getNotGrowthSubject"] = getNotGrowthSubject;
/* harmony export (immutable) */ __webpack_exports__["getGrowthScore"] = getGrowthScore;
/* harmony export (immutable) */ __webpack_exports__["getGrowthSubjectName"] = getGrowthSubjectName;
/* harmony export (immutable) */ __webpack_exports__["getNotGrowthScore"] = getNotGrowthScore;
/* harmony export (immutable) */ __webpack_exports__["getNotGrowthSubjectName"] = getNotGrowthSubjectName;
/* harmony export (immutable) */ __webpack_exports__["getRandomComments"] = getRandomComments;
/* harmony export (immutable) */ __webpack_exports__["getCatReturnVisitComment"] = getCatReturnVisitComment;
/* harmony export (immutable) */ __webpack_exports__["getFirstSelectedChild"] = getFirstSelectedChild;
/* harmony export (immutable) */ __webpack_exports__["getChildProficiencyHistory"] = getChildProficiencyHistory;
/* harmony export (immutable) */ __webpack_exports__["getChildProficiencyRank"] = getChildProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["getSelectedChild"] = getSelectedChild;
/* harmony export (immutable) */ __webpack_exports__["getSelectedChildGrade"] = getSelectedChildGrade;
/* harmony export (immutable) */ __webpack_exports__["isSupportedChildGrade"] = isSupportedChildGrade;
/* harmony export (immutable) */ __webpack_exports__["getSelectedChildId"] = getSelectedChildId;
/* harmony export (immutable) */ __webpack_exports__["getSelectedLectureSubjectId"] = getSelectedLectureSubjectId;
/* harmony export (immutable) */ __webpack_exports__["getLecturesType"] = getLecturesType;
/* harmony export (immutable) */ __webpack_exports__["getVideoLectures"] = getVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["getRecommendVideoLectures"] = getRecommendVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["getVideoLecturePosition"] = getVideoLecturePosition;
/* harmony export (immutable) */ __webpack_exports__["getCardLectures"] = getCardLectures;
/* harmony export (immutable) */ __webpack_exports__["getRecommendCardLectures"] = getRecommendCardLectures;
/* harmony export (immutable) */ __webpack_exports__["getSubjectMap"] = getSubjectMap;
/* harmony export (immutable) */ __webpack_exports__["getVideoLectureSubjects"] = getVideoLectureSubjects;
/* harmony export (immutable) */ __webpack_exports__["getCardLectureSubjects"] = getCardLectureSubjects;
/* harmony export (immutable) */ __webpack_exports__["getCardLecturePosition"] = getCardLecturePosition;
/* harmony export (immutable) */ __webpack_exports__["getBusy"] = getBusy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var customSubject = {
  id: 0,
  name: 'common.basic_subject',
  color_code: '#00C896'
};

function getCatSubjects(state, getters) {
  var grade = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(getters.getSelectedChild) ? getters.getSelectedChildGrade : getters.currentUserGrade;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(getters.getSubjectMap, function (item) {
    return item.grade_lower_bound <= grade && item.grade_upper_bound >= grade;
  });
}

function getDomains(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(state.catDomains, function (domain) {
    return {
      cat: domain.cat,
      domain_id: domain.id,
      domain_name: domain.name,
      proficiency_score: domain.proficiency_score,
      rank: domain.rank,
      subject_id: domain.subject_id
    };
  });
}

function getCatDomains(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(getters.getDomains, function (domain) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, domain, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(getters.getCatSubjects, function (subject) {
      return subject.id === domain.subject_id;
    }));
  });
}

function getActiveAssignments(state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(state.activeAssignments, function (assignment) {
    return !assignment.submissions[0].is_submitted;
  }) || [];
}

function getFilterLecturesSubjects(state, getters) {
  return [customSubject].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getters.getSubjectMap));
}

function getFilterSubjects(state, getters) {
  return [customSubject].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(getters.getCatSubjects));
}

function getSelectedSubjectId(state) {
  return state.selectedSubjectId || 0;
}

function getFilterProficiencyHistory(state, getters) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(getters.getSelectedChildId)) {
    return state.childProficiencyHistory[getters.getSelectedChildId] || {};
  }
  return state.filterProficiencyHistory || {};
}

function getCurrentScore(state, getters) {
  return getters.getFilterProficiencyHistory[getters.getSelectedSubjectId] && getters.getFilterProficiencyHistory[getters.getSelectedSubjectId].current_score || 0;
}

function getAverageScore(state, getters) {
  return getters.getFilterProficiencyHistory[getters.getSelectedSubjectId] && getters.getFilterProficiencyHistory[getters.getSelectedSubjectId].cl_average_score || 0;
}

function getAverageScoreRate(state, getters) {
  return Number(getters.getAverageScore / state.classtingTotalScore * 100) || 0;
}

function getCurrentScoreRate(state, getters) {
  return Number(getters.getCurrentScore / state.classtingTotalScore * 100) || 0;
}

function getProficiencyHistory(state, getters) {
  var proficiencyHistory = getters.getFilterProficiencyHistory[getters.getSelectedSubjectId] && getters.getFilterProficiencyHistory[getters.getSelectedSubjectId].history || [];

  var todayScore = {
    proficiency_score: getters.getCurrentScore,
    updated_at: new Date()
  };

  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(proficiencyHistory && proficiencyHistory.slice(0, 3)), [todayScore]);
}

function getOrderProficiencyHistory(state, getters) {
  var sortTargetName = 'updated_at';
  var limitScore = 4;
  var proficiencyHistory = getters.getProficiencyHistory;

  if (proficiencyHistory.length < limitScore) {
    var chartRange = limitScore - proficiencyHistory.length;
    var defaultScore = {
      proficiency_score: 0,
      updated_at: ''
    };

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["range"])(chartRange), function () {
      return defaultScore;
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(proficiencyHistory)), sortTargetName, ['asc']);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(proficiencyHistory, sortTargetName, ['asc']);
}

function getLastScore(state, getters) {
  var lastScoreIndex = getters.getOrderProficiencyHistory.length - 2;
  return getters.getOrderProficiencyHistory && getters.getOrderProficiencyHistory[lastScoreIndex];
}

function getChangedScore(state, getters) {
  if (getters.getLastScore && getters.getLastScore.proficiency_score > 0) {
    return getters.getCurrentScore - (getters.getLastScore && getters.getLastScore.proficiency_score);
  }
  return 0;
}

function getFilterProficiencyRank(state, getters) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(getters.getSelectedChild)) {
    return state.childProficiencyRank[getters.getSelectedChildId] || {};
  }

  return state.filterProficiencyRank || {};
}

function getProficiencyRank(state, getters) {
  if (getters.getDomainProficiencyRank) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(getters.getDomainProficiencyRank) || {};
  }

  return getters.getFilterProficiencyRank[getters.getSelectedSubjectId] && getters.getFilterProficiencyRank[getters.getSelectedSubjectId][0] || {};
}

function getPreviousProficiencyRank(state, getters) {
  if (getters.getDomainProficiencyRank) {
    return getters.getDomainProficiencyRank && getters.getDomainProficiencyRank[1] || {};
  }

  return getters.getFilterProficiencyRank[getters.getSelectedSubjectId] && getters.getFilterProficiencyRank[getters.getSelectedSubjectId][1] || {};
}

function getSchoolName(state, getters) {
  return getters.getProficiencyRank.school_name;
}

function getSchoolPosition(state, getters) {
  return getters.getProficiencyRank.school_position;
}

function getSchoolTotal(state, getters) {
  return getters.getProficiencyRank.school_total;
}

function isSchoolTotal(state, getters) {
  return getters.getSchoolTotal >= 10;
}

function getSchoolRate(state, getters) {
  return Number(getters.getSchoolPosition / getters.getSchoolTotal * 100) || 0;
}

function getPreviousSchoolPosition(state, getters) {
  return getters.getPreviousProficiencyRank.school_position || 0;
}

function getPreviousSchoolTotal(state, getters) {
  return getters.getPreviousProficiencyRank.school_total || 0;
}

function getPreviousSchoolRate(state, getters) {
  return Number(getters.getPreviousSchoolPosition / getters.getPreviousSchoolTotal * 100) || 0;
}

function getGradePosition(state, getters) {
  return getters.getProficiencyRank.grade_position || 0;
}

function getGradeTotal(state, getters) {
  return getters.getProficiencyRank.grade_total || 0;
}

function isGradeTotal(state, getters) {
  return getters.getGradeTotal >= 10;
}

function getGradeRate(state, getters) {
  return Number(getters.getGradePosition / getters.getGradeTotal * 100) || 0;
}

function getChangedSchoolRate(state, getters) {
  if (getters.getPreviousSchoolRate === 0) {
    return 0;
  }

  return Number((getters.getPreviousSchoolRate - getters.getSchoolRate) * 100 / getters.getPreviousSchoolRate) || 0;
}

function getPreviousGradePosition(state, getters) {
  return getters.getPreviousProficiencyRank.grade_position;
}

function getPreviousGradeTotal(state, getters) {
  return getters.getPreviousProficiencyRank.grade_total;
}

function getPreviousGradeRate(state, getters) {
  return Number(getters.getPreviousGradePosition / getters.getPreviousGradeTotal * 100) || 0;
}

function getChangedGradeRate(state, getters) {
  if (getters.getPreviousGradeRate === 0) {
    return 0;
  }

  return Number((getters.getPreviousGradeRate - getters.getGradeRate) * 100 / getters.getPreviousGradeRate) || 0;
}

function getChangedScores(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(getters.getFilterProficiencyHistory, function (item, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(item.current_score)) {
      return {
        subject_id: Number(index),
        changed_score: 0
      };
    }
    if (Number(index) !== 0) {
      var historyScore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["orderBy"])(item.history, ['desc'], 'updated_at')) || {};
      return {
        subject_id: Number(index),
        subject_name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(getters.getCatSubjects, function (i) {
          return i.id === Number(index);
        }).name,
        changed_score: item.current_score - historyScore.proficiency_score
      };
    }
    return false;
  });
}

function getGrowthSubject(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["maxBy"])(getters.getChangedScores, 'changed_score');
}

function getNotGrowthSubject(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["minBy"])(getters.getChangedScores, 'changed_score');
}

function getGrowthScore(state, getters) {
  return getters.getGrowthSubject && getters.getGrowthSubject.changed_score;
}

function getGrowthSubjectName(state, getters) {
  return getters.getGrowthSubject && getters.getGrowthSubject.subject_name;
}

function getNotGrowthScore(state, getters) {
  return getters.getNotGrowthSubject && getters.getNotGrowthSubject.changed_score;
}

function getNotGrowthSubjectName(state, getters) {
  return getters.getNotGrowthSubject && getters.getNotGrowthSubject.subject_name;
}

function getRandomComments(state) {
  return state.catDescription.isNotAssignment;
}

function getCatReturnVisitComment(state) {
  return state.returnVisit;
}

function getFirstSelectedChild(state, getters) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["head"])(getters.userChildrenList);
}

function getChildProficiencyHistory(state) {
  return state.childProficiencyHistory || {};
}

function getChildProficiencyRank(state) {
  return state.childProficiencyRank || {};
}

function getSelectedChild(state) {
  return state.selectedChild || {};
}

function getSelectedChildGrade(state, getters) {
  var tGrade = getters.getSelectedChild.t_grade;

  if (tGrade && tGrade > 6 && tGrade < 19) {
    return tGrade - 6;
  }

  return 0;
}

function isSupportedChildGrade(state, getters) {
  return getters.getSelectedChildGrade > 2;
}

function getSelectedChildId(state, getters) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(getters.getRouteQuery.child_id)) {
    return getters.getRouteQuery.child_id;
  }

  return getters.getSelectedChild.id;
}

function getSelectedLectureSubjectId(state) {
  return state.selectedLectureSubjectId || 0;
}

function getLecturesType(state) {
  return state.lecturesType;
}

function getVideoLectures(state, getters) {
  return state.filterVideoLectures[getters.getSelectedLectureSubjectId];
}

function getRecommendVideoLectures(state) {
  return state.recommendVideoLectures;
}

function getVideoLecturePosition(state, getters) {
  return state.filterVideoLecturesPosition[getters.getSelectedLectureSubjectId];
}

function getCardLectures(state, getters) {
  return state.filterCardLectures[getters.getSelectedLectureSubjectId];
}

function getRecommendCardLectures(state) {
  return state.recommendCardLectures;
}

function getSubjectMap(state) {
  return state.subjectMap;
}

function getVideoLectureSubjects(state, getters) {
  return [customSubject].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(getters.getSubjectMap, ['grade_lower_bound'], ['grade_upper_bound']), function (item) {
    return (item.grade_lower_bound <= getters.currentUserGrade && item.grade_upper_bound >= getters.currentUserGrade || item.grade_upper_bound === null) && item.has_video_lectures;
  })));
}

function getCardLectureSubjects(state, getters) {
  return [customSubject].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(getters.getSubjectMap, ['grade_lower_bound'], ['grade_upper_bound']), function (item) {
    return (item.grade_lower_bound <= getters.currentUserGrade && item.grade_upper_bound >= getters.currentUserGrade || item.grade_upper_bound === null) && item.has_card_lectures;
  })));
}

function getCardLecturePosition(state, getters) {
  return state.filterCardLecturesPosition[getters.getSelectedLectureSubjectId];
}

function getBusy(state) {
  return state.busy;
}

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(852);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(371);


var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_CAT_SUBJECT */], function (state, catSubjects) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(catSubjects, function (item) {
    return {
      subject_id: item.id,
      subject_name: item.name,
      icon_url: item.icon_url,
      color_code: item.color_code
    };
  });

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'catSubjects', result);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_CAT_DOMAIN */], function (state, catDomains) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'catDomains', catDomains);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_ACTIVE_ASSIGNMENT */], function (state, activeAssignments) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'activeAssignments', activeAssignments);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_CAT_CONFIGS */], function (state, catConfigs) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'catConfigs', catConfigs);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_PROFICIENCY_HISTORY */], function (state, proficiencyHistory) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'proficiencyHistory', proficiencyHistory);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SET_FILTER_PROFICIENCY_HISTORY */], function (state, _ref) {
  var subjectId = _ref.subjectId,
      proficiencyHistory = _ref.proficiencyHistory;

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterProficiencyHistory, subjectId, proficiencyHistory);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* SET_FILTER_PROFICIENCY_RANK */], function (state, _ref2) {
  var subjectId = _ref2.subjectId,
      proficiencyRank = _ref2.proficiencyRank;

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterProficiencyRank, subjectId, proficiencyRank);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_BUSY */], function (state, busy) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'busy', busy);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_SELECTED_SUBJECT_ID */], function (state, subjectId) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'selectedSubjectId', subjectId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_CHILD_PROFICIENCY_HISTORY */], function (state, _ref3) {
  var childId = _ref3.childId,
      subjectId = _ref3.subjectId,
      proficiencyHistory = _ref3.proficiencyHistory;

  if (!state.childProficiencyHistory[childId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.childProficiencyHistory, childId, {});
  }

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.childProficiencyHistory[childId], subjectId, proficiencyHistory);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_CHILD_PROFICIENCY_RANK */], function (state, _ref4) {
  var childId = _ref4.childId,
      subjectId = _ref4.subjectId,
      proficiencyRank = _ref4.proficiencyRank;

  if (!state.childProficiencyRank[childId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.childProficiencyRank, childId, {});
  }

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.childProficiencyRank[childId], subjectId, proficiencyRank);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_SELECTED_CHILD */], function (state, selectedChild) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'selectedChild', selectedChild);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_SELECTED_LECTURE_SUBJECT_ID */], function (state, selectedLectureSubjectId) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'selectedLectureSubjectId', selectedLectureSubjectId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* SET_VIDEO_LECTURES */], function (state, _ref5) {
  var videoLectures = _ref5.videoLectures,
      subjectId = _ref5.subjectId;

  if (!state.filterVideoLectures[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterVideoLectures, subjectId, []);
  }

  if (!state.filterVideoLecturesPosition[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterVideoLecturesPosition, subjectId, 1);
  }

  var videoPosition = Number(state.filterVideoLecturesPosition[subjectId] + 1);
  var videoLecturesConcat = state.filterVideoLectures[subjectId].concat(videoLectures);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterVideoLecturesPosition, subjectId, videoPosition);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterVideoLectures, subjectId, videoLecturesConcat);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* SET_CARD_LECTURES */], function (state, _ref6) {
  var cardLectures = _ref6.cardLectures,
      subjectId = _ref6.subjectId;

  if (!state.filterCardLectures[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterCardLectures, subjectId, []);
  }

  if (!state.filterCardLecturesPosition[subjectId]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterCardLecturesPosition, subjectId, 1);
  }

  var cardPosition = Number(state.filterCardLecturesPosition[subjectId] + 1);
  var cardLecturesConcat = state.filterCardLectures[subjectId].concat(cardLectures);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterCardLecturesPosition, subjectId, cardPosition);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterCardLectures, subjectId, cardLecturesConcat);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* SET_SUBJECTS */], function (state, subjects) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'subjectMap', subjects);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* SET_RECOMMEND_VIDEO_LECTURES */], function (state, videoLectures) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'recommendVideoLectures', videoLectures);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* SET_RECOMMEND_CARD_LECTURES */], function (state, cardLectures) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'recommendCardLectures', cardLectures);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_BUSY */], function (state, busy) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'busy', busy);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  catSubjects: [],
  catDomains: [],
  activeAssignments: [],
  filterProficiencyHistory: {},
  filterProficiencyRank: {},
  classtingTotalScore: 1300,
  catDescription: {
    isNotAssignment: ['common.sam_comment_1', 'common.sam_comment_2', 'common.sam_comment_3', 'common.sam_comment_4', 'common.sam_comment_5'],
    returnVisit: 'common.sam_return_visit_comment',
    isParent: 'common.sam_parent_comment'
  },
  childProficiencyHistory: {},
  childProficiencyRank: {},
  selectedLectureSubjectId: 0,
  filterVideoLectures: {},
  filterVideoLecturesPosition: {},
  filterCardLectures: {},
  filterCardLecturesPosition: {},
  lecturesType: [{
    id: 1,
    name: 'common.video_lecture'
  }, {
    id: 2,
    name: 'common.card_lecture'
  }],
  subjectMap: [],
  busy: false,
  countries: [],
  userCountry: {}
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatProficiency__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_CatProficiency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_CatProficiency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CatLearningElement__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CatLearningElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_CatLearningElement__);



var router = [{
  name: 'cat-proficiency',
  path: '/proficiency',
  component: __WEBPACK_IMPORTED_MODULE_0__views_CatProficiency___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}, {
  name: 'cat-learning-element',
  path: '/element/:domainId(\\d+)',
  component: __WEBPACK_IMPORTED_MODULE_1__views_CatLearningElement___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchDomain"] = fetchDomain;
/* harmony export (immutable) */ __webpack_exports__["setDomain"] = setDomain;
/* harmony export (immutable) */ __webpack_exports__["fetchLearningElement"] = fetchLearningElement;
/* harmony export (immutable) */ __webpack_exports__["setLearningElement"] = setLearningElement;
/* harmony export (immutable) */ __webpack_exports__["resetLearningElement"] = resetLearningElement;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainProficiencyRank"] = fetchDomainProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["setDomainProficiencyRank"] = setDomainProficiencyRank;
/* harmony export (immutable) */ __webpack_exports__["resetDomainProficiencyRank"] = resetDomainProficiencyRank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(373);






function fetchDomain(_ref, domainId) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/domains/' + domainId).then(function (res) {
    return dispatch('setDomain', res.data);
  });
}

function setDomain(_ref2, domain) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_DOMAIN */], domain);
}

function fetchLearningElement(_ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var domainId = _ref4.domainId,
      filters = _ref4.filters;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/cat-domains/' + domainId + '/learning-elements', { params: filters }).then(function (res) {
    return dispatch('setLearningElement', res.data);
  });
}

function setLearningElement(_ref5, learningElement) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* SET_LEARNING_ELEMENT */], learningElement);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(learningElement);
}

function resetLearningElement(_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* RESET_LEARNING_ELEMENT */]);
}

function fetchDomainProficiencyRank(_ref7, filters) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/cl-proficiency-rank', { params: filters }).then(function (res) {
    return dispatch('setDomainProficiencyRank', res.data);
  });
}

function setDomainProficiencyRank(_ref8, domainProficiencyRank) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* SET_DOMAIN_PROFICIENCY_RANK */], domainProficiencyRank);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(domainProficiencyRank);
}

function resetDomainProficiencyRank(_ref9) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* RESET_DOMAIN_PROFICIENCY_RANK */]);
}

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getRegionName"] = getRegionName;
/* harmony export (immutable) */ __webpack_exports__["getDistrictTotal"] = getDistrictTotal;
/* harmony export (immutable) */ __webpack_exports__["isDistrictTotal"] = isDistrictTotal;
/* harmony export (immutable) */ __webpack_exports__["getDistrictPosition"] = getDistrictPosition;
/* harmony export (immutable) */ __webpack_exports__["getDistrictRate"] = getDistrictRate;
/* harmony export (immutable) */ __webpack_exports__["getPrevDistrictPosition"] = getPrevDistrictPosition;
/* harmony export (immutable) */ __webpack_exports__["getPrevDistrictTotal"] = getPrevDistrictTotal;
/* harmony export (immutable) */ __webpack_exports__["getPrevDistrictRate"] = getPrevDistrictRate;
/* harmony export (immutable) */ __webpack_exports__["getChangedDistrictRate"] = getChangedDistrictRate;
/* harmony export (immutable) */ __webpack_exports__["getHistoryScoresData"] = getHistoryScoresData;
/* harmony export (immutable) */ __webpack_exports__["getHistoryScoresDates"] = getHistoryScoresDates;
/* harmony export (immutable) */ __webpack_exports__["getHistoryScoreDateLabels"] = getHistoryScoreDateLabels;
/* harmony export (immutable) */ __webpack_exports__["getDomain"] = getDomain;
/* harmony export (immutable) */ __webpack_exports__["getLearningElement"] = getLearningElement;
/* harmony export (immutable) */ __webpack_exports__["getDomainProficiencyRank"] = getDomainProficiencyRank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function getRegionName(state, getters) {
  return getters.getProficiencyRank.region;
}

function getDistrictTotal(state, getters) {
  return getters.getProficiencyRank.district_total;
}

function isDistrictTotal(state, getters) {
  return getters.getProficiencyRank.district_total >= 10;
}

function getDistrictPosition(state, getters) {
  return getters.getProficiencyRank.district_position;
}

function getDistrictRate(state, getters) {
  return Number(getters.getDistrictPosition / getters.getDistrictTotal * 100) || 0;
}

function getPrevDistrictPosition(state, getters) {
  return getters.getPreviousProficiencyRank.district_position || 0;
}

function getPrevDistrictTotal(state, getters) {
  return getters.getPreviousProficiencyRank.district_total || 0;
}

function getPrevDistrictRate(state, getters) {
  return Number(getters.getPrevDistrictPosition / getters.getPrevDistrictTotal * 100) || 0;
}

function getChangedDistrictRate(state, getters) {
  if (getters.getPrevDistrictRate === 0) {
    return 0;
  }

  return Number((getters.getPrevDistrictRate - getters.getDistrictRate) * 100 / getters.getPrevDistrictRate) || 0;
}

function getHistoryScoresData(state, getters) {
  return getters.getOrderProficiencyHistory.map(function (item) {
    return item.proficiency_score || 0;
  });
}

function getHistoryScoresDates(state, getters) {
  return getters.getOrderProficiencyHistory.map(function (item) {
    return item.updated_at || '';
  });
}

function getHistoryScoreDateLabels(state, getters) {
  return getters.getHistoryScoresDates.map(function (item) {
    if (item === '') {
      return item;
    }

    var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isDate"])(item) ? item : new Date(item.slice(0, 10));
    return date.getMonth() + 1 + '.' + date.getDate();
  });
}

function getDomain(state) {
  return state.domain || {};
}

function getLearningElement(state) {
  return state.learningElement;
}

function getDomainProficiencyRank(state) {
  return state.domainProficiencyRank;
}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(858);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(373);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LEARNING_ELEMENT */], function (state, learningElement) {
  if (!state.learningElement) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'learningElement', []);
  }

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'learningElement', state.learningElement.concat(learningElement));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_LEARNING_ELEMENT */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'learningElement', null);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_DOMAIN */], function (state, domain) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'domain', domain);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_DOMAIN_PROFICIENCY_RANK */], function (state, domainProficiencyRank) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'domainProficiencyRank', domainProficiencyRank);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* RESET_DOMAIN_PROFICIENCY_RANK */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'domainProficiencyRank', null);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  gradeMap: {
    0: '학년 전체',
    1: '초 1',
    2: '초 2',
    3: '초 3',
    4: '초 4',
    5: '초 5',
    6: '초 6',
    7: '중 1',
    8: '중 2',
    9: '중 3',
    10: '고 1',
    11: '고 2',
    12: '고 3',
    9999: '선택',
    null: '기타'
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_VideoCourseView__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_VideoCourseView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_VideoCourseView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CardCourseView__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_CardCourseView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_CardCourseView__);
// import SubscriptionCourse from '../views/SubscriptionCourse';



var router = [
// {
//   name: 'subscription-course',
//   path: '/subscription',
//   component: SubscriptionCourse,
//   meta: {
//     requiresAuth: true,
//   },
// },
{
  name: 'video-course-view',
  path: '/course/video/:courseId',
  component: __WEBPACK_IMPORTED_MODULE_0__views_VideoCourseView___default.a,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'card-course-view',
  path: '/course/card/:courseId',
  component: __WEBPACK_IMPORTED_MODULE_1__views_CardCourseView___default.a,
  meta: {
    requiresAuth: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchSubscriptionsVideoCourses"] = fetchSubscriptionsVideoCourses;
/* harmony export (immutable) */ __webpack_exports__["setSubscriptionsCourses"] = setSubscriptionsCourses;
/* harmony export (immutable) */ __webpack_exports__["resetSubscriptionsCourses"] = resetSubscriptionsCourses;
/* harmony export (immutable) */ __webpack_exports__["resetSubscriptionsCoursesPosition"] = resetSubscriptionsCoursesPosition;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCourseIsSubscribed"] = fetchVideoCourseIsSubscribed;
/* harmony export (immutable) */ __webpack_exports__["fetchCardCourseIsSubscribed"] = fetchCardCourseIsSubscribed;
/* harmony export (immutable) */ __webpack_exports__["fetchSubscriptionsCardCourses"] = fetchSubscriptionsCardCourses;
/* harmony export (immutable) */ __webpack_exports__["fetchCardCourse"] = fetchCardCourse;
/* harmony export (immutable) */ __webpack_exports__["setCardCourse"] = setCardCourse;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCourse"] = fetchVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["setVideoCourse"] = setVideoCourse;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoCoursesLectures"] = fetchVideoCoursesLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchCardCoursesLectures"] = fetchCardCoursesLectures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(375);






function fetchSubscriptionsVideoCourses(_ref, lectureType) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/subscriptions/video-courses').then(function (res) {
    return dispatch('setSubscriptionsCourses', {
      subscriptionsCourses: res.data,
      lectureType: lectureType
    });
  });
}

function setSubscriptionsCourses(_ref2, _ref3) {
  var commit = _ref2.commit;
  var subscriptionsCourses = _ref3.subscriptionsCourses,
      lectureType = _ref3.lectureType;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_SUBSCRIPTIONS_COURSES */], { subscriptionsCourses: subscriptionsCourses, lectureType: lectureType });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(subscriptionsCourses);
}

function resetSubscriptionsCourses(_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* RESET_SUBSCRIPTIONS_COURSES */]);
}

function resetSubscriptionsCoursesPosition(_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* RESET_SUBSCRIPTIONS_COURSES_POSITION */]);
}

function fetchVideoCourseIsSubscribed(_ref6, _ref7) {
  var dispatch = _ref6.dispatch;
  var courseId = _ref7.courseId,
      userId = _ref7.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-courses/' + courseId + '/subscribed-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchCardCourseIsSubscribed(_ref8, _ref9) {
  var dispatch = _ref8.dispatch;
  var courseId = _ref9.courseId,
      userId = _ref9.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-courses/' + courseId + '/subscribed-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function fetchSubscriptionsCardCourses(_ref10, lectureType) {
  var dispatch = _ref10.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/users/me/subscriptions/card-courses').then(function (res) {
    return dispatch('setSubscriptionsCourses', {
      subscriptionsCourses: res.data,
      lectureType: lectureType
    });
  });
}

function fetchCardCourse(_ref11, courseId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-courses/' + courseId).then(function (res) {
    return res.data;
  });
}

function setCardCourse(_ref12, videoCourse) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["SET_CARD_COURSE"], videoCourse);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoCourse);
}

function fetchVideoCourse(_ref13, courseId) {
  var dispatch = _ref13.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-courses/' + courseId).then(function (res) {
    return res.data;
  });
}

function setVideoCourse(_ref14, videoCourse) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["SET_VIDEO_COURSE"], videoCourse);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(videoCourse);
}

function fetchVideoCoursesLectures(_ref15, filters) {
  var dispatch = _ref15.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchCardCoursesLectures(_ref16, filters) {
  var dispatch = _ref16.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFilterSubscriptions"] = getFilterSubscriptions;
/* harmony export (immutable) */ __webpack_exports__["getFilterSubscriptionsPosition"] = getFilterSubscriptionsPosition;
function getFilterSubscriptions(state) {
  return state.filterSubscriptions;
}

function getFilterSubscriptionsPosition(state) {
  return state.filterSubscriptionsPosition;
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(864);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(375);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* RESET_SUBSCRIPTIONS_COURSES */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterSubscriptions', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_SUBSCRIPTIONS_COURSES_POSITION */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterSubscriptionsPosition', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_SUBSCRIPTIONS_COURSES */], function (state, _ref) {
  var lectureType = _ref.lectureType,
      subscriptionsCourses = _ref.subscriptionsCourses;

  if (!state.filterSubscriptions[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterSubscriptions, lectureType, []);
  }

  if (!state.filterSubscriptionsPosition[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterSubscriptionsPosition, lectureType, 1);
  }

  var coursesPosition = Number(state.filterSubscriptionsPosition[lectureType] + 1);
  var coursesConcat = state.filterSubscriptions[lectureType].concat(subscriptionsCourses);

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterSubscriptionsPosition, lectureType, coursesPosition);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterSubscriptions, lectureType, coursesConcat);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  filterSubscriptions: {},
  filterSubscriptionsPosition: {}
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_DomainLectureView__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_DomainLectureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_DomainLectureView__);


var router = [{
  name: 'domain-lecture-view',
  path: '/domain/lecture',
  component: __WEBPACK_IMPORTED_MODULE_0__views_DomainLectureView___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["resetDomainLectures"] = resetDomainLectures;
/* harmony export (immutable) */ __webpack_exports__["resetDomainLecturesPosition"] = resetDomainLecturesPosition;
/* harmony export (immutable) */ __webpack_exports__["setDomainLectures"] = setDomainLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainVideoLectures"] = fetchDomainVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchDomainCardLectures"] = fetchDomainCardLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchLectureLearningElement"] = fetchLectureLearningElement;
/* harmony export (immutable) */ __webpack_exports__["setLearningLearningElement"] = setLearningLearningElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(377);






function resetDomainLectures(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* RESET_DOMAIN_LECTURES */]);
}

function resetDomainLecturesPosition(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* RESET_DOMAIN_LECTURES_POSITION */]);
}

function setDomainLectures(_ref3, _ref4) {
  var commit = _ref3.commit;
  var domainLectures = _ref4.domainLectures,
      lectureType = _ref4.lectureType;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_DOMAIN_LECTURES */], { domainLectures: domainLectures, lectureType: lectureType });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(domainLectures);
}

function fetchDomainVideoLectures(_ref5, filters) {
  var dispatch = _ref5.dispatch;

  var videoLectureType = 1;
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/', { params: filters }).then(function (res) {
    return dispatch('setDomainLectures', {
      domainLectures: res.data,
      lectureType: videoLectureType
    });
  });
}

function fetchDomainCardLectures(_ref6, filters) {
  var dispatch = _ref6.dispatch;

  var cardLectureType = 2;
  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/card-lectures/', { params: filters }).then(function (res) {
    return dispatch('setDomainLectures', {
      domainLectures: res.data,
      lectureType: cardLectureType
    });
  });
}

function fetchLectureLearningElement(_ref7, elementId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/learning-elements/' + elementId).then(function (res) {
    return dispatch('setLearningLearningElement', res.data);
  });
}

function setLearningLearningElement(_ref8, learningElement) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* SET_LEARNING_ELEMENT */], { learningElement: learningElement });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(learningElement);
}

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFilterDomainLectures"] = getFilterDomainLectures;
/* harmony export (immutable) */ __webpack_exports__["getFilterDomainLecturesPosition"] = getFilterDomainLecturesPosition;
/* harmony export (immutable) */ __webpack_exports__["getLearningElements"] = getLearningElements;
function getFilterDomainLectures(state) {
  return state.filterDomainLectures;
}

function getFilterDomainLecturesPosition(state) {
  return state.filterDomainLecturesPosition;
}

function getLearningElements(state) {
  return state.learningElement;
}

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(870);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(377);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* RESET_DOMAIN_LECTURES */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterDomainLectures', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_DOMAIN_LECTURES_POSITION */], function (state) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'filterDomainLecturesPosition', {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_DOMAIN_LECTURES */], function (state, _ref) {
  var domainLectures = _ref.domainLectures,
      lectureType = _ref.lectureType;

  if (!state.filterDomainLectures[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterDomainLectures, lectureType, []);
  }

  if (!state.filterDomainLecturesPosition[lectureType]) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterDomainLecturesPosition, lectureType, 1);
  }

  var lecturesPosition = Number(state.filterDomainLecturesPosition[lectureType] + 1);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterDomainLecturesPosition, lectureType, lecturesPosition);

  var lecturesConcat = state.filterDomainLectures[lectureType].concat(domainLectures);
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.filterDomainLectures, lectureType, lecturesConcat);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["SET_DOMAIN"], function (state, domain) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'domain', domain);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_LEARNING_ELEMENT */], function (state, _ref2) {
  var learningElement = _ref2.learningElement;

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'learningElement', learningElement);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  filterDomainLectures: {},
  filterDomainLecturesPosition: {},
  learningElement: {}
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(875);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_NotFound__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Unauthorized__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Unauthorized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Unauthorized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_NotSupportCountry__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_NotSupportCountry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_NotSupportCountry__);




var router = [{
  name: 'errors.notFound',
  path: '/404',
  component: __WEBPACK_IMPORTED_MODULE_0__views_NotFound___default.a,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'errors.unAuthorized',
  path: '/401',
  component: __WEBPACK_IMPORTED_MODULE_1__views_Unauthorized___default.a,
  meta: {
    requiresAuth: true
  }
}, {
  name: 'errors.notSupportCountry',
  path: '/not_support_country',
  component: __WEBPACK_IMPORTED_MODULE_2__views_NotSupportCountry___default.a,
  meta: {
    requiresAuth: true
  }
}, {
  path: '*',
  redirect: '404'
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cat_main__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cat_assignment__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cat_domain__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cat_proficiency__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__video_lecture__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_lecture__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__course__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bookmark__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__domain_lecture__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_licence__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__errors__ = __webpack_require__(874);














/* harmony default export */ __webpack_exports__["a"] = ([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__cat_main__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__cat_assignment__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__cat_domain__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__cat_proficiency__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__video_lecture__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__card_lecture__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__course__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__bookmark__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__domain_lecture__["a" /* router */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__errors__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__user_licence__["a" /* router */])));

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tutorials__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cat_main__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cat_assignment__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cat_domain__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cat_proficiency__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__video_lecture__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__card_lecture__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bookmark__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__course__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__domain_lecture__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__user_licence__ = __webpack_require__(378);



















var store = {
  Tutorials: __WEBPACK_IMPORTED_MODULE_6__tutorials__["a" /* default */],
  Auth: __WEBPACK_IMPORTED_MODULE_5__auth__["b" /* store */],
  CatMain: __WEBPACK_IMPORTED_MODULE_7__cat_main__["b" /* store */],
  CatAssignment: __WEBPACK_IMPORTED_MODULE_8__cat_assignment__["b" /* store */],
  CatDomain: __WEBPACK_IMPORTED_MODULE_9__cat_domain__["b" /* store */],
  CatProficiency: __WEBPACK_IMPORTED_MODULE_10__cat_proficiency__["b" /* store */],
  VideoLecture: __WEBPACK_IMPORTED_MODULE_11__video_lecture__["b" /* store */],
  CardLecture: __WEBPACK_IMPORTED_MODULE_12__card_lecture__["b" /* store */],
  Bookmark: __WEBPACK_IMPORTED_MODULE_13__bookmark__["b" /* store */],
  Course: __WEBPACK_IMPORTED_MODULE_14__course__["b" /* store */],
  DomainLecture: __WEBPACK_IMPORTED_MODULE_15__domain_lecture__["b" /* store */],
  UserLicence: __WEBPACK_IMPORTED_MODULE_16__user_licence__["b" /* store */]
};
var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(store);

var modules = keys.reduce(function (acc, key) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, store[key].module));
}, {});
var plugins = keys.reduce(function (acc, key) {
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [store[key].plugin]);
}, []).filter(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"]);

/* harmony default export */ __webpack_exports__["a"] = ({ modules: modules, plugins: plugins });

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(881);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["checkUserTutorial"] = checkUserTutorial;
/* harmony export (immutable) */ __webpack_exports__["setCheckedTutorials"] = setCheckedTutorials;
/* harmony export (immutable) */ __webpack_exports__["setTutorialAsChecked"] = setTutorialAsChecked;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(233);







function checkUserTutorial(_ref) {
  var dispatch = _ref.dispatch,
      state = _ref.state,
      getters = _ref.getters;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(state.checkedTutorials)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.checkedTutorials);
  }

  var userCheckedTutorial = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config__["m" /* USER_TUTORIAL_KEY */] + '/' + getters.currentUserId);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(userCheckedTutorial)) {
    return dispatch('setCheckedTutorials', {
      learningIntro: false
    });
  }

  return dispatch('setCheckedTutorials', JSON.parse(userCheckedTutorial));
}

function setCheckedTutorials(_ref2, checkedTutorials) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS, checkedTutorials);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

function setTutorialAsChecked(_ref3, tutorial) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* default */].CHECK_TUTORIAL, tutorial);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
}

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["checkedTutorials"] = checkedTutorials;
/* eslint-disable import/prefer-default-export */
function checkedTutorials(state) {
  return state.checkedTutorials;
}

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(880);







var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module, plugin: __WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* default */] });

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(233);


var _mutations;




var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].CHECK_TUTORIAL, function (state, tutorial) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.checkedTutorials, tutorial, true);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS, function (state, checkedTutorials) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'checkedTutorials', checkedTutorials);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(233);






function subscribe(store) {
  store.subscribe(function (mutation, _ref) {
    var Tutorials = _ref.Tutorials,
        Auth = _ref.Auth;

    switch (mutation.type) {
      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].SET_CHECKED_TUTORIALS:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["m" /* USER_TUTORIAL_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(cookieKey, Tutorials.checkedTutorials, { expires: 999 });
          }

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* default */].CHECK_TUTORIAL:
        {
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(Auth.user)) {
            var _cookieKey = __WEBPACK_IMPORTED_MODULE_2__config__["m" /* USER_TUTORIAL_KEY */] + '/' + Auth.user.id;
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(_cookieKey, Tutorials.checkedTutorials, { expires: 999 });
          }

          break;
        }

      default:
        {
          break;
        }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  subscribe(store);
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  checkedTutorials: null
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_UserLicence__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_UserLicence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_UserLicence__);


var router = [{
  name: 'user-licence',
  path: '/user/licence',
  component: __WEBPACK_IMPORTED_MODULE_0__views_UserLicence___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["updatePromoCode"] = updatePromoCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__(52);



/* eslint-disable import/prefer-default-export */
function updatePromoCode(_ref, params) {
  var dispatch = _ref.dispatch;

  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].put(__WEBPACK_IMPORTED_MODULE_0__config__["g" /* MINERVA_API_URL */] + '/promo-codes', params).then(function (res) {
    return dispatch('setUserLicence', res.data);
  });
}
/* eslint-enable */

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(886);


var module = {
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_RecommendVideoLecture__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_RecommendVideoLecture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_RecommendVideoLecture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_VideoLectureView__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_VideoLectureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_VideoLectureView__);



var router = [{
  name: 'recommend-video-lecture',
  path: '/recommend/videos',
  component: __WEBPACK_IMPORTED_MODULE_0__views_RecommendVideoLecture___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}, {
  name: 'video-lecture-view',
  path: '/video/:videoId(\\d+)',
  component: __WEBPACK_IMPORTED_MODULE_1__views_VideoLectureView___default.a,
  meta: {
    requiresAuth: true,
    requiresRole: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createVideoLectureViews"] = createVideoLectureViews;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoLecture"] = fetchVideoLecture;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoLectures"] = fetchVideoLectures;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoLectureIsLiked"] = fetchVideoLectureIsLiked;
/* harmony export (immutable) */ __webpack_exports__["createVideoLectureLike"] = createVideoLectureLike;
/* harmony export (immutable) */ __webpack_exports__["removeVideoLectureLike"] = removeVideoLectureLike;
/* harmony export (immutable) */ __webpack_exports__["fetchVideoLectureIsBookmarked"] = fetchVideoLectureIsBookmarked;
/* harmony export (immutable) */ __webpack_exports__["createVideoLectureBookmark"] = createVideoLectureBookmark;
/* harmony export (immutable) */ __webpack_exports__["removeVideoLectureBookmark"] = removeVideoLectureBookmark;
/* harmony export (immutable) */ __webpack_exports__["fetchSimilarVideoLectures"] = fetchSimilarVideoLectures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_http__ = __webpack_require__(52);




function createVideoLectureViews(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var lectureId = _ref2.lectureId,
      params = _ref2.params;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/views', params);
}

function fetchVideoLecture(_ref3, lectureId) {
  var dispatch = _ref3.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId).then(function (res) {
    return res.data;
  });
}

function fetchVideoLectures(_ref4, filters) {
  var dispatch = _ref4.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

function fetchVideoLectureIsLiked(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var lectureId = _ref6.lectureId,
      userId = _ref6.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/liked-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createVideoLectureLike(_ref7, lectureId) {
  var dispatch = _ref7.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/likes').then(function () {
    return true;
  });
}

function removeVideoLectureLike(_ref8, lectureId) {
  var dispatch = _ref8.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/likes').then(function () {
    return false;
  });
}

function fetchVideoLectureIsBookmarked(_ref9, _ref10) {
  var dispatch = _ref9.dispatch;
  var lectureId = _ref10.lectureId,
      userId = _ref10.userId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/bookmarked-users/' + userId).then(function () {
    return true;
  }).catch(function (err) {
    if (err.response.status === 404) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

function createVideoLectureBookmark(_ref11, lectureId) {
  var dispatch = _ref11.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/bookmarks').then(function () {
    return true;
  });
}

function removeVideoLectureBookmark(_ref12, lectureId) {
  var dispatch = _ref12.dispatch;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].delete(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/bookmarks').then(function () {
    return false;
  });
}

function fetchSimilarVideoLectures(_ref13, _ref14) {
  var dispatch = _ref13.dispatch;
  var filters = _ref14.filters,
      lectureId = _ref14.lectureId;

  return __WEBPACK_IMPORTED_MODULE_2__plugins_http__["b" /* http */].get(__WEBPACK_IMPORTED_MODULE_1__config__["g" /* MINERVA_API_URL */] + '/video-lectures/' + lectureId + '/similar-lectures', { params: filters }).then(function (res) {
    return res.data;
  });
}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getCurrentDate"] = getCurrentDate;
/* harmony export (immutable) */ __webpack_exports__["getMonitoringHistories"] = getMonitoringHistories;
function getCurrentDate(state) {
  return state.currentDate;
}

function getMonitoringHistories(state) {
  return state.monitoringHistories;
}

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(890);






var module = {
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */]),
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = ({ module: module });

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_MONITORING_HISTORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_MONITORING_HISTORY; });
var FETCH_MONITORING_HISTORIES = 'video-lecture/FETCH_MONITORING_HISTORIES';
var UPDATE_MONITORING_HISTORY = 'video-lecture/UPDATE_MONITORING_HISTORY';

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(892);


var _mutations;





var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_MONITORING_HISTORIES */], function (state, histories) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'monitoringHistories', histories);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* UPDATE_MONITORING_HISTORY */], function (state, histories) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state, 'updatedMonitoringHistories', histories);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);


/* harmony default export */ __webpack_exports__["a"] = ({
  currentDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(new Date()).tz('Asia/Seoul').format('YYYYMMDD'),
  monitoringHistories: [],
  updatedMonitoringHistories: {}
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    componentHandler.upgradeElements(el);
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_lite__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_design_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_design_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AppRoot__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AppRoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AppRoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_mobile__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__i18n__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__(351);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



























__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* DropdownPlugin */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["b" /* ModalPlugin */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["c" /* CarouselPlugin */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugins_http__["a" /* default */], { store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */], router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__plugins_mobile__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
  id: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* GA_ID */],
  router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */],
  autoTracking: {
    pageviewOnLoad: false
  },
  ignoreRoutes: ['auth']
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__directives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__components__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_19__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_20__i18n__["a" /* default */],
  el: '#app',
  template: '<AppRoot/>',
  components: { AppRoot: __WEBPACK_IMPORTED_MODULE_14__AppRoot___default.a }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);




function getDevice() {
  var userAgent = window.navigator.userAgent;

  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return 'ios.event';
  }

  if (userAgent.match(/android/i)) {
    return 'android.event';
  }

  return 'web.event';
}

function sendApiLog(res, store) {
  try {
    if (!res || !res.config || !res.config.url || res.config.url.indexOf('wlog') !== -1) {
      return;
    }

    var user = store.getters.currentUser || {};
    var now = new Date();
    var body = {
      method: res.config.method,
      api: res.config.url,
      code: res.status,
      uid: user.user_id,
      role: user.role,
      grade: user.grade,
      device: getDevice(),
      client_time: now.getTime(),
      origin: '' + window.location.origin + window.location.pathname,
      host: window.location.host,
      msg: (res.data || {}).error_description
    };

    var parentIds = store.getters.getRouteQuery.parent_ids;

    if (parentIds) {
      var parentIdList = parentIds.split(',');

      parentIdList.forEach(function (parentId, i) {
        body['parent_id' + (i + 1)] = parentId;
      });
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* LOG_URL */], body);
  } catch (err) {
    console.error('failed to send log with err:', err);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (http, store) {
  http.interceptors.response.use(function (response) {
    sendApiLog(response, store);

    return response;
  }, function (error) {
    var response = error.response;


    sendApiLog(response, store);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



function afterEachRoutes(router) {
  router.afterEach(function (to) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
      document.title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["has"])(to.meta, 'title') ? to.meta.title + ' - Classting AI' : 'Classting AI';
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (afterEachRoutes);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





var needAuth = function needAuth(auth) {
  return auth === true;
};
var needRole = function needRole(role) {
  return role === true;
};

function beforeEachRoutes(router) {
  router.beforeEach(function (to, from, next) {
    var auth = to.meta.requiresAuth;
    var role = to.meta.requiresRole;

    if (to.name !== 'user-licence' && to.name !== 'auth.oauthCallback' && to.name !== 'auth.mobileCallback') {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__config__["c" /* CLASSTING_AI_INTRO_WEB */] + '/home';
    }

    if (from.query.parent_ids) {
      /* eslint-disable no-param-reassign */
      to.query.parent_ids = from.query.parent_ids;
      /* eslint-enable */
    }

    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('checkUserToken').then(function () {
      if (needRole(role)) {
        var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.currentUser;
        var userCountry = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.currentUserCountryCode;
        var supportCountries = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getSupportCountries;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"])(supportCountries, userCountry)) {
          next({
            name: 'errors.notSupportCountry'
          });
        } else if (user.role === 'teacher') {
          next({
            name: 'errors.unAuthorized'
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }).catch(function () {
      if (needAuth(auth)) {
        if (to.query && to.query.source === 'classting') {
          next({
            path: '/mobile_callback/classting?continue_url=' + encodeURIComponent(to.fullPath),
            replace: true
          });
        } else {
          sessionStorage.setItem('continue_url', to.fullPath);
          window.location.href = __WEBPACK_IMPORTED_MODULE_0__config__["f" /* CLASSTING_FULL_AUTH_URL */];
        }
      } else {
        next();
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (beforeEachRoutes);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["sendSlackContentReports"] = sendSlackContentReports;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_http__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);




/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
function sendSlackContentReports(_, _ref) {
  var params = _ref.params,
      userInfo = _ref.userInfo;

  var body = {
    username: userInfo,
    channel: __WEBPACK_IMPORTED_MODULE_2__config__["n" /* CONTENT_REPORTS_CONFIG */].channel,
    attachments: [{
      color: 'warning',
      mrkdwn_in: ['text'],
      text: '\n\n```' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params, null, '  ') + '```'
    }]
  };

  return __WEBPACK_IMPORTED_MODULE_1__plugins_http__["b" /* http */].post(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* CONTENT_REPORTS_CONFIG */].url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body), {
    headers: { 'Content-Type': 'text/plain' },
    transformRequest: [function (data, headers) {
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      return data;
    }]
  });
}
/* eslint-enable */

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getRouteName"] = getRouteName;
/* harmony export (immutable) */ __webpack_exports__["getRouteParams"] = getRouteParams;
/* harmony export (immutable) */ __webpack_exports__["getRouteQuery"] = getRouteQuery;
function getRouteName(state) {
  return state.route.name;
}

function getRouteParams(state) {
  return state.route.params;
}

function getRouteQuery(state) {
  return state.route.query;
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(232);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__app__["b" /* store */].modules));

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(232);



var plugins = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__app__["b" /* store */].plugins));

/* harmony default export */ __webpack_exports__["a"] = (plugins);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-root'
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(20);


//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mobile-callback',

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setToken', 'setDevice', 'fetchUser', 'fetchGrades', 'fetchUserLicence', 'fetchPremiumSchool'])),

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routeQuery: 'getRouteQuery',
    currentUserLanguage: 'currentUserLanguage'
  })),

  created: function created() {
    var _this = this;

    var continueUrl = this.routeQuery.continue_url;

    this.setDevice(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* NATIVE_APP_NAME */]);

    window.setToken = function (token) {
      _this.setToken(token).then(function () {
        return _this.fetchUser();
      }).then(function () {
        return _this.fetchGrades();
      }).then(function () {
        _this.$i18n.locale = _this.currentUserLanguage;
        return true;
      }).then(function () {
        return _this.fetchUserLicence();
      }).then(function () {
        return _this.fetchPremiumSchool();
      }).then(function () {
        if (continueUrl) {
          _this.$router.replace(window.decodeURIComponent(continueUrl));
        } else {
          _this.$router.replace('/');
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      });
    };

    this.$mobile.callNative('ctjscall://authorize?source=' + __WEBPACK_IMPORTED_MODULE_3__config__["e" /* NATIVE_APP_NAME */] + '&callback=setToken');
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);



//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'oauth-callback',

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['currentUserLanguage'])),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setToken', 'fetchUser', 'fetchGrades', 'fetchUserLicence', 'fetchPremiumSchool']), {
    getUrlParams: function getUrlParams() {
      var params = {};

      this.$route.hash.slice(1).split('&').forEach(function (query) {
        var _query$split = query.split('='),
            _query$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_query$split, 2),
            key = _query$split2[0],
            value = _query$split2[1];

        params[key] = value;
      });

      return params;
    }
  }),

  created: function created() {
    var _this = this;

    var urlParams = this.getUrlParams();
    var token = urlParams.access_token;
    var continueUrl = urlParams.continue_url || sessionStorage.getItem('continue_url');

    if (!token) {
      // TODO: handle error case
      console.error('no token found in URL');
      return 'something';
    }

    return this.setToken(token).then(function () {
      return _this.fetchUser();
    }).then(function () {
      return _this.fetchGrades();
    }).then(function () {
      _this.$i18n.locale = _this.currentUserLanguage;
      return true;
    }).then(function () {
      return _this.fetchUserLicence();
    }).then(function () {
      return _this.fetchPremiumSchool();
    }).then(function () {
      if (continueUrl) {
        _this.$router.replace(window.decodeURIComponent(continueUrl));
      } else {
        _this.$router.replace('/');
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }).catch(function (err) {
      console.error('err while signing in:', err);

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bookmar',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      selectedLectureType: 1,
      busy: false,
      videoLectureType: 1,
      cardLectureType: 2
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    lecturesType: 'getLecturesType',
    filterBookmarks: 'getFilterBookmarks',
    filterBookmarksPosition: 'getFilterBookmarksPosition'
  }), {
    bookmarksLecture: function bookmarksLecture() {
      return this.filterBookmarks[this.selectedLectureType] || [];
    },
    bookmarksPosition: function bookmarksPosition() {
      return this.filterBookmarksPosition[this.selectedLectureType] || 1;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchBookmarksVideoLectures', 'fetchBookmarksCardLectures', 'resetBookmarks', 'resetBookmarksPosition']), {
    selectedTab: function selectedTab(item) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: item.id === 1 ? 'bookmarked.type_video' : 'bookmarked.type_card',
        eventAction: 'click'
      });

      this.selectedLectureType = item.id;
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      var filters = {};
      filters.page = this.bookmarksPosition;
      filters.per_page = this.limit;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this.selectedLectureType === 1) {
          return _this.fetchBookmarksVideoLectures(filters);
        }
        return _this.fetchBookmarksCardLectures(filters);
      }).then(function (data) {
        if (data.length > 0) {
          return $state.loaded();
        }
        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.resetBookmarks();
    this.resetBookmarksPosition();
    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(_this2.subjectMap)) {
        return _this2.fetchSubjects();
      }
      return true;
    }).then(function () {
      return _this2.fetchBookmarksVideoLectures();
    }).then(function () {
      _this2.busy = false;
    });
  },


  watch: {
    selectedLectureType: function selectedLectureType(selected) {
      var _this3 = this;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.bookmarksLecture) && selected === 2) {
        var filters = {};
        filters.page = this.bookmarksPosition;
        filters.per_page = this.limit;
        this.busy = true;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          return _this3.fetchBookmarksCardLectures(filters);
        }).then(function () {
          _this3.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_labels__ = __webpack_require__(96);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card-lecture-view',

  data: function data() {
    return {
      busy: false,
      cardLecture: {},
      cardLectures: {},
      cardCourse: {},
      isLikeCardLecture: false,
      isBookmarkCardLecture: false,
      isCourseSubscribed: false,
      isSnackBar: false,
      cardLikeCount: 0,
      page: 1,
      limit: 10
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_labels__["a" /* default */]],

  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routeParams: 'getRouteParams',
    routeQuery: 'getRouteQuery',
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap',
    currentUserId: 'currentUserId',
    isPrime: 'isPrime',
    isUserLicence: 'isUserLicence',
    isPremiumSchool: 'isPremiumSchool',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  }), {
    cardId: function cardId() {
      return this.cardLecture && this.cardLecture.id;
    },
    cardTitle: function cardTitle() {
      return this.cardLecture && this.cardLecture.title;
    },
    cardPublisher: function cardPublisher() {
      return this.cardLecture && this.cardLecture.owner;
    },
    publisherName: function publisherName() {
      return this.cardPublisher && this.cardPublisher.name;
    },
    publisherId: function publisherId() {
      return this.cardPublisher && this.cardPublisher.id;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.subjectMap, { id: this.cardLecture.subject_id }) || {};
    },
    cardSubjectName: function cardSubjectName() {
      return this.filterSubject.name;
    },
    cardGrade: function cardGrade() {
      return this.getTranslatedName(this.gradeMap[this.cardLecture.grade_id]);
    },
    cardPageCount: function cardPageCount() {
      return this.cardLecture && this.cardLecture.page_count;
    },
    cardGoal: function cardGoal() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.cardLecture && this.cardLecture.goal)) {
        return false;
      }
      return this.cardLecture && this.cardLecture.goal.replace(/\n/g, '<br>');
    },
    storeCardId: function storeCardId() {
      return this.cardLecture && this.cardLecture.store_card_id;
    },
    cardCreatedDate: function cardCreatedDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_moment_src_moment__["a" /* default */])(this.cardLecture && this.cardLecture.created_at).format('YYYY.MM.DD');
    },
    isCourseCard: function isCourseCard() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["has"])(this.routeQuery, 'course_id')) {
        return true;
      }

      return false;
    },
    courseId: function courseId() {
      return Number(this.routeQuery.course_id);
    },
    cardLectureId: function cardLectureId() {
      return this.routeParams.cardId;
    },
    isCardCourse: function isCardCourse() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.cardCourse);
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['createCardLectureViews', 'fetchCardLecture', 'fetchSimilarCardLectures', 'fetchCardLectures', 'fetchCardLectureIsLiked', 'fetchCardCourse', 'fetchCardCourseIsSubscribed', 'createCardLectureLike', 'removeCardLectureLike', 'fetchSubjects', 'fetchCardLectureIsBookmarked', 'createCardLectureBookmark', 'removeCardLectureBookmark']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_6__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_6__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okSnackBar: function okSnackBar() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'snackbar_card_lecture',
        eventAction: 'click'
      });

      this.isSnackBar = false;
      this.showPrime();
    },
    openSnackBar: function openSnackBar() {
      this.isSnackBar = true;
    },
    closeSnackBar: function closeSnackBar() {
      this.isSnackBar = false;
    },
    setCardLectureEventCount: function setCardLectureEventCount(count) {
      return this.$localStorage.set('cardLectureEventCount', count);
    },
    getCardLectureEventCount: function getCardLectureEventCount() {
      return Number(this.$localStorage.get('cardLectureEventCount') || 0);
    },
    isCurrentCard: function isCurrentCard(id) {
      return id === this.cardId;
    },
    viewCourse: function viewCourse(courseId) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'card_lecture.course',
        eventAction: 'click'
      });

      return this.$router.push({
        name: 'card-course-view',
        params: {
          courseId: courseId
        }
      });
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.page += 1;
      var filters = {
        page: this.page,
        per_page: this.limit
      };

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this.isCourseCard) {
          filters.card_course_id = _this.courseId;
          return _this.fetchCardLectures(filters);
        }
        return _this.fetchSimilarCardLectures({ filters: filters, lectureId: _this.cardLectureId });
      }).then(function (data) {
        if (data.length > 0) {
          _this.cardLectures = _this.cardLectures.concat(data);
          return $state.loaded();
        }
        return $state.complete();
      });
    },
    moveCardViewer: function moveCardViewer() {
      return window.open(__WEBPACK_IMPORTED_MODULE_6__config__["j" /* CT_VIEWER_URL */] + '/viewer/coin-cards/' + this.storeCardId);
    },
    toggleLike: function toggleLike() {
      var _this2 = this;

      if (!this.isLikeCardLecture) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture',
          eventAction: 'light_up'
        });

        return this.createCardLectureLike(this.cardLectureId).then(function (isLikeCardLecture) {
          _this2.isLikeCardLecture = isLikeCardLecture;
          _this2.cardLikeCount += 1;
        });
      }

      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'card_lecture',
        eventAction: 'unlit'
      });

      return this.removeCardLectureLike(this.cardLectureId).then(function (isLikeCardLecture) {
        _this2.isLikeCardLecture = isLikeCardLecture;
        _this2.cardLikeCount -= 1;
      });
    },
    toggleBookmark: function toggleBookmark() {
      var _this3 = this;

      if (!this.isBookmarkCardLecture) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture',
          eventAction: 'bookmark'
        });

        return this.createCardLectureBookmark(this.cardLectureId).then(function (isBookmarkCardLecture) {
          _this3.isBookmarkCardLecture = isBookmarkCardLecture;
        });
      }

      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'card_lecture',
        eventAction: 'unbookmark'
      });

      return this.removeCardLectureBookmark(this.cardLectureId).then(function (isBookmarkCardLecture) {
        _this3.isBookmarkCardLecture = isBookmarkCardLecture;
      });
    },
    initCardLecture: function initCardLecture() {
      var _this4 = this;

      this.$route.meta.title = this.$t('common.detail');
      this.busy = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this4.subjectMap)) {
          return _this4.fetchSubjects();
        }
        return true;
      }).then(function () {
        _this4.fetchCardLecture(_this4.cardLectureId).then(function (cardLecture) {
          _this4.cardLecture = cardLecture;
          _this4.cardLikeCount = cardLecture.like_count;
          if (cardLecture.card_course_id) {
            return _this4.fetchCardCourse(cardLecture.card_course_id).then(function (cardCourse) {
              _this4.cardCourse = cardCourse;
              _this4.fetchCardCourseIsSubscribed({
                courseId: cardLecture.card_course_id,
                userId: _this4.currentUserId
              }).then(function (isCourseSubscribed) {
                _this4.isCourseSubscribed = isCourseSubscribed;
              });
            });
          }
          return true;
        });
      }).then(function () {
        var params = {
          owner_id: _this4.publisherId,
          is_prime: _this4.isPrime,
          is_user_licence: _this4.isUserLicence,
          is_school_licence: _this4.isPremiumSchool
        };
        return _this4.createCardLectureViews({ lectureId: _this4.cardLectureId, params: params });
      }).then(function () {
        return _this4.fetchCardLectureIsLiked({
          lectureId: _this4.cardLectureId,
          userId: _this4.currentUserId
        }).then(function (isLikeCardLecture) {
          _this4.isLikeCardLecture = isLikeCardLecture;
        });
      }).then(function () {
        return _this4.fetchCardLectureIsBookmarked({
          lectureId: _this4.cardLectureId,
          userId: _this4.currentUserId
        }).then(function (isBookmarkCardLecture) {
          _this4.isBookmarkCardLecture = isBookmarkCardLecture;
        });
      }).then(function () {
        _this4.page = 1;
        var filters = {
          page: _this4.page,
          per_page: _this4.limit
        };

        if (_this4.isCourseCard) {
          filters.card_course_id = _this4.courseId;
          return _this4.fetchCardLectures(filters);
        }

        return _this4.fetchSimilarCardLectures({ filters: filters, lectureId: _this4.cardLectureId });
      }).then(function (cardLectures) {
        _this4.cardLectures = cardLectures;
      }).then(function () {
        return _this4.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture_light',
          eventAction: 'view',
          eventValue: _this4.videoLikeCount
        });
      }).then(function () {
        return _this4.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture_view',
          eventAction: 'view',
          eventValue: _this4.videoLecture && _this4.videoLecture.view_count
        });
      }).then(function () {
        if (!_this4.isSubscriptionUser && !_this4.getCardLectureEventCount()) {
          return _this4.setCardLectureEventCount(1);
        }

        if (!_this4.isSubscriptionUser && _this4.getCardLectureEventCount()) {
          var eventCount = _this4.getCardLectureEventCount() + 1;
          return _this4.setCardLectureEventCount(eventCount);
        }

        return true;
      }).then(function () {
        if (!_this4.isSubscriptionUser && _this4.isPrimeSupportCountry && _this4.getCardLectureEventCount() >= 12) {
          _this4.$ga.event({
            eventCategory: 'prime',
            eventLabel: 'snackbar_card_lecture',
            eventAction: 'view'
          });
          _this4.$localStorage.set('cardLectureEventCount', 0);
          _this4.openSnackBar();
          return true;
        }
        return true;
      }).then(function () {
        _this4.busy = false;
      });
    }
  }),

  beforeMount: function beforeMount() {
    this.initCardLecture();
  },


  watch: {
    $route: function $route() {
      this.initCardLecture();
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recommend-card-lecture',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      selectedId: 0,
      busy: false,
      orderValue: '-view_count',
      isSnackBar: false
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filterLecturesSubjects: 'getFilterLecturesSubjects',
    subjectMap: 'getSubjectMap',
    cardLectureSubjects: 'getCardLectureSubjects',
    cardLectures: 'getCardLectures',
    selectedLectureSubjectId: 'getSelectedLectureSubjectId',
    cardLecturePosition: 'getCardLecturePosition',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchFilterCardLectures', 'fetchFilterRecommendCardLectures', 'setSelectedLectureSubjectId']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okSnackBar: function okSnackBar() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'snackbar_card_lectures',
        eventAction: 'click'
      });

      this.isSnackBar = false;
      this.showPrime();
    },
    openSnackBar: function openSnackBar() {
      this.isSnackBar = true;
    },
    closeSnackBar: function closeSnackBar() {
      this.isSnackBar = false;
    },
    setRecommendCardLectureEventCount: function setRecommendCardLectureEventCount(count) {
      return this.$localStorage.set('recommendCardLectureEventCount', count);
    },
    getRecommendCardLectureEventCount: function getRecommendCardLectureEventCount() {
      return Number(this.$localStorage.get('recommendCardLectureEventCount') || 0);
    },
    selectedTab: function selectedTab(selected) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'card_lectures.subject',
        eventAction: 'click',
        eventValue: selected.id
      });

      this.selectedId = selected.id;
      this.setSelectedLectureSubjectId(selected.id);
    },
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      filters.page = this.cardLecturePosition;
      filters.per_page = this.limit;

      if (this.selectedLectureSubjectId !== 0) {
        filters.subject_id = this.selectedLectureSubjectId;
      }

      this.fetchFilterRecommendCardLectures(filters).then(function (data) {
        if (data.length > 0) {
          return $state.loaded();
        }

        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    this.$route.meta.title = this.$t('common.sam_recommend_card_lecture');
    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this.subjectMap)) {
        return _this.fetchSubjects();
      }
      return true;
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this.cardLectures)) {
        var filters = {
          page: _this.page,
          per_page: _this.limit
        };
        return _this.fetchFilterRecommendCardLectures(filters);
      }
      return true;
    }).then(function () {
      if (!_this.isSubscriptionUser && !_this.getRecommendCardLectureEventCount()) {
        return _this.setRecommendCardLectureEventCount(1);
      }

      if (!_this.isSubscriptionUser && _this.getRecommendCardLectureEventCount()) {
        var eventCount = _this.getRecommendCardLectureEventCount() + 1;
        return _this.setRecommendCardLectureEventCount(eventCount);
      }

      return true;
    }).then(function () {
      if (!_this.isSubscriptionUser && _this.isPrimeSupportCountry && _this.getRecommendCardLectureEventCount() >= 15) {
        _this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_card_lectures',
          eventAction: 'view'
        });
        _this.$localStorage.set('recommendCardLectureEventCount', 0);
        _this.openSnackBar();
        return true;
      }
      return true;
    }).then(function () {
      _this.busy = false;
    });
  },


  watch: {
    selectedLectureSubjectId: function selectedLectureSubjectId(selected) {
      var _this2 = this;

      if (!this.cardLectures) {
        this.busy = true;
        var filters = {
          page: this.page,
          per_page: this.limit,
          subject_id: selected
        };
        this.fetchFilterRecommendCardLectures(filters).then(function () {
          _this2.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cat_main_components_Assignment__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cat_main_components_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cat_main_components_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatTutorial__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatTutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatTutorial__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-assignment',

  data: function data() {
    return {
      selectedStats: 'all',
      page: 1,
      limit: 10,
      selectedClassName: this.$t('assignment.all_class'),
      busy: false
    };
  },


  components: {
    Assignment: __WEBPACK_IMPORTED_MODULE_5__cat_main_components_Assignment___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    CatTutorial: __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatTutorial___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    assignmentStats: 'getAssignmentStats',
    assignments: 'getAssignments',
    userId: 'currentUserId',
    selectedClassId: 'getSelectedClassId',
    classes: 'getClasses',
    assignmentPosition: 'getAssignmentPosition',
    checkedTutorials: 'checkedTutorials'
  }), {
    isTutorialChecked: function isTutorialChecked() {
      return !this.checkedTutorials.learningIntro;
    },
    filterClasses: function filterClasses() {
      return [{
        name: this.$t('assignment.all_class'),
        id: 0
      }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.classes));
    },
    filterAssignments: function filterAssignments() {
      return this.assignments && this.assignments[this.selectedStats];
    },
    filterAssignmentPosition: function filterAssignmentPosition() {
      return this.assignmentPosition && this.assignmentPosition[this.selectedStats];
    },
    isFilterAssignments: function isFilterAssignments() {
      return this.filterAssignments && this.filterAssignments.length > 0;
    },
    userScore: function userScore() {
      return this.assignmentStats && this.assignmentStats.user_score;
    },
    classScore: function classScore() {
      return this.assignmentStats && this.assignmentStats.class_score;
    },
    totalCount: function totalCount() {
      return this.assignmentStats && this.assignmentStats.total_count;
    },
    todoCount: function todoCount() {
      return this.assignmentStats && this.assignmentStats.todo_count;
    },
    inReviewCount: function inReviewCount() {
      return this.assignmentStats && this.assignmentStats.in_review_count;
    },
    endedCount: function endedCount() {
      return this.assignmentStats && this.assignmentStats.ended_count;
    },
    filterAssignmentStats: function filterAssignmentStats() {
      return [{
        name: this.$t('assignment.stats.total_count'),
        code: 'all',
        value: this.totalCount
      }, {
        name: this.$t('assignment.stats.todo_count'),
        code: 'todo',
        value: this.todoCount
      }, {
        name: this.$t('assignment.stats.in_review_count'),
        code: 'in_review',
        value: this.inReviewCount
      }, {
        name: this.$t('assignment.stats.ended_count'),
        code: 'ended',
        value: this.endedCount
      }];
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchActiveAssignments', 'fetchAssignmentStats', 'fetchFilterAssignments', 'fetchClasses', 'setClassId', 'fetchFilterAssignmentStats', 'resetAssignments']), {
    selectClass: function selectClass(classes) {
      this.$ga.event({
        eventCategory: 'assignments',
        eventAction: 'click.class_filter',
        eventLabel: classes.id
      });

      this.selectedClassName = classes.name;
      this.setClassId(classes.id);
    },
    selectStats: function selectStats(code) {
      this.$ga.event({
        eventCategory: 'assignments',
        eventAction: 'click.stats_filter',
        eventLabel: code
      });

      this.selectedStats = code;
    },
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      filters.page = this.filterAssignmentPosition;
      filters.per_page = this.limit;
      filters.status = this.selectedStats;
      if (this.selectedClassId !== 0) {
        filters.class_id = this.selectedClassId;
      }

      this.fetchFilterAssignments(filters).then(function (data) {
        if (data.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    this.$route.meta.title = this.$t('common.class_assignment');
    this.resetAssignments();
    this.busy = true;
    var filters = {};
    filters.page = this.page;
    filters.per_page = this.limit;
    filters.status = this.selectedStats;
    this.fetchClasses(this.userId).then(function () {
      return _this.fetchAssignmentStats();
    }).then(function () {
      return _this.fetchFilterAssignments(filters);
    }).then(function () {
      _this.busy = false;
    });
  },


  watch: {
    selectedStats: function selectedStats(selected) {
      var _this2 = this;

      if (!this.assignments[selected]) {
        this.busy = true;
        var filters = {};
        filters.page = this.page;
        filters.per_page = this.limit;
        filters.status = selected;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          if (_this2.selectedClassId !== 0) {
            filters.class_id = _this2.selectedClassId;
          }
          return _this2.fetchFilterAssignments(filters);
        }).then(function () {
          _this2.busy = false;
        });
      }
    },
    selectedClassId: function selectedClassId(selected) {
      var _this3 = this;

      if (!this.assignments) {
        this.busy = true;
        var filters = {};
        filters.page = this.page;
        filters.per_page = this.limit;
        filters.status = this.selectedStats;
        filters.class_id = selected;

        this.fetchFilterAssignments(filters).then(function () {
          return _this3.fetchFilterAssignmentStats(selected);
        }).then(function () {
          _this3.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatSubtitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cat_main_components_CatDomainGuide__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cat_main_components_CatDomainGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cat_main_components_CatDomainGuide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cat_main_components_PrimeModal__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cat_main_components_PrimeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cat_main_components_PrimeModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-domain',

  data: function data() {
    return {
      selectedSubject: 0,
      selectedSubjectColor: '#03a9f4',
      busy: false,
      limit: 10,
      isPrimeModal: false,
      isSnackBar: false,
      isLicenceModal: false
    };
  },


  components: {
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_6__cat_main_components_CatSubtitle___default.a,
    CatDomainGuide: __WEBPACK_IMPORTED_MODULE_7__cat_main_components_CatDomainGuide___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a,
    PrimeModal: __WEBPACK_IMPORTED_MODULE_8__cat_main_components_PrimeModal___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    catSubjects: 'getCatSubjects',
    catSubjectDomains: 'getCatSubjectDomains',
    selectedSubjectId: 'getSelectedSubjectId',
    catStats: 'getCatStats',
    subjectDomainPosition: 'getSubjectDomainPosition',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  }), {
    filterCatSubjectDomains: function filterCatSubjectDomains() {
      return this.catSubjectDomains && this.catSubjectDomains[this.selectedSubject];
    },
    catSubjectDomainsLength: function catSubjectDomainsLength() {
      return this.filterCatSubjectDomains && this.filterCatSubjectDomains.length;
    },
    filterCatStats: function filterCatStats() {
      return this.catStats && this.catStats[this.selectedSubject];
    },
    completedCats: function completedCats() {
      return this.filterCatStats && this.filterCatStats.completed_cats;
    },
    completedDomains: function completedDomains() {
      return this.filterCatStats && this.filterCatStats.completed_domains;
    },
    getCatDescription: function getCatDescription() {
      var minCompletedCats = 5;
      if (this.completedCats > minCompletedCats) {
        return this.$t('domain.current_problem_count', { count: this.completedCats });
      }

      return this.$t('domain.complete_problem', { count: this.completedDomains });
    },
    filterSubjectDomainPosition: function filterSubjectDomainPosition() {
      return this.subjectDomainPosition[this.selectedSubject];
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchCatDomains', 'fetchSubjects', 'fetchCatStats', 'creatCatCard', 'fetchCatConfigs', 'resetCatSubjectDomains']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_5__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_5__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okPrimeModal: function okPrimeModal() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'modal_preview_cat',
        eventAction: 'click'
      });

      this.isPrimeModal = false;
      this.showPrime();
    },
    closePrimeModal: function closePrimeModal() {
      this.isPrimeModal = false;
      return true;
    },
    okSnackBar: function okSnackBar() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'snackbar_cats',
        eventAction: 'click'
      });

      this.isSnackBar = false;
      this.showPrime();
    },
    openSnackBar: function openSnackBar() {
      this.isSnackBar = true;
    },
    closeSnackBar: function closeSnackBar() {
      this.isSnackBar = false;
    },
    setDomainEventCount: function setDomainEventCount(count) {
      return this.$localStorage.set('domainEventCount', count);
    },
    getDomainEventCount: function getDomainEventCount() {
      return Number(this.$localStorage.get('domainEventCount') || 0);
    },
    selectedTab: function selectedTab(selected) {
      this.$ga.event({
        eventCategory: 'cats',
        eventAction: 'click.subject',
        eventLabel: selected.id
      });

      this.selectedSubject = selected.id;
      this.selectedSubjectColor = selected.color_code;
    },
    openLearningViewer: function openLearningViewer(viewerUrl, isFirstCatQuiz) {
      var _this = this;

      this.$ga.event({
        eventCategory: 'cats',
        eventAction: 'click.domain'
      });

      if (!this.isSubscriptionUser && !isFirstCatQuiz) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'cat',
          eventAction: 'preview'
        });

        if (this.isPrimeSupportCountry) {
          this.isPrimeModal = true;
          return true;
        }

        this.isLicenceModal = true;
        return true;
      }

      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(viewerUrl);
      }

      var viewer = window.open(viewerUrl);
      var delay = setInterval(function () {
        if (viewer.closed) {
          clearInterval(delay);
          _this.resetCatSubjectDomains();
          var filters = {};
          filters.subject_id = _this.selectedSubject;
          _this.fetchCatDomains(filters);
        }
      }, 1000);

      return true;
    },
    quizProgressValue: function quizProgressValue(value, total) {
      return Number((value / total * 100).toFixed(0)) || 0;
    },
    isGradeTotal: function isGradeTotal(gradeTotal) {
      return gradeTotal >= 10;
    },
    openCreatedLearningViewer: function openCreatedLearningViewer(domainId, isFirstCatQuiz) {
      var _this2 = this;

      this.fetchCatConfigs().then(function (catConfigs) {
        if (isFirstCatQuiz) {
          return _this2.creatCatCard({ domainId: domainId, quizCount: catConfigs.first_cat_quiz_count });
        }

        if (_this2.isSubscriptionUser) {
          return _this2.creatCatCard({ domainId: domainId, quizCount: catConfigs.normal_cat_quiz_count });
        }

        return true;
      }).then(function (data) {
        return _this2.openLearningViewer(data.viewer_url, isFirstCatQuiz);
      });
    },
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      filters.page = this.filterSubjectDomainPosition;
      filters.per_page = this.limit;
      filters.subject_id = this.selectedSubject;

      this.fetchCatDomains(filters).then(function (data) {
        if (data.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this3 = this;

    this.$route.meta.title = this.$t('common.sam_assignment');
    this.resetCatSubjectDomains();
    this.busy = true;
    var filters = {};
    filters.page = 1;
    filters.per_page = this.limit;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.catSubjects)) {
        return _this3.fetchSubjects();
      }
      return true;
    }).then(function () {
      _this3.selectedSubject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(_this3.catSubjects, '0.id', 0);
      filters.subject_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(_this3.catSubjects, '0.id', 0);
      return true;
    }).then(function () {
      return _this3.fetchCatStats(filters);
    }).then(function () {
      if (!_this3.isSubscriptionUser && !_this3.getDomainEventCount()) {
        return _this3.setDomainEventCount(1);
      }

      if (!_this3.isSubscriptionUser && _this3.getDomainEventCount()) {
        var eventCount = _this3.getDomainEventCount() + 1;
        return _this3.setDomainEventCount(eventCount);
      }

      return true;
    }).then(function () {
      if (!_this3.isSubscriptionUser && _this3.isPrimeSupportCountry && _this3.getDomainEventCount() >= 15) {
        _this3.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_cats',
          eventAction: 'view'
        });
        _this3.$localStorage.set('domainEventCount', 0);
        _this3.openSnackBar();
        return true;
      }
      return true;
    }).then(function () {
      _this3.busy = false;
    });
  },


  watch: {
    selectedSubject: function selectedSubject(selected) {
      var _this4 = this;

      var filters = {};
      filters.subject_id = selected;
      this.fetchCatStats(filters).then(function () {
        if (!_this4.catSubjectDomains[selected]) {
          _this4.busy = true;
          _this4.fetchCatDomains(filters).then(function () {
            _this4.busy = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CatSubtitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Assignment__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Assignment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'active-assignment',

  data: function data() {
    return {
      busy: false
    };
  },


  components: {
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_2__components_CatSubtitle___default.a,
    Assignment: __WEBPACK_IMPORTED_MODULE_3__components_Assignment___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    activeAssignments: 'getActiveAssignments'
  }), {
    isActiveAssignments: function isActiveAssignments() {
      return this.filterActiveAssginments.length !== 0;
    },
    filterActiveAssginments: function filterActiveAssginments() {
      return this.activeAssignments.slice(0, 4) || [];
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchActiveAssignments'])),

  beforeMount: function beforeMount() {
    var _this = this;

    this.busy = true;
    this.fetchActiveAssignments('active').then(function () {
      _this.busy = false;
    });
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_src_moment__ = __webpack_require__(86);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assignment',

  props: ['assignments', 'isBlock', 'eventLabel'],

  methods: {
    openAssignmentViewer: function openAssignmentViewer(url) {
      this.$ga.event({
        eventCategory: 'assignments',
        eventAction: 'click',
        eventLabel: this.eventLabel
      });

      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(url);
      }
      return window.open(url);
    },
    isDueDate: function isDueDate(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).valueOf() > __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])().valueOf();
    },
    dueDate: function dueDate(date) {
      if (this.isDueDate(date)) {
        if (Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).diff(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(), 'days', true)) <= 2) {
          return {
            dueDate: this.$t('assignment.period_submission', { date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).format('YYYY.MM.DD HH:mm:ss') }),
            color: '#ff595f'
          };
        }

        return {
          dueDate: this.$t('assignment.period_submission', { date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).format('YYYY.MM.DD HH:mm:ss') }),
          color: '#00c896'
        };
      }

      return {
        dueDate: this.$t('assignment.end_submission', { date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).format('YYYY.MM.DD HH:mm:ss') }),
        color: '#aaaaaa'
      };
    },
    remainingDay: function remainingDay(date) {
      if (!this.isDueDate(date)) {
        return false;
      }

      return Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(date).diff(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])(), 'days', true));
    },
    isGraded: function isGraded(submissions) {
      return submissions[0].is_graded;
    },
    isSubmitted: function isSubmitted(submissions) {
      return submissions[0].is_submitted;
    },
    userScore: function userScore(value) {
      return value.score && value.score.my_score || '-';
    },
    classScore: function classScore(value) {
      return value.score && value.score.class_score || '-';
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card-lecture',

  data: function data() {
    return {
      busy: false,
      page: 1,
      limit: 4
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    recommendCardLectures: 'getRecommendCardLectures'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchMainRecommendCardLectures'])),

  beforeMount: function beforeMount() {
    var _this = this;

    this.busy = true;
    var filters = {
      page: this.page,
      per_page: this.limit
    };
    this.fetchMainRecommendCardLectures(filters).then(function () {
      _this.busy = false;
    });
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PrimeModal__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PrimeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PrimeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CatSubtitle__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-domain',

  data: function data() {
    return {
      busy: false,
      isPrimeModal: false,
      isLicenceModal: false
    };
  },


  components: {
    PrimeModal: __WEBPACK_IMPORTED_MODULE_5__components_PrimeModal___default.a,
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_6__components_CatSubtitle___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    isSupportedGrade: 'isSupportedGrade',
    catSubjects: 'getCatSubjects',
    catDomains: 'getCatDomains',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchCatDomain', 'creatCatCard', 'fetchCatConfigs', 'setBusy']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okPrimeModal: function okPrimeModal() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'modal_preview_cat',
        eventAction: 'click'
      });

      this.isPrimeModal = false;
      this.showPrime();
    },
    closePrimeModal: function closePrimeModal() {
      this.isPrimeModal = false;
      return true;
    },
    openLearningViewer: function openLearningViewer(viewerUrl, isFirstCatQuiz) {
      var _this = this;

      if (!this.isSubscriptionUser && !isFirstCatQuiz) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'cat',
          eventAction: 'preview'
        });

        if (this.isPrimeSupportCountry) {
          this.isPrimeModal = true;
          return true;
        }

        this.isLicenceModal = true;
        return true;
      }

      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(viewerUrl);
      }

      var viewer = window.open(viewerUrl);
      var delay = setInterval(function () {
        if (viewer.closed) {
          clearInterval(delay);
          _this.fetchCatDomain(_this.catSubjects.length);
        }
      }, 1000);

      return true;
    },
    handleCloseClick: function handleCloseClick() {
      this.$refs.modal.hide();
    },
    quizProgressValue: function quizProgressValue(value, total) {
      return Number((value / total * 100).toFixed(0));
    },
    openCreatedLearningViewer: function openCreatedLearningViewer(domainId, isFirstCatQuiz) {
      var _this2 = this;

      this.fetchCatConfigs().then(function (catConfigs) {
        if (isFirstCatQuiz) {
          return _this2.creatCatCard({ domainId: domainId, quizCount: catConfigs.first_cat_quiz_count });
        }

        if (_this2.isSubscriptionUser) {
          return _this2.creatCatCard({ domainId: domainId, quizCount: catConfigs.normal_cat_quiz_count });
        }

        return true;
      }).then(function (data) {
        return _this2.openLearningViewer(data.viewer_url, isFirstCatQuiz);
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this3 = this;

    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this3.catSubjects)) {
        return _this3.fetchSubjects();
      }
      return true;
    }).then(function () {
      return _this3.fetchCatDomain(_this3.catSubjects.length);
    }).then(function () {
      _this3.busy = false;
    });
  }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-domain-guide',

  props: {
    id: String
  },

  methods: {
    handleSubmit: function handleSubmit() {
      this.$refs.modal.hide();
    }
  }

});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-header',

  props: ['catDescription'],

  data: function data() {
    return {
      selectedChildName: this.$t('common.child_add'),
      selectedChildId: null,
      busy: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    currentUser: 'currentUser',
    isParentUser: 'isParentUser',
    getFirstSelectedChild: 'getFirstSelectedChild',
    selectedChild: 'getSelectedChild',
    userChildrenList: 'userChildrenList',
    childProficiencyHistory: 'getChildProficiencyHistory',
    childProficiencyRank: 'getChildProficiencyRank',
    isPremiumSchool: 'isPremiumSchool',
    notGrowthSubjectName: 'getNotGrowthSubjectName',
    growthSubjectName: 'getGrowthSubjectName',
    growthScore: 'getGrowthScore',
    activeAssignments: 'getActiveAssignments',
    randomComments: 'getRandomComments',
    catReturnVisitComment: 'getCatReturnVisitComment'
  }), {
    assignmentLength: function assignmentLength() {
      return this.activeAssignments.length;
    },
    catRandomComment: function catRandomComment() {
      var maxNumber = this.randomComments.length - 1;
      return this.randomComments[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["random"])(0, maxNumber)];
    },
    userName: function userName() {
      return this.currentUser && this.currentUser.name;
    },
    isUserChildrentList: function isUserChildrentList() {
      return this.userChildrenList.length > 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchUserRelationships', 'setSelectedChild', 'setSelectedChildId', 'fetchChildProficiencyHistory', 'fetchChildProficiencyRank', 'setBusy']), {
    catComment: function catComment() {
      var growthScore = 20;
      var notGrowthScore = -20;

      if (this.getGrowthScore > growthScore) {
        return this.$t('common.sam_growth_comment', { subjectName: this.growthSubjectName, score: this.growthScore });
      }

      if (this.getNotGrowthScore < notGrowthScore) {
        return this.$t('common.sam_not_growth_comment', { subjectName: this.notGrowthSubjectName, score: this.growthScore });
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.activeAssignments)) {
        return this.$t('common.sam_assignment_comment', { assignment: this.assignmentLength });
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(this.activeAssignments)) {
        return this.$t(this.catRandomComment);
      }

      return this.catReturnVisitComment;
    },
    selectChild: function selectChild(child) {
      this.setSelectedChild(child);
      this.selectedChildName = child.name;
      this.selectedChildId = child.id;
    },
    initParentView: function initParentView() {
      var _this = this;

      var filters = {};
      return this.fetchUserRelationships().then(function () {
        if (!_this.isUserChildrentList) {
          return true;
        }
        _this.selectedChildName = _this.getFirstSelectedChild && _this.getFirstSelectedChild.name;
        filters.child_id = _this.getFirstSelectedChild && _this.getFirstSelectedChild.id;
        return _this.setSelectedChild(_this.getFirstSelectedChild);
      }).then(function () {
        if (!_this.isUserChildrentList) {
          return true;
        }

        return _this.fetchChildProficiencyHistory(filters);
      }).then(function () {
        if (!_this.isUserChildrentList) {
          return true;
        }

        return _this.fetchChildProficiencyRank(filters);
      });
    },
    openChildSettings: function openChildSettings() {
      var _this2 = this;

      this.$ga.event({
        eventCategory: 'learning',
        eventAction: 'link_child'
      });
      var openedClassting = window.open(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* CLASSTING_URL */] + '/settings/parent');
      var delay = setInterval(function () {
        if (openedClassting.closed) {
          clearInterval(delay);
          _this2.initParentView();
        }
      }, 1000);
    }
  }),

  beforeMount: function beforeMount() {
    var _this3 = this;

    if (this.isParentUser) {
      this.setBusy(true);
      this.initParentView().then(function () {
        _this3.setBusy(false);
      });
    }
  },


  watch: {
    selectedChildId: function selectedChildId(selected) {
      var filters = {
        child_id: selected
      };

      if (!this.childProficiencyHistory[selected]) {
        this.fetchChildProficiencyHistory(filters);
      }

      if (!this.childProficiencyRank[selected]) {
        this.fetchChildProficiencyRank(filters);
      }
    }
  }

});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatProficiency__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatProficiency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CatProficiency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CatSubtitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-parent-view',

  components: {
    CatProficiency: __WEBPACK_IMPORTED_MODULE_2__components_CatProficiency___default.a,
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_3__components_CatSubtitle___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    userChildrenList: 'userChildrenList',
    selectedChild: 'getSelectedChild',
    selectedChildId: 'getSelectedChildId',
    busy: 'getBusy',
    isSupportedChildGrade: 'isSupportedChildGrade'
  }), {
    isUserChildrentList: function isUserChildrentList() {
      return this.userChildrenList && this.userChildrenList.length > 0;
    }
  }),

  methods: {
    viewChildProficiency: function viewChildProficiency() {
      this.$ga.event({
        eventCategory: 'learning',
        eventLabel: 'view_more_subject',
        eventAction: 'click'
      });

      return this.$router.push('/proficiency?child_id=' + this.selectedChildId);
    },
    handleCloseClick: function handleCloseClick() {
      this.$refs.modal.hide();
    }
  }

});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatRank__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CatRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CatRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatScore__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatScore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CatScore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatRankPolicy__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatRankPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CatRankPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CatSubtitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-proficiency',

  data: function data() {
    return {
      selectedSubjectId: 0,
      selectedSubjectColor: '#00c896'
    };
  },


  components: {
    CatRank: __WEBPACK_IMPORTED_MODULE_2__components_CatRank___default.a,
    CatScore: __WEBPACK_IMPORTED_MODULE_3__components_CatScore___default.a,
    CatRankPolicy: __WEBPACK_IMPORTED_MODULE_4__components_CatRankPolicy___default.a,
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_5__components_CatSubtitle___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isSupportedGrade: 'isSupportedGrade',
    catSubjects: 'getCatSubjects',
    filterSubjects: 'getFilterSubjects',
    isParentUser: 'isParentUser'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSelectedSubjectId']), {
    selectedTab: function selectedTab(selected) {
      this.setSelectedSubjectId(selected.id);
      this.selectedSubjectId = selected.id;
      this.selectedSubjectColor = selected.color_code;
    },
    handleCloseClick: function handleCloseClick() {
      this.$refs.modal.hide();
    }
  })
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-rank',

  data: function data() {
    return {
      busy: false
    };
  },


  props: ['selectedSubjectId'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    filterProficiencyRank: 'getFilterProficiencyRank',
    schoolName: 'getSchoolName',
    isSchoolTotal: 'isSchoolTotal',
    isGradeTotal: 'isGradeTotal',
    schoolRate: 'getSchoolRate',
    gradeRate: 'getGradeRate',
    changedSchoolRate: 'getChangedSchoolRate',
    changedGradeRate: 'getChangedGradeRate',
    isParentUser: 'isParentUser',
    childProficiencyRank: 'getChildProficiencyRank',
    selectedChildId: 'getSelectedChildId'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchFilterProficiencyRank', 'fetchChildProficiencyRank']), {
    changedIcon: function changedIcon(rate) {
      var total = 76;
      var height = total * rate / 100;
      return {
        margin: height + 'px',
        height: total - height + 'px'
      };
    },
    rateScore: function rateScore(score) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(Math.abs(score), 1);
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.isParentUser) {
      this.busy = true;
      this.fetchFilterProficiencyRank().then(function () {
        _this.busy = false;
      });
    }
  },


  watch: {
    selectedSubjectId: function selectedSubjectId(selected) {
      var _this2 = this;

      var filters = {};
      if (selected !== 0) {
        filters.subject_id = selected;
      }

      // Support Student
      if (!this.isParentUser && !this.filterProficiencyRank[selected]) {
        this.busy = true;
        this.fetchFilterProficiencyRank(filters).then(function () {
          _this2.busy = false;
        });
      }

      // Support Parent
      if (this.isParentUser && !this.childProficiencyRank[selected]) {
        this.busy = true;
        filters.child_id = this.selectedChildId;
        this.fetchChildProficiencyRank(filters).then(function () {
          _this2.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_src_moment__ = __webpack_require__(86);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-rank-policy',

  computed: {
    proficiencyUpdateDate: function proficiencyUpdateDate() {
      var updateDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_moment_src_moment__["a" /* default */])();
      return {
        month: updateDate.month() + 1,
        day: updateDate.date()
      };
    }
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatScoreGuide__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatScoreGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CatScoreGuide__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-score',

  data: function data() {
    return {
      busy: false
    };
  },


  props: ['selectedSubjectId', 'selectedSubjectColor'],

  components: {
    CatScoreGuide: __WEBPACK_IMPORTED_MODULE_4__components_CatScoreGuide___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filterProficiencyHistory: 'getFilterProficiencyHistory',
    catSubjects: 'getCatSubjects',
    currentScore: 'getCurrentScore',
    averageScore: 'getAverageScore',
    averageScoreRate: 'getAverageScoreRate',
    currentScoreRate: 'getCurrentScoreRate',
    changedScore: 'getChangedScore',
    isParentUser: 'isParentUser',
    routeQuery: 'getRouteQuery',
    childProficiencyHistory: 'getChildProficiencyHistory',
    selectedChildId: 'getSelectedChildId'
  }), {
    changedScoreResource: function changedScoreResource() {
      if (this.changedScore < 0) {
        return {
          icon: 'ic-info-decrease.svg',
          color: '#448aff'
        };
      }

      return {
        icon: 'ic-info-increase.svg',
        color: '#ff595f'
      };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchFilterProficiencyHistory', 'fetchChildProficiencyHistory'])),

  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.isParentUser) {
      this.busy = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return _this.fetchFilterProficiencyHistory().then(function () {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["map"])(_this.catSubjects, function (item) {
            var filters = {};
            filters.subject_id = item.id;
            return _this.fetchFilterProficiencyHistory(filters);
          });
        });
      }).then(function (promise) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promise);
      }).then(function () {
        _this.busy = false;
      });
    }
  },


  watch: {
    selectedSubjectId: function selectedSubjectId(selected) {
      var _this2 = this;

      if (!this.childProficiencyHistory[selected] && this.isParentUser) {
        var filters = {
          child_id: this.selectedChildId
        };

        if (selected !== 0) {
          filters.subject_id = this.selectedSubjectId;
        }

        this.busy = true;
        this.fetchChildProficiencyHistory(filters).then(function () {
          _this2.busy = false;
        });
      }
    }
  }

});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-score-guide',

  props: {
    id: String
  },

  data: function data() {
    return {
      gradeScores: [{ grade: this.$t('ct_score.score_label_1'), score: this.$t('ct_score.score_value_1') }, { grade: this.$t('ct_score.score_label_2'), score: this.$t('ct_score.score_value_2') }, { grade: this.$t('ct_score.score_label_3'), score: this.$t('ct_score.score_value_3') }, { grade: this.$t('ct_score.score_label_4'), score: this.$t('ct_score.score_value_4') }, { grade: this.$t('ct_score.score_label_5'), score: this.$t('ct_score.score_value_5') }, { grade: this.$t('ct_score.score_label_6'), score: this.$t('ct_score.score_value_6') }, { grade: this.$t('ct_score.score_label_7'), score: this.$t('ct_score.score_value_7') }, { grade: this.$t('ct_score.score_label_8'), score: this.$t('ct_score.score_value_8') }, { grade: this.$t('ct_score.score_label_9'), score: this.$t('ct_score.score_value_9') }, { grade: this.$t('ct_score.score_label_10'), score: this.$t('ct_score.score_value_10') }, { grade: this.$t('ct_score.score_label_11'), score: this.$t('ct_score.score_value_11') }, { grade: this.$t('ct_score.score_label_12'), score: this.$t('ct_score.score_value_12') }]
    };
  },


  methods: {
    handleSubmit: function handleSubmit() {
      this.$refs.modal.hide();
    }
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-subtitle',

  props: ['title', 'count', 'routeName', 'eventLabel'],

  methods: {
    viewDetail: function viewDetail() {
      this.$ga.event({
        eventCategory: 'learning',
        eventLabel: this.eventLabel,
        eventAction: 'click'
      });

      return this.$router.push({ name: this.routeName });
    }
  }

});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__(96);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-tutorial',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    id: String
  },

  data: function data() {
    return {
      slide: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    checkedTutorials: 'checkedTutorials',
    currentUser: 'currentUser',
    isParentUser: 'isParentUser',
    isSupportUser: 'isSupportUser',
    gradeMap: 'getGradeMap',
    currentUserRole: 'currentUserRole'
  }), {
    userName: function userName() {
      return this.currentUser && this.currentUser.name;
    },
    userSchool: function userSchool() {
      return this.currentUser && this.currentUser.school_name;
    },
    userGrade: function userGrade() {
      if (!this.currentUser.grade) {
        return null;
      }

      return this.gradeMap && this.getTranslatedName(this.gradeMap[this.currentUser.grade]);
    },
    isNextButtonDisabled: function isNextButtonDisabled() {
      if (!this.isParentUser && !this.currentUser.grade && !this.userSchool) {
        return true;
      }
      return false;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setTutorialAsChecked', 'fetchUser']), {
    modalHide: function modalHide() {
      this.$refs.modal.hide();
      this.setTutorialAsChecked('learningIntro');
    },
    nextSlide: function nextSlide() {
      this.$refs.carousel.next();
    },
    prevSlide: function prevSlide() {
      this.$refs.carousel.prev();
    },
    openClassting: function openClassting() {
      var _this = this;

      var openedClassting = window.open(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* CLASSTING_URL */] + '/settings/personal_info');
      var delay = setInterval(function () {
        if (openedClassting.closed) {
          clearInterval(delay);
          _this.fetchUser();
        }
      }, 1000);

      return true;
    }
  }),

  mounted: function mounted() {
    this.$refs.modal.show();
  },


  watch: {
    slide: function slide(number) {
      if (number === this.$refs.carousel.slides.length - 1) {
        this.$refs.nextIcon.disabled = true;
      }

      if (number !== this.$refs.carousel.slides.length - 1) {
        this.$refs.nextIcon.disabled = false;
      }

      if (number === 1 && this.isNextButtonDisabled) {
        this.$refs.nextIcon.disabled = true;
        this.$refs.nextButton.disabled = true;
        this.$refs.nextButton.style.opacity = 0.4;
      }
    },
    isNextButtonDisabled: function isNextButtonDisabled() {
      if (!this.isNextButtonDisabled) {
        this.$refs.nextIcon.disabled = false;
        this.$refs.nextButton.disabled = false;
        this.$refs.nextButton.style.opacity = 1;
      }
    }
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'prime-modal',

  props: {
    benefitTitle: {
      type: String,
      default: 'prime.benefit.title'
    },

    isUnsupportText: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      benefitItems: [{
        icon: '/static/images/ic-check-benefit-copy.svg',
        text: this.$t('prime.benefit.item_1')
      }, {
        icon: '/static/images/ic-check-benefit-copy.svg',
        text: this.$t('prime.benefit.item_2')
      }, {
        icon: '/static/images/ic-check-benefit-copy.svg',
        text: this.$t('prime.benefit.item_3')
      }, {
        icon: '/static/images/ic-check-benefit-copy.svg',
        text: this.$t('prime.benefit.item_4')
      }],
      unsupportText: this.$t('prime.not_support')
    };
  },
  mounted: function mounted() {
    this.$refs.primeModal.show();
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-lecture',

  data: function data() {
    return {
      busy: false,
      page: 1,
      limit: 4
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    recommendVideoLectures: 'getRecommendVideoLectures'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchMainRecommendVideoLectures'])),

  beforeMount: function beforeMount() {
    var _this = this;

    this.busy = true;
    var filters = {
      page: this.page,
      per_page: this.limit
    };

    this.fetchMainRecommendVideoLectures(filters).then(function () {
      _this.busy = false;
    });
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatHeader__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CatHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ActiveAssignment__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ActiveAssignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ActiveAssignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatDomain__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatDomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CatDomain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CatSubtitle__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CatSubtitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CatSubtitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CatProficiency__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CatProficiency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_CatProficiency__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CatTutorial__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CatTutorial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CatTutorial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CatParentView__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CatParentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_CatParentView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CardLecture__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CardLecture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_CardLecture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_VideoLecture__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_VideoLecture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_VideoLecture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PrimeModal__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PrimeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_PrimeModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-main',

  data: function data() {
    return {
      isPrimeModal: false,
      isLicenceModal: false
    };
  },


  components: {
    CatHeader: __WEBPACK_IMPORTED_MODULE_4__components_CatHeader___default.a,
    ActiveAssignment: __WEBPACK_IMPORTED_MODULE_5__components_ActiveAssignment___default.a,
    CatDomain: __WEBPACK_IMPORTED_MODULE_6__components_CatDomain___default.a,
    CatSubtitle: __WEBPACK_IMPORTED_MODULE_7__components_CatSubtitle___default.a,
    CatProficiency: __WEBPACK_IMPORTED_MODULE_8__components_CatProficiency___default.a,
    CatTutorial: __WEBPACK_IMPORTED_MODULE_9__components_CatTutorial___default.a,
    CatParentView: __WEBPACK_IMPORTED_MODULE_10__components_CatParentView___default.a,
    CardLecture: __WEBPACK_IMPORTED_MODULE_11__components_CardLecture___default.a,
    VideoLecture: __WEBPACK_IMPORTED_MODULE_12__components_VideoLecture___default.a,
    PrimeModal: __WEBPACK_IMPORTED_MODULE_13__components_PrimeModal___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    checkedTutorials: 'checkedTutorials',
    isSupportUser: 'isSupportUser',
    isParentUser: 'isParentUser',
    subjectMap: 'getSubjectMap',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  }), {
    isTutorialChecked: function isTutorialChecked() {
      return !this.checkedTutorials.learningIntro;
    },
    isConfirmPrimeNotice: function isConfirmPrimeNotice() {
      return JSON.parse(this.$localStorage.get('isConfirmPrimeNotice'));
    },
    isOpenPrimeModal: function isOpenPrimeModal() {
      return !this.isSubscriptionUser && !this.isTutorialChecked && this.isPrimeModal && this.isPrimeSupportCountry;
    },
    isOpenLicenceModal: function isOpenLicenceModal() {
      return !this.isSubscriptionUser && !this.isTutorialChecked && this.isLicenceModal && !this.isPrimeSupportCountry;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSelectedLectureSubjectId', 'setSelectedSubjectId', 'fetchSubjects']), {
    setMainEventCount: function setMainEventCount(count) {
      return this.$localStorage.set('mainEventCount', count);
    },
    getMainEventCount: function getMainEventCount() {
      return Number(this.$localStorage.get('mainEventCount') || 0);
    },
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_3__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_3__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okPrimeModal: function okPrimeModal() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'modal_learning_tab',
        eventAction: 'click'
      });

      this.isPrmieModal = false;
      this.showPrime();
    },
    closePrimeModal: function closePrimeModal() {
      this.isPrimeModal = false;
      return true;
    }
  }),

  beforeMount: function beforeMount() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.subjectMap)) {
      this.fetchSubjects();
    }

    var initSubjectId = 0;

    this.setSelectedSubjectId(initSubjectId);
    this.setSelectedLectureSubjectId(initSubjectId);

    if (!this.isSubscriptionUser && !this.getMainEventCount()) {
      return this.setMainEventCount(1);
    }

    if (!this.isSubscriptionUser && this.getMainEventCount()) {
      var eventCount = this.getMainEventCount() + 1;
      this.setMainEventCount(eventCount);
    }

    if (!this.isSubscriptionUser && this.getMainEventCount() >= 20) {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'modal_learning_tab',
        eventAction: 'view'
      });
      this.$localStorage.set('mainEventCount', 0);

      if (this.isPrimeSupportCountry) {
        this.isPrimeModal = true;
        return true;
      }

      this.isLicenceModal = true;
      return true;
    }

    return true;
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cat_main_components_CatRankPolicy__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cat_main_components_CatRankPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cat_main_components_CatRankPolicy__);

//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-domain-rank',

  components: {
    CatProficiencyRank: __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank___default.a,
    CatRankPolicy: __WEBPACK_IMPORTED_MODULE_3__cat_main_components_CatRankPolicy___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    routeParams: 'getRouteParams',
    domainProficiencyRank: 'getDomainProficiencyRank',
    isParentUser: 'isParentUser',
    selectedChildId: 'getSelectedChildId'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchDomainProficiencyRank'])),

  beforeMount: function beforeMount() {
    var filters = {};
    filters.domain_id = this.routeParams.domainId;
    if (this.isParentUser) {
      filters.child_id = this.selectedChildId;
    }
    this.fetchDomainProficiencyRank(filters);
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__(96);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-element',

  props: ['learningElement'],

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    gradeMap: 'getGradeMap',
    isParentUser: 'isParentUser'
  }), {
    learningElementLangth: function learningElementLangth() {
      return this.learningElement.length;
    }
  }),

  methods: {
    correctAnswer: function correctAnswer(correct, total) {
      return Number((correct / total * 100).toFixed(1)) || '-';
    },
    isCorrectAnswerRatio: function isCorrectAnswerRatio(correct, total) {
      return this.correctAnswer(correct, total) >= 65;
    },
    goToLearningStore: function goToLearningStore(id) {
      var domainLectureUrl = __WEBPACK_IMPORTED_MODULE_2__config__["CT_PERF_URL"] + '/domain/lecture?learning_element_id=' + id;

      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(domainLectureUrl);
      }
      return window.open('/domain/lecture?learning_element_id=' + id);
    }
  }

});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);




var reactiveProp = __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["default"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"],
  name: 'cat-proficiency-chart',
  mixins: [reactiveProp],
  props: ['chartData', 'chartFontColor'],
  data: function data() {
    return {
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        gradient: null
      },
      options: {
        scales: {
          pointLabels: {
            display: true,
            fontColor: 'rgba(0, 0, 0, 0)',
            fontSize: 12
          },
          yAxes: [{
            gridLines: {
              zeroLineWidth: 1,
              scaleShowGridLines: true,
              display: false,
              drawBorder: true,
              color: 'rgba(255, 255, 255, 0.4)'
            },
            scaleLabel: {
              display: false
            },
            scaleShowLabels: false,
            ticks: {
              display: true,
              beginAtZero: true,
              stepSize: 250,
              fontColor: this.chartFontColor,
              fontSize: 12
            }
          }],
          xAxes: [{
            position: 'bottom',
            gridLines: {
              display: false,
              scaleShowGridLines: true,
              drawBorder: true,
              color: 'rgba(255, 255, 255, 0.4)'
            },
            ticks: {
              display: true,
              beginAtZero: false,
              fontColor: this.chartFontColor,
              fontSize: 12
            }
          }]
        },
        legend: {
          display: false
        }
      }
    };
  },
  mounted: function mounted() {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 350);
    this.gradient.addColorStop(0, 'rgba(255,255,255, 0.1)');
    this.gradient.addColorStop(1, 'rgba(255,255,255, 0.4)');
    this.renderChart(this.chartData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.options), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.defaultOptions));
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-proficiency-rank',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isGradeTotal: 'isGradeTotal',
    isSchoolTotal: 'isSchoolTotal',
    schoolName: 'getSchoolName',
    gradeRate: 'getGradeRate',
    schoolRate: 'getSchoolRate',
    changedSchoolRate: 'getChangedSchoolRate',
    changedGradeRate: 'getChangedGradeRate',
    changedDistrictRate: 'getChangedDistrictRate',
    regionName: 'getRegionName',
    districtRate: 'getDistrictRate',
    prevDistrictRate: 'getPrevDistrictRate',
    isDistrictTotal: 'isDistrictTotal'
  })),

  methods: {
    changedRateResource: function changedRateResource(changedRate) {
      if (changedRate < 0) {
        return {
          icon: 'ic-info-decrease.svg',
          color: '#448aff'
        };
      }

      return {
        icon: 'ic-info-increase.svg',
        color: '#ff595f'
      };
    },
    rateScore: function rateScore(score) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(Math.abs(score), 1);
    },
    changedRateScore: function changedRateScore(score) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["round"])(Math.abs(score));
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank__);

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-subject-rank',

  props: ['selectedSubjectId'],

  components: {
    CatProficiencyRank: __WEBPACK_IMPORTED_MODULE_2__CatProficiencyRank___default.a
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchFilterProficiencyRank', 'fetchChildProficiencyRank'])),

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isParentUser: 'isParentUser',
    selectedChildId: 'getSelectedChildId',
    childProficiencyRank: 'getChildProficiencyRank',
    filterProficiencyRank: 'getFilterProficiencyRank'
  })),

  beforeMount: function beforeMount() {
    var filters = {};
    if (this.selectedSubjectId !== 0) {
      filters.subject_id = this.selectedSubjectId;
    }

    if (this.isParentUser) {
      filters.child_id = this.selectedChildId;
      this.fetchChildProficiencyRank(filters);
    }

    if (!this.isParentUser) {
      this.fetchFilterProficiencyRank(filters);
    }
  },


  watch: {
    selectedSubjectId: function selectedSubjectId(selected) {
      var _this = this;

      var filters = {};
      if (selected !== 0) {
        filters.subject_id = selected;
      }

      // Support Student
      if (!this.isParentUser && !this.filterProficiencyRank[selected]) {
        this.busy = true;
        this.fetchFilterProficiencyRank(filters).then(function () {
          _this.busy = false;
        });
      }

      // Support Parent
      if (this.isParentUser && !this.childProficiencyRank[selected]) {
        this.busy = true;
        filters.child_id = this.selectedChildId;
        this.fetchChildProficiencyRank(filters).then(function () {
          _this.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatDomainRank__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CatDomainRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CatDomainRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatElement__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CatElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CatElement__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-learning-element',
  data: function data() {
    return {
      busy: false,
      limit: 20,
      page: 1
    };
  },


  components: {
    CatDomainRank: __WEBPACK_IMPORTED_MODULE_3__components_CatDomainRank___default.a,
    CatElement: __WEBPACK_IMPORTED_MODULE_4__components_CatElement___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    learningElement: 'getLearningElement',
    domain: 'getDomain',
    routeParams: 'getRouteParams',
    isParentUser: 'isParentUser',
    selectedChildId: 'getSelectedChildId'
  }), {
    domainName: function domainName() {
      return this.domain && this.domain.name;
    },
    isLearningElement: function isLearningElement() {
      return this.learningElement && this.learningElement.length >= 10;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchDomain', 'fetchLearningElement']), {
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      this.page += 1;
      filters.page = this.page;
      filters.per_page = this.limit;
      filters.subject_id = this.selectedSubject;

      if (this.isParentUser) {
        filters.child_id = this.selectedChildId;
      }
      this.fetchLearningElement({ domainId: this.routeParams.domainId, filters: filters }).then(function (data) {
        if (data.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    this.$route.meta.title = this.$t('elements.subtitle');
    this.busy = true;
    this.fetchDomain(this.routeParams.domainId).then(function () {
      var filters = {};
      filters.page = _this.page;
      filters.per_page = _this.limit;

      if (_this.isParentUser) {
        filters.child_id = _this.selectedChildId;
        return _this.fetchLearningElement({ domainId: _this.routeParams.domainId, filters: filters });
      }
      return _this.fetchLearningElement({ domainId: _this.routeParams.domainId, filters: filters });
    }).then(function () {
      _this.busy = false;
    });
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatProficiencyChart__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CatProficiencyChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CatProficiencyChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CatSubjectRank__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CatSubjectRank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CatSubjectRank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cat_main_components_CatScore__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cat_main_components_CatScore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__cat_main_components_CatScore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cat_main_components_CatRankPolicy__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cat_main_components_CatRankPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__cat_main_components_CatRankPolicy__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cat-proficiency',

  data: function data() {
    return {
      selectedSubject: 0,
      selectedChartBackgroundColor: '#00C896',
      chartFontColor: 'rgba(255, 255, 255)',
      busy: false,
      limit: 10
    };
  },


  components: {
    CatProficiencyChart: __WEBPACK_IMPORTED_MODULE_6__components_CatProficiencyChart___default.a,
    CatScore: __WEBPACK_IMPORTED_MODULE_8__cat_main_components_CatScore___default.a,
    CatSubjectRank: __WEBPACK_IMPORTED_MODULE_7__components_CatSubjectRank___default.a,
    CatRankPolicy: __WEBPACK_IMPORTED_MODULE_9__cat_main_components_CatRankPolicy___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_numbers__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filterSubjects: 'getFilterSubjects',
    catSubjectDomains: 'getCatSubjectDomains',
    filterProficiencyRank: 'getFilterProficiencyRank',
    schoolRate: 'getSchoolRate',
    previousSchoolRate: 'getPreviousSchoolRate',
    currentScore: 'getCurrentScore',
    averageScore: 'getAverageScore',
    currentScoreRate: 'getCurrentScoreRate',
    changedSchoolRate: 'getChangedSchoolRate',
    orderProficiencyHistory: 'getOrderProficiencyHistory',
    historyScoresData: 'getHistoryScoresData',
    historyScoreDateLabels: 'getHistoryScoreDateLabels',
    selectedSubjectId: 'getSelectedSubjectId',
    isParentUser: 'isParentUser',
    selectedChildId: 'getSelectedChildId',
    subjectDomainPosition: 'getSubjectDomainPosition'
  }), {
    isFilterCatSubjectDomains: function isFilterCatSubjectDomains() {
      return this.filterCatSubjectDomains.length >= 10;
    },
    chartData: function chartData() {
      return {
        labels: this.historyScoreDateLabels,
        datasets: [{
          borderColor: 'rgba(255, 255, 255, 0.0)',
          pointBackgroundColor: '#FFFFFF',
          borderWidth: 1,
          pointBorderColor: this.selectedChartBackgroundColor,
          data: this.historyScoresData
        }]
      };
    },
    filterCatSubjectDomains: function filterCatSubjectDomains() {
      return this.catSubjectDomains && this.catSubjectDomains[this.selectedSubjectId];
    },
    isSelectedSubjectId: function isSelectedSubjectId() {
      return this.selectedSubjectId !== 0;
    },
    filterSubjectDomainPosition: function filterSubjectDomainPosition() {
      return this.subjectDomainPosition[this.selectedSubjectId];
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchCatDomains', 'fetchChildProficiencyRank', 'fetchFilterProficiencyRank', 'fetchChildProficiencyHistory', 'fetchFilterProficiencyHistory', 'setSelectedSubjectId', 'resetDomainProficiencyRank', 'resetLearningElement']), {
    selectedTab: function selectedTab(selected) {
      this.$ga.event({
        eventCategory: 'learning',
        eventAction: 'click.level_subject',
        eventLabel: selected.id
      });

      this.selectedSubject = selected.id;
      this.selectedChartBackgroundColor = selected.color_code;
      this.setSelectedSubjectId(selected.id);
    },
    changedReateResource: function changedReateResource(rate) {
      if (rate < 0) {
        return {
          icon: 'ic-info-decrease.svg',
          color: '#448aff'
        };
      }

      return {
        icon: 'ic-info-increase.svg',
        color: '#ff595f'
      };
    },
    ratioValue: function ratioValue(value, total) {
      return Number((value / total * 100).toFixed(1));
    },
    isGradeTotal: function isGradeTotal(gradeTotal) {
      return gradeTotal >= 10;
    },
    goToLearningElement: function goToLearningElement(domainId) {
      if (this.isParentUser) {
        return this.$router.push({
          name: 'cat-learning-element',
          params: {
            domainId: domainId
          },
          query: {
            child_id: this.selectedChildId
          }
        });
      }

      return this.$router.push({
        name: 'cat-learning-element',
        params: {
          domainId: domainId
        }
      });
    },
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      filters.page = this.filterSubjectDomainPosition;
      filters.per_page = this.limit;
      filters.subject_id = this.selectedSubjectId;

      if (this.isParentUser) {
        filters.child_id = this.selectedChildId;
      }

      this.fetchCatDomains(filters).then(function (data) {
        if (data.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    this.$route.meta.title = this.$t('proficiency.title', { user: this.isParentUser ? this.$t('common.child') : this.$t('common.me') });
    this.busy = true;
    this.resetLearningElement();
    this.resetDomainProficiencyRank();
    var filters = {};
    if (this.isSelectedSubjectId) {
      filters.subject_id = this.selectedSubjectId;
    }

    if (this.isParentUser) {
      filters.child_id = this.selectedChildId;
    }

    var selectedSubject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.filterSubjects, function (item) {
      return item.id === _this.selectedSubjectId;
    });

    this.selectedChartBackgroundColor = selectedSubject.color_code;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(_this.catSubjects)) {
        return _this.fetchSubjects();
      }
      return true;
    }).then(function () {
      if (_this.isSelectedSubjectId) {
        filters.subject_id = _this.selectedSubjectId;
      }

      if (_this.isParentUser) {
        filters.child_id = _this.selectedChildId;
        return _this.fetchChildProficiencyHistory(filters);
      }
      return _this.fetchFilterProficiencyHistory(filters);
    }).then(function () {
      if (_this.isParentUser) {
        return _this.fetchChildProficiencyRank(filters);
      }

      return _this.fetchFilterProficiencyRank(filters);
    }).then(function () {
      if (_this.isSelectedSubjectId && !_this.filterCatSubjectDomains) {
        return _this.fetchCatDomains(filters);
      }
      return true;
    }).then(function () {
      _this.busy = false;
    });
  },


  watch: {
    selectedSubjectId: function selectedSubjectId(selected) {
      var _this2 = this;

      var filters = {};

      if (selected !== 0) {
        filters.subject_id = selected;
      }

      if (!this.isParentUser && !this.filterCatSubjectDomains) {
        this.busy = true;
        this.fetchCatDomains(filters).then(function () {
          _this2.busy = false;
        });
      }

      if (this.isParentUser && !this.filterCatSubjectDomains) {
        this.busy = true;
        filters.child_id = this.selectedChildId;
        this.fetchCatDomains(filters).then(function () {
          _this2.busy = false;
        });
      }
    }
  }

});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card-course-view',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      cardCourse: {},
      cardCourseLectures: [],
      busy: false
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routerParams: 'getRouteParams',
    subjects: 'getSubjectMap'
  }), {
    cardLectureCount: function cardLectureCount() {
      return this.cardCourse && this.cardCourse.lecture_count;
    },
    courseCreatedDate: function courseCreatedDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_moment_src_moment__["a" /* default */])(this.cardCourse && this.cardCourse.created_at).format('YYYY.MM.DD');
    },
    courseDescription: function courseDescription() {
      return this.cardCourse && this.cardCourse.description;
    },
    courseId: function courseId() {
      return Number(this.routerParams.courseId) || 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchCardCourse', 'fetchCardCoursesLectures']), {
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.page += 1;
      var filters = {
        card_course_id: this.courseId,
        page: this.page,
        per_page: this.limit,
        order_by: 'position'
      };

      this.fetchCardCoursesLectures(filters).then(function (data) {
        if (data.length > 0) {
          _this.cardCourseLectures = _this.cardCourseLectures.concat(data);
          return $state.loaded();
        }
        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(_this2.subjects)) {
        return _this2.fetchSubjects();
      }
      return true;
    }).then(function () {
      return _this2.fetchCardCourse(_this2.courseId);
    }).then(function (cardCourse) {
      _this2.cardCourse = cardCourse;
      return cardCourse;
    }).then(function (cardCourse) {
      var filters = {
        card_course_id: cardCourse.id,
        order_by: 'position'
      };
      _this2.fetchCardCoursesLectures(filters).then(function (cardCoursesLectures) {
        _this2.cardCourseLectures = cardCoursesLectures;
        return true;
      });
    }).then(function () {
      _this2.busy = false;
    });
  }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-course-view',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      videoCourse: {},
      videoCourseLectures: [],
      busy: false
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routerParams: 'getRouteParams',
    subjects: 'getSubjectMap'
  }), {
    videoLectureCount: function videoLectureCount() {
      return this.videoCourse && this.videoCourse.lecture_count;
    },
    videoCourseCreatedDate: function videoCourseCreatedDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_moment_src_moment__["a" /* default */])(this.videoLecture && this.videoLecture.created_at).format('YYYY.MM.DD');
    },
    videoCourseDescription: function videoCourseDescription() {
      return this.videoCourse && this.videoCourse.description;
    },
    videoCourseDuration: function videoCourseDuration() {
      return __WEBPACK_IMPORTED_MODULE_3_moment_src_moment__["a" /* default */].utc(this.videoCourse && this.videoCourse.duration * 1000).format('HH:mm:ss');
    },
    courseId: function courseId() {
      return Number(this.routerParams.courseId) || 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchVideoCourse', 'fetchVideoCoursesLectures']), {
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.page += 1;
      var filters = {
        video_course_id: this.courseId,
        page: this.page,
        per_page: this.limit,
        order_by: 'position'
      };

      this.fetchVideoCoursesLectures(filters).then(function (data) {
        if (data.length > 0) {
          _this.videoCourseLectures = _this.videoCourseLectures.concat(data);
          return $state.loaded();
        }
        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(_this2.subjects)) {
        return _this2.fetchSubjects();
      }
      return true;
    }).then(function () {
      return _this2.fetchVideoCourse(_this2.courseId);
    }).then(function (videoCourse) {
      _this2.videoCourse = videoCourse;
      return videoCourse;
    }).then(function (videoCourse) {
      var filters = {
        video_course_id: videoCourse.id,
        order_by: 'position'
      };
      _this2.fetchVideoCoursesLectures(filters).then(function (videoCourseLectures) {
        _this2.videoCourseLectures = videoCourseLectures;
        return true;
      });
    }).then(function () {
      _this2.busy = false;
    });
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'domain-lecture-view',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      busy: false,
      selectedLectureType: 1,
      videoLectureType: 1,
      cardLectureType: 2
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    routeQuery: 'getRouteQuery',
    lecturesType: 'getLecturesType',
    filterDomainLectures: 'getFilterDomainLectures',
    filterDomainLecturesPosition: 'getFilterDomainLecturesPosition',
    domain: 'getDomain',
    subjectMap: 'getSubjectMap',
    learningElement: 'getLearningElements',
    isParentUser: 'isParentUser',
    currentUser: 'currentUser'
  }), {
    domainLectures: function domainLectures() {
      return this.filterDomainLectures[this.selectedLectureType] || [];
    },
    domainLecturesPosition: function domainLecturesPosition() {
      return this.filterDomainLecturesPosition[this.selectedLectureType] || this.videoLectureType;
    },
    subjectId: function subjectId() {
      if (this.isDomainLecture) {
        return this.domain.subject_id;
      }

      return this.learningElement.subject_id;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.subjectMap, { id: this.subjectId });
    },
    domainName: function domainName() {
      if (this.isDomainLecture) {
        return this.domain.name;
      }

      return this.learningElement.name;
    },
    domainSubjectName: function domainSubjectName() {
      return this.filterSubject.name;
    },
    domainId: function domainId() {
      return this.routeQuery.domain_id;
    },
    learningElementId: function learningElementId() {
      return this.routeQuery.learning_element_id;
    },
    isDomainLecture: function isDomainLecture() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["has"])(this.routeQuery, 'domain_id')) {
        return true;
      }

      return false;
    },
    domainSubjectColor: function domainSubjectColor() {
      return this.filterSubject.color_code;
    },
    catDescription: function catDescription() {
      if (this.isDomainLecture) {
        return this.$t('domain_lecture.domain_lecture_comment');
      }

      var currentUserName = this.isParentUser ? this.$t('common.child') : this.currentUser.name + ' ' + this.$t('common.student');
      return this.$t('domain_lecture.element_lecture_comment', { use: currentUserName });
    },
    emptyVideoLectureText: function emptyVideoLectureText() {
      return this.$t('domain_lecture.empty_video_lecture');
    },
    emptyCardLectureText: function emptyCardLectureText() {
      return this.$t('domain_lecture.empty_card_lecture');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchDomain', 'fetchSubjects', 'fetchDomainVideoLectures', 'fetchDomainCardLectures', 'resetDomainLectures', 'resetDomainLecturesPosition', 'fetchLectureLearningElement']), {
    selectedTab: function selectedTab(item) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: item.id === 1 ? 'more_lectures.type_video' : 'more_lectures.type_card',
        eventAction: 'click'
      });

      this.selectedLectureType = item.id;
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      var filters = {};
      filters.page = this.domainLecturesPosition;
      filters.per_page = this.limit;
      if (this.isDomainLecture) {
        filters.domain_id = this.domainId;
      }

      if (!this.isDomainLecture) {
        filters.learning_element_id = this.learningElementId;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this.selectedLectureType === _this.videoLectureType) {
          return _this.fetchDomainVideoLectures(filters);
        }
        return _this.fetchDomainCardLectures(filters);
      }).then(function (data) {
        if (data.length > 0) {
          return $state.loaded();
        }
        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    this.resetDomainLectures();
    this.resetDomainLecturesPosition();
    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (_this2.isDomainLecture) {
        return _this2.fetchDomain(_this2.domainId);
      }

      return _this2.fetchLectureLearningElement(_this2.learningElementId);
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(_this2.subjectMap)) {
        return _this2.fetchSubjects();
      }
      return true;
    }).then(function () {
      var filters = {};
      filters.page = _this2.domainLecturesPosition;
      filters.per_page = _this2.limit;
      if (_this2.isDomainLecture) {
        filters.domain_id = _this2.domainId;
      }

      if (!_this2.isDomainLecture) {
        filters.learning_element_id = _this2.learningElementId;
      }
      return _this2.fetchDomainVideoLectures(filters);
    }).then(function () {
      _this2.busy = false;
    });
  },


  watch: {
    selectedLectureType: function selectedLectureType(selected) {
      var _this3 = this;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(this.domainLectures) && selected === this.cardLectureType) {
        var filters = {};
        filters.page = this.domainLecturesPosition;
        filters.per_page = this.limit;
        if (this.isDomainLecture) {
          filters.domain_id = this.domainId;
        }

        if (!this.isDomainLecture) {
          filters.learning_element_id = this.learningElementId;
        }
        this.busy = true;
        this.fetchDomainCardLectures(filters).then(function () {
          _this3.busy = false;
        });
      }
    }
  }

});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-found'
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-support-country',

  computed: {
    classtingUrl: function classtingUrl() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["d" /* CLASSTING_URL */];
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'un-authorized',

  methods: {
    goToClassting: function goToClassting() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__config__["d" /* CLASSTING_URL */];
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_src_moment__ = __webpack_require__(86);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-licence',

  data: function data() {
    return {
      busy: false,
      isSuccess: false,
      successText: '',
      isError: false,
      errorText: '',
      licenceCode: '',
      fieldPlaceholder: this.$t('licence.field_placeholder'),
      benefitItems: [this.$t('licence.benefit_item_1'), this.$t('licence.benefit_item_2'), this.$t('licence.benefit_item_3'), this.$t('licence.benefit_item_4'), this.$t('licence.benefit_item_5')]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    isUserLicence: 'isUserLicence',
    userLicence: 'userLicence',
    currentUserName: 'currentUserName'
  }), {
    isLicenceCode: function isLicenceCode() {
      return this.licenceCode;
    },
    licenceStartDate: function licenceStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_moment_src_moment__["a" /* default */])(this.userLicence && this.userLicence.start_date).format('YYYY-MM-DD');
    },
    licenceEndDate: function licenceEndDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_moment_src_moment__["a" /* default */])(this.userLicence && this.userLicence.end_date).format('YYYY-MM-DD');
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updatePromoCode']), {
    submitLicenceCode: function submitLicenceCode() {
      var _this = this;

      this.$ga.event({
        eventCategory: 'ai_license',
        eventLabel: 'register_ai_license',
        eventAction: 'register'
      });
      this.busy = true;
      var licenceCode = {
        code: this.licenceCode
      };

      this.updatePromoCode(licenceCode).then(function () {
        _this.isSuccess = true;
        _this.successText = _this.$t('licence.success_message', { startDate: _this.licenceStartDate, endDate: _this.licenceEndDate });
        return true;
      }).catch(function (err) {
        _this.isError = true;
        _this.busy = false;
        if (err.response.status === 404) {
          _this.errorText = _this.$t('licence.error_message_1');
        }

        if (err.response.status === 409) {
          _this.errorText = _this.$t('licence.error_message_2');
        }
      });
    }
  }),

  beforeMount: function beforeMount() {
    this.$route.meta.title = this.$t('licence.title');
  }
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recommend-video-lecture',

  data: function data() {
    return {
      page: 1,
      limit: 10,
      selectedId: 0,
      busy: false,
      orderValue: '-view_count',
      isSnackBar: false
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    filterLecturesSubjects: 'getFilterLecturesSubjects',
    subjectMap: 'getSubjectMap',
    videoLectureSubjects: 'getVideoLectureSubjects',
    videoLectures: 'getVideoLectures',
    selectedLectureSubjectId: 'getSelectedLectureSubjectId',
    videoLecturePosition: 'getVideoLecturePosition',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrimeSupportCountry: 'isPrimeSupportCountry'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchFilterVideoLectures', 'fetchFilterRecommendVideoLectures', 'setSelectedLectureSubjectId']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okSnackBar: function okSnackBar() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'snackbar_video_lectures',
        eventAction: 'click'
      });

      this.isSnackBar = false;
      this.showPrime();
    },
    openSnackBar: function openSnackBar() {
      this.isSnackBar = true;
    },
    closeSnackBar: function closeSnackBar() {
      this.isSnackBar = false;
    },
    setRecommendVideoLectureEventCount: function setRecommendVideoLectureEventCount(count) {
      return this.$localStorage.set('recommendVideoLectureEventCount', count);
    },
    getRecommendVideoLectureEventCount: function getRecommendVideoLectureEventCount() {
      return Number(this.$localStorage.get('recommendVideoLectureEventCount') || 0);
    },
    selectedTab: function selectedTab(selected) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'video_lectures.subject',
        eventAction: 'click',
        eventValue: selected.id
      });

      this.selectedId = selected.id;
      this.setSelectedLectureSubjectId(selected.id);
    },
    infiniteHandler: function infiniteHandler($state) {
      var filters = {};
      filters.page = this.videoLecturePosition;
      filters.per_page = this.limit;

      if (this.selectedLectureSubjectId !== 0) {
        filters.subject_id = this.selectedLectureSubjectId;
      }

      this.fetchFilterRecommendVideoLectures(filters).then(function (data) {
        if (data.length > 0) {
          return $state.loaded();
        }

        return $state.complete();
      });
    }
  }),

  beforeMount: function beforeMount() {
    var _this = this;

    this.$route.meta.title = this.$t('common.sam_recommend_video_lecture');
    this.busy = true;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this.subjectMap)) {
        return _this.fetchSubjects();
      }
      return true;
    }).then(function () {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this.videoLectures)) {
        var filters = {
          page: _this.page,
          per_page: _this.limit
        };
        return _this.fetchFilterRecommendVideoLectures(filters);
      }
      return true;
    }).then(function () {
      if (!_this.isSubscriptionUser && !_this.getRecommendVideoLectureEventCount()) {
        return _this.setRecommendVideoLectureEventCount(1);
      }

      if (!_this.isSubscriptionUser && _this.getRecommendVideoLectureEventCount()) {
        var eventCount = _this.getRecommendVideoLectureEventCount() + 1;
        return _this.setRecommendVideoLectureEventCount(eventCount);
      }

      return true;
    }).then(function () {
      if (!_this.isSubscriptionUser && _this.isPrimeSupportCountry && _this.getRecommendVideoLectureEventCount() >= 15) {
        _this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_video_lectures',
          eventAction: 'view'
        });
        _this.$localStorage.set('recommendVideoLectureEventCount', 0);
        _this.openSnackBar();
        return true;
      }
      return true;
    }).then(function () {
      _this.busy = false;
    });
  },


  watch: {
    selectedLectureSubjectId: function selectedLectureSubjectId(selected) {
      var _this2 = this;

      if (!this.videoLectures) {
        this.busy = true;
        var filters = {
          page: this.page,
          per_page: this.limit,
          subject_id: selected
        };

        this.fetchFilterRecommendVideoLectures(filters).then(function () {
          _this2.busy = false;
        });
      }
    }
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_labels__ = __webpack_require__(96);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-lecture-view',

  data: function data() {
    return {
      busy: false,
      videoLecture: {},
      videoLectures: {},
      videoCourse: {},
      isLikeVideoLecture: false,
      isBookmarkVideoLecture: false,
      isCourseSubscribed: false,
      isPrmieModal: false,
      isSnackBar: false,
      videoLikeCount: 0,
      page: 1,
      limit: 20,
      contentReportSuccessModalIsShown: false,
      reportContentModalIsShown: false,
      isVideoAutoState: JSON.parse(this.$localStorage.get('isVideoAutoState')),
      isLicenceModal: false,
      intervalId: null,
      now: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["now"])(),
      savedPreviewVideoLecture: JSON.parse(this.$localStorage.get(this.$store.getters.currentUserId))
    };
  },


  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_numbers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_labels__["a" /* default */]],

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])({
    routeParams: 'getRouteParams',
    routeQuery: 'getRouteQuery',
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap',
    currentUserId: 'currentUserId',
    isSubscriptionUser: 'isSubscriptionUser',
    isPrime: 'isPrime',
    isUserLicence: 'isUserLicence',
    isPremiumSchool: 'isPremiumSchool',
    isPrimeSupportCountry: 'isPrimeSupportCountry',
    monitoringHistories: 'getMonitoringHistories'
  }), {
    videoId: function videoId() {
      return this.videoLecture && this.videoLecture.id;
    },
    video: function video() {
      return this.videoLecture && this.videoLecture.video;
    },
    videoFiles: function videoFiles() {
      return this.video && this.video.files;
    },
    filterVideoFile: function filterVideoFile() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.videoFiles, { quality: 'hls' });
    },
    videoUrl: function videoUrl() {
      return this.video && this.video.embed;
    },
    videoTitle: function videoTitle() {
      return this.videoLecture && this.videoLecture.title;
    },
    videoPublisher: function videoPublisher() {
      return this.videoLecture && this.videoLecture.owner;
    },
    publisherName: function publisherName() {
      return this.videoPublisher && this.videoPublisher.name;
    },
    publisherId: function publisherId() {
      return this.videoPublisher && this.videoPublisher.id;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
    },
    videoSubjectName: function videoSubjectName() {
      return this.filterSubject.name;
    },
    videoGrade: function videoGrade() {
      return this.getTranslatedName(this.gradeMap[this.videoLecture.grade_id]);
    },
    videoViewCount: function videoViewCount() {
      return this.getToCommas(this.videoLecture && this.videoLecture.view_count);
    },
    videoDescription: function videoDescription() {
      return (this.videoLecture && this.videoLecture.description).replace(/\n/g, '<br>');
    },
    videoCreatedDate: function videoCreatedDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_moment_src_moment__["a" /* default */])(this.videoLecture && this.videoLecture.created_at).format('YYYY.MM.DD');
    },
    isNotNextPlay: function isNotNextPlay() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["some"])(this.videoLectures, { id: this.videoId });
    },
    nextVideoIndex: function nextVideoIndex() {
      if (this.isCourseCard) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["findIndex"])(this.videoLectures, { id: this.videoId }) + 1;
      }

      if (this.isNotNextPlay) {
        return 1;
      }

      return 0;
    },
    nextVideo: function nextVideo() {
      if (this.isCourseCard && this.nextVideoIndex === 0) {
        return null;
      }

      return this.videoLectures[this.nextVideoIndex];
    },
    nextVideoId: function nextVideoId() {
      if (!this.nextVideo) {
        return 0;
      }

      return this.nextVideo.id;
    },
    isCourseCard: function isCourseCard() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["has"])(this.routeQuery, 'course_id')) {
        return true;
      }

      return false;
    },
    isVideoCourse: function isVideoCourse() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.videoCourse);
    },
    courseId: function courseId() {
      return Number(this.routeQuery.course_id) || 0;
    },
    videoLectureId: function videoLectureId() {
      return this.routeParams.videoId;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['fetchSubjects', 'fetchVideoLecture', 'fetchSimilarVideoLectures', 'fetchVideoLectures', 'fetchVideoLectureIsLiked', 'fetchVideoCourse', 'fetchVideoCourseIsSubscribed', 'createVideoLectureLike', 'removeVideoLectureLike', 'fetchFilterVideoLectures', 'fetchVideoLectureIsBookmarked', 'createVideoLectureViews', 'createVideoLectureBookmark', 'removeVideoLectureBookmark']), {
    showPrime: function showPrime() {
      if (this.$mobile.isClasstingClient()) {
        return this.$mobile.openNewWebView(__WEBPACK_IMPORTED_MODULE_6__config__["i" /* CLASSTING_PAY_WEB */]);
      }

      return window.open(__WEBPACK_IMPORTED_MODULE_6__config__["i" /* CLASSTING_PAY_WEB */]);
    },
    okSnackBar: function okSnackBar() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'snackbar_video_lecture',
        eventAction: 'click'
      });

      this.isSnackBar = false;
      this.showPrime();
    },
    openSnackBar: function openSnackBar() {
      this.isSnackBar = true;
    },
    closeSnackBar: function closeSnackBar() {
      this.isSnackBar = false;
    },
    setVideoLectureEventCount: function setVideoLectureEventCount(count) {
      return this.$localStorage.set('videoLectureEventCount', count);
    },
    getVideoLectureEventCount: function getVideoLectureEventCount() {
      return Number(this.$localStorage.get('videoLectureEventCount') || 0);
    },
    okPrimeModal: function okPrimeModal() {
      this.$ga.event({
        eventCategory: 'prime',
        eventLabel: 'modal_preview_video',
        eventAction: 'click'
      });

      this.isPrmieModal = false;
      this.showPrime();
    },
    openPrimeModal: function openPrimeModal() {
      if (this.isPrimeSupportCountry) {
        this.isPrmieModal = true;
        return true;
      }

      this.isLicenceModal = true;
      return true;
    },
    closePrimeModal: function closePrimeModal() {
      this.isPrmieModal = false;
    },
    isCurrentCard: function isCurrentCard(id) {
      return id === this.videoId;
    },
    onContentReportSent: function onContentReportSent() {
      this.reportContentModalIsShown = false;
      this.contentReportSuccessModalIsShown = true;
    },
    viewCourse: function viewCourse(courseId) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'video_lecture.course',
        eventAction: 'click'
      });

      return this.$router.push({
        name: 'video-course-view',
        params: {
          courseId: courseId
        }
      });
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      this.paginationVideoLectures().then(function (data) {
        if (data.length > 0) {
          _this.videoLectures = _this.videoLectures.concat(data);
          return $state.loaded();
        }
        return $state.complete();
      });
    },
    paginationVideoLectures: function paginationVideoLectures() {
      var _this2 = this;

      this.page += 1;
      var filters = {
        page: this.page,
        per_page: this.limit
      };

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this2.isCourseCard) {
          filters.video_course_id = _this2.courseId;
          return _this2.fetchVideoLectures(filters);
        }

        return _this2.fetchSimilarVideoLectures({ filters: filters, lectureId: _this2.videoLectureId });
      });
    },
    change: function change(value) {
      if (value) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'auto_play_on'
        });
      }

      if (!value) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'auto_play_off'
        });
      }

      this.$localStorage.set('isVideoAutoState', value);
      this.isVideoAutoState = JSON.parse(this.$localStorage.get('isVideoAutoState'));
    },
    toggleLike: function toggleLike() {
      var _this3 = this;

      if (!this.isLikeVideoLecture) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'light_up'
        });

        return this.createVideoLectureLike(this.videoLectureId).then(function (isLikeVideoLecture) {
          _this3.isLikeVideoLecture = isLikeVideoLecture;
          _this3.videoLikeCount += 1;
        });
      }

      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'video_lecture',
        eventAction: 'unlit'
      });

      return this.removeVideoLectureLike(this.videoLectureId).then(function (isLikeVideoLecture) {
        _this3.isLikeVideoLecture = isLikeVideoLecture;
        _this3.videoLikeCount -= 1;
      });
    },
    toggleBookmark: function toggleBookmark() {
      var _this4 = this;

      if (!this.isBookmarkVideoLecture) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture',
          eventAction: 'bookmark'
        });

        return this.createVideoLectureBookmark(this.videoLectureId).then(function (isBookmarkVideoLecture) {
          _this4.isBookmarkVideoLecture = isBookmarkVideoLecture;
        });
      }

      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: 'video_lecture',
        eventAction: 'unbookmark'
      });

      return this.removeVideoLectureBookmark(this.videoLectureId).then(function (isBookmarkVideoLecture) {
        _this4.isBookmarkVideoLecture = isBookmarkVideoLecture;
      });
    },
    initVideoLecture: function initVideoLecture() {
      var _this5 = this;

      this.$route.meta.title = this.$t('common.detail');
      this.busy = true;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(_this5.subjectMap)) {
          return _this5.fetchSubjects();
        }
        return true;
      }).then(function () {
        _this5.fetchVideoLecture(_this5.videoLectureId).then(function (videoLecture) {
          _this5.videoLecture = videoLecture;
          _this5.videoLikeCount = videoLecture.like_count;
          if (videoLecture.video_course_id) {
            return _this5.fetchVideoCourse(videoLecture.video_course_id).then(function (videoCourse) {
              _this5.videoCourse = videoCourse;
              return _this5.fetchVideoCourseIsSubscribed({
                courseId: videoLecture.video_course_id,
                userId: _this5.currentUserId
              }).then(function (isCourseSubscribed) {
                _this5.isCourseSubscribed = isCourseSubscribed;
              });
            });
          }
          return true;
        });
      }).then(function () {
        var params = {
          owner_id: _this5.publisherId,
          is_prime: _this5.isPrime,
          is_user_licence: _this5.isUserLicence,
          is_school_licence: _this5.isPremiumSchool
        };
        return _this5.createVideoLectureViews({ lectureId: _this5.videoLectureId, params: params });
      }).then(function () {
        _this5.fetchVideoLectureIsLiked({
          lectureId: _this5.videoLectureId,
          userId: _this5.currentUserId
        }).then(function (isLikeVideoLecture) {
          _this5.isLikeVideoLecture = isLikeVideoLecture;
        });
        return true;
      }).then(function () {
        _this5.fetchVideoLectureIsBookmarked({
          lectureId: _this5.routeParams.videoId,
          userId: _this5.currentUserId
        }).then(function (isBookmarkVideoLecture) {
          _this5.isBookmarkVideoLecture = isBookmarkVideoLecture;
        });
      }).then(function () {
        _this5.page = 1;
        var filters = {
          page: _this5.page,
          per_page: _this5.limit
        };

        if (_this5.isCourseCard) {
          filters.video_course_id = _this5.courseId;
          return _this5.fetchVideoLectures(filters);
        }

        return _this5.fetchSimilarVideoLectures({ filters: filters, lectureId: _this5.videoLectureId });
      }).then(function (videoLectures) {
        _this5.videoLectures = videoLectures;
        return true;
      }).then(function () {
        if (_this5.isNotNextPlay && !_this5.isCourseCard) {
          _this5.videoLectures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(_this5.videoLectures, function (item) {
            return item.id !== _this5.videoId;
          });
        }
        return true;
      }).then(function () {
        if (_this5.nextVideoId === 0 && _this5.isCourseCard) {
          return _this5.paginationVideoLectures().then(function (data) {
            _this5.videoLectures = _this5.videoLectures.concat(data);
          });
        }

        return true;
      }).then(function () {
        _this5.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture_light',
          eventAction: 'view',
          eventValue: _this5.videoLikeCount
        });

        _this5.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'video_lecture_view',
          eventAction: 'view',
          eventValue: _this5.videoLecture && _this5.videoLecture.view_count
        });

        if (!_this5.isSubscriptionUser && !_this5.getVideoLectureEventCount()) {
          return _this5.setVideoLectureEventCount(1);
        }

        if (!_this5.isSubscriptionUser && _this5.getVideoLectureEventCount()) {
          var eventCount = _this5.getVideoLectureEventCount() + 1;
          return _this5.setVideoLectureEventCount(eventCount);
        }

        return true;
      }).then(function () {
        var videoLectureViewCount = 12;

        if (!_this5.isSubscriptionUser && _this5.isPrimeSupportCountry && _this5.getVideoLectureEventCount() >= videoLectureViewCount) {
          _this5.$ga.event({
            eventCategory: 'prime',
            eventLabel: 'snackbar_video_lecture',
            eventAction: 'view'
          });
          _this5.$localStorage.set('videoLectureEventCount', 0);
          _this5.openSnackBar();
          return true;
        }
        return true;
      }).then(function () {
        if (!_this5.isSubscriptionUser && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(_this5.savedPreviewVideoLecture, 'date') !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD')) {
          var previewVideoLecture = {
            date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD'),
            viedo_lecture_id: _this5.videoLectureId,
            user_id: _this5.currentUserId
          };

          return _this5.$localStorage.set(_this5.currentUserId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(previewVideoLecture));
        }

        return true;
      }).then(function () {
        _this5.busy = false;
      });
    }
  }),

  beforeMount: function beforeMount() {
    this.initVideoLecture();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },


  watch: {
    $route: function $route() {
      clearInterval(this.intervalId);
      this.initVideoLecture();
    },
    nextVideo: function nextVideo() {
      var _this6 = this;

      if (this.nextVideoId === 0 && this.isCourseCard) {
        this.paginationVideoLectures().then(function (data) {
          _this6.videoLectures = _this6.videoLectures.concat(data);
        });
      }
    }
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',

  props: ['header-title', 'hide-arrow-back-btn', 'hide-close-btn', 'colored-app-header'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getRouteQuery']), {
    isBrowserView: function isBrowserView() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.getRouteQuery.source);
    }
  }),

  methods: {
    close: function close() {
      this.$mobile.closeWebView();
    }
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'basic-card',

  props: {
    headerTitle: {
      type: String,
      default: 'title'
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'basic-line-gauge',

  props: {
    value: {
      type: Number,
      default: 50
    },
    unit: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    bgColor: {
      type: String,
      default: '#00c896'
    }
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'basic-modal',

  props: {
    title: {
      type: String,
      default: 'Title'
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    hideBody: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'basic-number-line',

  props: {
    myScore: {
      type: Number,
      default: 50
    },
    avgScore: {
      type: Number,
      default: 50
    },
    showPositionLabel: {
      type: Boolean,
      default: false
    },
    showPositionLegend: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card'
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_labels__ = __webpack_require__(96);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'course-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_labels__["a" /* default */]],

  props: {
    course: {
      type: Object
    },
    isCardList: {
      type: Boolean,
      default: false
    },
    isSubscription: {
      type: Boolean,
      default: false
    },
    isVideoCourse: {
      type: Boolean,
      default: false
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap'
  }), {
    courseTitle: function courseTitle() {
      return this.course.title || this.course.name;
    },
    courseOwner: function courseOwner() {
      return this.course.owner;
    },
    courseOwnerName: function courseOwnerName() {
      return this.courseOwner.name;
    },
    courseProfileImage: function courseProfileImage() {
      if (!this.courseOwner.profile_image) {
        return '/static/images/user_profile.png';
      }

      return this.courseOwner.profile_image;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.subjectMap, { id: this.course.subject_id }) || {};
    },
    courseSubjectName: function courseSubjectName() {
      return this.filterSubject.name;
    },
    courseGrade: function courseGrade() {
      return this.getTranslatedName(this.gradeMap[this.course.grade_id]);
    },
    courseLectureCount: function courseLectureCount() {
      return this.course.lecture_count;
    }
  }),

  methods: {
    subscriptionResources: function subscriptionResources() {
      if (this.isSubscription) {
        return {
          icon: 'ic-checked2.svg',
          color: '#ff595f',
          name: '구독중'
        };
      }

      return {
        icon: 'ic-check.svg',
        color: '#bcbbbb',
        name: '구독하기'
      };
    }
  }
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'custom-modal',

  props: {
    id: String,
    title: String,
    okTitle: {
      type: String,
      default: '확인'
    },
    closeTitle: {
      type: String,
      default: '취소'
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    okBusy: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    isCloseButton: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'desktop-header',

  props: {
    navState: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      ctStoreUrl: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* CT_STORE_URL */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUserId', 'currentUser']), {
    userProfileUrl: function userProfileUrl() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.currentUserId)) {
        return __WEBPACK_IMPORTED_MODULE_3__config__["d" /* CLASSTING_URL */] + '/users/' + this.currentUserId;
      }

      return '#';
    },
    profileImageStyle: function profileImageStyle() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.currentUser) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.currentUser.profile_image)) {
        return {
          'background-image': 'url(\'' + this.currentUser.profile_image + '\')'
        };
      }

      return {};
    }
  })
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'desktop-subheader',

  props: {
    subheaderTitle: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empty-content',

  props: {
    emptyContentText: {
      type: String
    },
    emptyContentImage: {
      type: String,
      default: '/static/images/img_empty_assignment.png'
    }
  }
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__(96);

//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'image-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_numbers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  props: {
    cardLecture: {
      type: Object
    },
    isList: {
      type: Boolean,
      default: false
    },
    likeCount: {
      type: Number,
      default: 0
    },
    isCourseCard: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: Number
    },
    isCurrentCard: {
      type: Boolean,
      default: false
    },
    eventLabel: {
      type: String,
      default: 'card_lecture'
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap'
  }), {
    cardTitle: function cardTitle() {
      return this.cardLecture.title;
    },
    cardImage: function cardImage() {
      return this.cardLecture.cover_image_small;
    },
    cardPublisher: function cardPublisher() {
      return this.cardLecture.publisher_name;
    },
    cardLikeCount: function cardLikeCount() {
      return this.likeCount || this.cardLecture.like_count;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.subjectMap, { id: this.cardLecture.subject_id }) || {};
    },
    cardSubjectName: function cardSubjectName() {
      return this.filterSubject.name || '';
    },
    cardGrade: function cardGrade() {
      return this.getTranslatedName(this.gradeMap[this.cardLecture.grade_id]) || this.$t('common.others');
    },
    cardViewsCount: function cardViewsCount() {
      return this.cardLecture.view_count;
    }
  }),

  methods: {
    viewCard: function viewCard(cardId) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: this.eventLabel,
        eventAction: 'click'
      });

      if (this.isCourseCard) {
        return this.$router.push('/card/' + cardId + '?course_id=' + this.courseId);
      }
      return this.$router.push('/card/' + cardId);
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layout'
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_labels__ = __webpack_require__(96);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'left-image-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_labels__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_numbers__["a" /* default */]],

  props: {
    videoLecture: {
      type: Object
    },
    isCourseCard: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: Number
    },

    isCurrentCard: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      videoBackgroundSize: {
        width: 295,
        height: 166
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap'
  }), {
    videoTitle: function videoTitle() {
      return this.videoLecture.title;
    },
    videoPublisher: function videoPublisher() {
      return this.videoLecture.owner.name;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
    },
    videoSubjectName: function videoSubjectName() {
      return this.filterSubject.name;
    },
    video: function video() {
      return this.videoLecture && this.videoLecture.video;
    },
    filterVideoPicture: function filterVideoPicture() {
      var videoPicture = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.video.pictures, { width: this.videoBackgroundSize.width });
      if (!videoPicture) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["maxBy"])(this.video.pictures, function (item) {
          return item.width;
        });
      }

      return videoPicture;
    },
    videoGrade: function videoGrade() {
      return this.getTranslatedName(this.gradeMap[this.videoLecture.grade_id]);
    },
    videoPicture: function videoPicture() {
      if (!this.filterVideoPicture) {
        return false;
      }

      return this.filterVideoPicture.link;
    },
    videoLikesCount: function videoLikesCount() {
      return this.videoLecture.like_count;
    },
    videoViewsCount: function videoViewsCount() {
      return this.videoLecture.view_count;
    },
    videoDuration: function videoDuration() {
      return __WEBPACK_IMPORTED_MODULE_2_moment_src_moment__["a" /* default */].utc(this.video && this.video.duration * 1000).format('mm:ss');
    }
  }),

  methods: {
    watchVideo: function watchVideo(videoId) {
      if (this.isCourseCard) {
        return this.$router.push('/video/' + videoId + '?course_id=' + this.courseId);
      }

      return this.$router.push('/video/' + videoId);
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'licence-modal'
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'line-gauge',

  props: {
    value: {
      type: Number,
      default: 50
    },
    bgColor: {
      type: String,
      default: '#00c896'
    }
  },

  computed: {
    styleBindings: function styleBindings() {
      return {
        width: this.value + '%',
        'background-color': this.bgColor,
        'border-color': this.bgColor
      };
    }
  }
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading-bounce'
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_himalaya__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_himalaya___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_himalaya__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vimeo_player__ = __webpack_require__(795);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'l-video',

  props: {
    videoId: {
      type: Number
    },
    videoUrl: {
      type: String
    },
    nextVideoId: {
      type: Number
    },
    isCourseCard: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: Number
    },
    isVideoAutoState: {
      type: Boolean,
      default: true
    },
    savedPreviewVideoLecture: {
      type: Object
    }
  },

  data: function data() {
    return {
      player: null,
      pauseVideoTime: 20
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    isSubscriptionUser: 'isSubscriptionUser'
  }), {
    videoParse: function videoParse() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["head"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_himalaya__["parse"])(this.videoUrl)).attributes;
    },
    videoParseUrl: function videoParseUrl() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.videoParse, { key: 'src' }).value + '&autoplay=1';
    },
    isNextVideoId: function isNextVideoId() {
      return this.nextVideoId !== 0;
    },
    playedDate: function playedDate() {
      return this.savedPreviewVideoLecture && this.savedPreviewVideoLecture.date;
    },
    isPlayedPreviewVideo: function isPlayedPreviewVideo() {
      return !this.isSubscriptionUser && this.playedDate === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_moment_src_moment__["a" /* default */])().format('YYYY-MM-DD') && Number(this.savedPreviewVideoLecture.viedo_lecture_id) !== this.videoId;
    }
  }),

  methods: {
    loadVideo: function loadVideo() {
      var _this = this;

      this.player = new __WEBPACK_IMPORTED_MODULE_5__vimeo_player__["a" /* default */](this.$refs.video);

      if (this.isPlayedPreviewVideo) {
        return this.unloadVideo();
      }

      if (this.isNextVideoId && this.isVideoAutoState && this.isSubscriptionUser) {
        return this.player.on('timeupdate', function (data) {
          if (data.percent === 1) {
            if (_this.isCourseCard) {
              return _this.$router.push('/video/' + _this.nextVideoId + '?course_id=' + _this.courseId);
            }

            return _this.$router.push('/video/' + _this.nextVideoId);
          }
          return true;
        });
      }

      return true;
    },
    unloadVideo: function unloadVideo() {
      var _this2 = this;

      return this.player.on('timeupdate', function (data) {
        if (data.seconds > _this2.pauseVideoTime) {
          _this2.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'video',
            eventAction: 'preview'
          });
          _this2.player.unload().then(function () {
            return _this2.player.pause().then(function () {
              return _this2.$emit('openPrimeModal');
            });
          });
        }
      });
    }
  },

  watch: {
    isVideoAutoState: function isVideoAutoState(isAutoState) {
      if (isAutoState) {
        return this.loadVideo();
      }

      if (!isAutoState) {
        this.player = new __WEBPACK_IMPORTED_MODULE_5__vimeo_player__["a" /* default */](this.$refs.video);
        if (this.isPlayedPreviewVideo) {
          return this.unloadVideo();
        }

        if (this.isSubscriptionUser) {
          return this.player.off('timeupdate');
        }
      }

      return true;
    }
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_desktop__ = __webpack_require__(380);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-layout',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_desktop__["a" /* default */]],

  props: {
    headerTitle: {
      type: String,
      default: ''
    },
    hideArrowBackBtn: {
      type: Boolean,
      default: false
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    coloredAppHeader: {
      type: Boolean,
      default: false
    },
    navState: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mission-achieved-modal',

  props: {
    achievedMissions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideGoToBadges: {
      type: Boolean,
      default: false
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['clearNewlyAchievedMissions']), {
    goToBadgesPage: function goToBadgesPage() {
      var _this = this;

      this.clearNewlyAchievedMissions().then(function () {
        return _this.$router.push('/badges');
      });
    }
  })
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-container'
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation-bar',

  data: function data() {
    return {
      ctStoreUrl: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* CT_STORE_URL */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUser', 'currentUserId', 'isParentUser', 'isPrime', 'isUserLicence', 'isTeacherUser']), {
    isNavigationBar: function isNavigationBar() {
      if (this.$mobile.isClasstingAndroid()) {
        return false;
      }
      return true;
    },
    userProfileImage: function userProfileImage() {
      return this.currentUser && this.currentUser.profile_image;
    },
    isActiveLicenceUser: function isActiveLicenceUser() {
      if (this.isUserLicence) {
        return 'ic-license-active.svg';
      }

      return 'ic-course-inactive.svg';
    },
    aiLink: function aiLink() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["c" /* CLASSTING_AI_INTRO_WEB */] + '/home';
    }
  }),

  methods: {
    userBookmarkUrl: function userBookmarkUrl() {
      this.$router.push({ name: 'bookmark' });
    },
    userCourseUrl: function userCourseUrl() {
      this.$router.push({ name: 'subscription-course' });
    },
    userProfileUrl: function userProfileUrl() {
      if (this.currentUserId) {
        return window.open(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* CLASSTING_URL */] + '/news');
      }
      return '/';
    },
    userLanguageUrl: function userLanguageUrl() {
      return window.open(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* CLASSTING_URL */] + '/settings/personal_info');
    },
    userLicence: function userLicence() {
      this.$router.push({ name: 'user-licence' });
    }
  },

  beforeMount: function beforeMount() {
    if (this.$mobile.isClasstingAndroid()) {
      this.$moblie.callActionbar(true);
    }
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_desktop__ = __webpack_require__(380);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'no-header-layout',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_desktop__["a" /* default */]],

  props: {
    navState: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'prime-snackbar'
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progress-bar',

  props: {
    value: {
      type: Number,
      default: 50
    },
    bgColor: {
      type: String,
      default: '#00c896'
    },
    height: {
      type: Number,
      default: 10
    },
    isBorderStyle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    progressBarStyle: function progressBarStyle() {
      return {
        height: this.height + 'px',
        'border-bottom-left-radius': this.isBorderStyle ? '4px' : '',
        'border-bottom-right-radius': this.isBorderStyle ? '4px' : ''
      };
    },
    progressStyle: function progressStyle() {
      var _this = this;

      return {
        width: this.value + '%',
        height: this.height + 'px',
        'background-color': this.bgColor,
        'border-color': this.bgColor,
        'border-bottom-left-radius': this.isBorderStyle ? '4px' : '',
        'border-bottom-right-radius': function borderBottomRightRadius() {
          if (_this.isBorderStyle && _this.value === 100) {
            return '4px';
          }
          return '';
        }
      };
    }
  }

});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'radio',

  props: ['id', 'model-value', 'check-value', 'left-label'],

  data: function data() {
    return {
      isChecked: false
    };
  },


  computed: {
    state: function state() {
      return this.modelValue === this.checkValue;
    }
  },

  methods: {
    check: function check() {
      return this.$emit('change', this.checkValue);
    },
    uncheck: function uncheck() {
      if (this.checkValue === true) {
        return this.$emit('change', false);
      }

      return this.$emit('change', null);
    },
    onChange: function onChange() {
      if (this.state) {
        this.uncheck();
      } else {
        this.check();
      }
    }
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'report-content-modal',

  props: {
    videoLecture: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      reportIssue: 1,
      busy: false,
      userAgent: navigator.userAgent.toLowerCase(),
      reportContentType: {
        error: this.$t('report_content.error'),
        inappropriate: this.$t('report_content.inappropriate'),
        inputText: this.$t('report_content.input_text')
      },
      reportContentMessage: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUserId', 'currentUser']), {
    isReportInputText: function isReportInputText() {
      if (this.reportIssue === 3) {
        return true;
      }

      return false;
    },
    reportIssueText: function reportIssueText() {
      if (this.reportIssue === 1) {
        return this.reportContentType.error;
      }

      if (this.reportIssue === 2) {
        return this.reportContentType.inappropriate;
      }

      return this.reportContentType.inputText;
    },
    isDisabled: function isDisabled() {
      return this.reportContentMessage.length === 0 && this.reportIssue === 3;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['sendSlackContentReports']), {
    onRadioSelect: function onRadioSelect(value) {
      this.reportIssue = value;
    },
    reportContent: function reportContent() {
      var _this = this;

      if (!this.busy && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"])(this.videoLecture)) {
        this.busy = true;
        var params = {
          lecture_type: 'video' || null,
          platform: this.userAgent || null,
          id: this.videoLecture.id || null,
          title: this.videoLecture.title || null,
          subject_id: this.videoLecture.subject_id || null,
          domain_id: this.videoLecture.domain_id || null,
          grade_id: this.videoLecture.grade_id || null,
          video_course_id: this.videoLecture.video_course_id || null,
          video_id: this.videoLecture.video.id || null,
          course: this.videoLecture.course || null,
          external_video_id: this.videoLecture.video.external_video_id || null,
          owner: this.videoLecture.owner || null,
          reason: this.reportIssueText,
          reported_from: this.$route.fullPath,
          reported_at: new Date().toString(),
          reported_message: this.reportContentMessage || null
        };

        var userInfo = this.currentUser.name + '(' + this.currentUser.role + ' ' + this.currentUser.user_id + ')';

        this.sendSlackContentReports({ params: params, userInfo: userInfo }).then(function () {
          _this.busy = false;
          _this.$emit('ok');
        });
      }
    }
  })
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-header',

  props: {
    title: {
      type: String
    },
    isBackground: {
      type: Boolean,
      default: true
    }
  }

});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-header-tab',
  props: {
    items: {
      type: Array,
      default: []
    },
    selectedId: {
      type: Number,
      default: 0
    },
    isStaticTab: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 8,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 0
          },
          640: {
            slidesPerView: 4,
            spaceBetween: 0
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      }
    };
  },


  methods: {
    selected: function selected(item) {
      this.$emit('selectedTab', item);
    },
    getTabName: function getTabName(item) {
      if (!this.isStaticTab) {
        return item.id === 0 ? this.$t(item.name) : item.name;
      }

      return this.$t(item.name);
    }
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subheader-nav-item',

  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'text-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_numbers__["a" /* default */]],

  props: {
    videoLecture: {
      type: Object
    },
    isList: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      videoBackgroundSize: {
        width: 295,
        height: 166
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    subjectMap: 'getSubjectMap'
  }), {
    videoTitle: function videoTitle() {
      return this.videoLecture.title;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
    },
    videoSubjectName: function videoSubjectName() {
      return this.filterSubject.name;
    },
    videoSubjectColor: function videoSubjectColor() {
      return this.filterSubject.color_code;
    },
    video: function video() {
      return this.videoLecture && this.videoLecture.video;
    },
    filterVideoPicture: function filterVideoPicture() {
      var videoPicture = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["find"])(this.video.pictures, { width: this.videoBackgroundSize.width });
      if (!videoPicture) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["maxBy"])(this.video.pictures, function (item) {
          return item.width;
        });
      }

      return videoPicture;
    },
    videoPicture: function videoPicture() {
      return {
        'background-image': 'url(\'' + this.filterVideoPicture.link + '\')'
      };
    },
    gradientStyle: function gradientStyle() {
      return {
        'background-color': 'rgba(0, 0, 0, 0.4)'
      };
    }
  }),

  methods: {
    watchVideo: function watchVideo(videoId) {
      return this.$router.push('/video/' + videoId);
    }
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toggle-switch',

  data: function data() {
    return {
      value: JSON.parse(this.$localStorage.get('isVideoAutoState'))
    };
  },
  beforeMount: function beforeMount() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(this.$localStorage.get('isVideoAutoState'))) {
      return this.$localStorage.set('isVideoAutoState', true);
    }

    return true;
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_src_moment__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_numbers__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_labels__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_numbers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_labels__["a" /* default */]],

  props: {
    videoLecture: {
      type: Object
    },
    isCourseCard: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: Number
    },
    eventLabel: {
      type: String,
      default: 'video_lecture'
    }
  },

  data: function data() {
    return {
      videoBackgroundSize: {
        width: 295,
        height: 166
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    subjectMap: 'getSubjectMap',
    gradeMap: 'getGradeMap'
  }), {
    videoLectureId: function videoLectureId() {
      return this.videoLecture.id;
    },
    videoTitle: function videoTitle() {
      return this.videoLecture.title;
    },
    videoPublisher: function videoPublisher() {
      return this.videoLecture.owner.name;
    },
    filterSubject: function filterSubject() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
    },
    videoSubjectName: function videoSubjectName() {
      return this.filterSubject.name;
    },
    video: function video() {
      return this.videoLecture && this.videoLecture.video;
    },
    filterVideoPicture: function filterVideoPicture() {
      var videoPicture = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(this.video.pictures, { width: this.videoBackgroundSize.width });
      if (!videoPicture) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["maxBy"])(this.video.pictures, function (item) {
          return item.width;
        });
      }

      return videoPicture;
    },
    videoGrade: function videoGrade() {
      return this.getTranslatedName(this.gradeMap[this.videoLecture.grade_id]);
    },
    videoPicture: function videoPicture() {
      if (!this.filterVideoPicture) {
        return false;
      }

      return this.filterVideoPicture.link;
    },
    videoLikesCount: function videoLikesCount() {
      return this.videoLecture.like_count;
    },
    videoViewsCount: function videoViewsCount() {
      return this.videoLecture.view_count;
    },
    videoDuration: function videoDuration() {
      return __WEBPACK_IMPORTED_MODULE_2_moment_src_moment__["a" /* default */].utc(this.video && this.video.duration * 1000).format('mm:ss');
    }
  }),

  methods: {
    watchVideo: function watchVideo(videoId) {
      this.$ga.event({
        eventCategory: 'recommended_lectures',
        eventLabel: this.eventLabel,
        eventAction: 'click',
        eventValue: this.videoLectureId
      });

      if (this.isCourseCard) {
        return this.$router.push('/video/' + videoId + '?course_id=' + this.courseId);
      }

      return this.$router.push('/video/' + videoId);
    }
  }
});

/***/ }),
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.2","/home/runner/work/old-ai-web/old-ai-web"]],"_development":true,"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_spec":"6.5.2","_where":"/home/runner/work/old-ai-web/old-ai-web","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}

/***/ }),
/* 1307 */,
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */
/***/ (function(module, exports) {

module.exports = {"version":"2019c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Godthab America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1399 */,
/* 1400 */,
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 610,
	"./af.js": 610,
	"./ar": 617,
	"./ar-dz": 611,
	"./ar-dz.js": 611,
	"./ar-kw": 612,
	"./ar-kw.js": 612,
	"./ar-ly": 613,
	"./ar-ly.js": 613,
	"./ar-ma": 614,
	"./ar-ma.js": 614,
	"./ar-sa": 615,
	"./ar-sa.js": 615,
	"./ar-tn": 616,
	"./ar-tn.js": 616,
	"./ar.js": 617,
	"./az": 618,
	"./az.js": 618,
	"./be": 619,
	"./be.js": 619,
	"./bg": 620,
	"./bg.js": 620,
	"./bm": 621,
	"./bm.js": 621,
	"./bn": 622,
	"./bn.js": 622,
	"./bo": 623,
	"./bo.js": 623,
	"./br": 624,
	"./br.js": 624,
	"./bs": 625,
	"./bs.js": 625,
	"./ca": 626,
	"./ca.js": 626,
	"./cs": 627,
	"./cs.js": 627,
	"./cv": 628,
	"./cv.js": 628,
	"./cy": 629,
	"./cy.js": 629,
	"./da": 630,
	"./da.js": 630,
	"./de": 633,
	"./de-at": 631,
	"./de-at.js": 631,
	"./de-ch": 632,
	"./de-ch.js": 632,
	"./de.js": 633,
	"./dv": 634,
	"./dv.js": 634,
	"./el": 635,
	"./el.js": 635,
	"./en-au": 636,
	"./en-au.js": 636,
	"./en-ca": 637,
	"./en-ca.js": 637,
	"./en-gb": 638,
	"./en-gb.js": 638,
	"./en-ie": 639,
	"./en-ie.js": 639,
	"./en-nz": 640,
	"./en-nz.js": 640,
	"./eo": 641,
	"./eo.js": 641,
	"./es": 644,
	"./es-do": 642,
	"./es-do.js": 642,
	"./es-us": 643,
	"./es-us.js": 643,
	"./es.js": 644,
	"./et": 645,
	"./et.js": 645,
	"./eu": 646,
	"./eu.js": 646,
	"./fa": 647,
	"./fa.js": 647,
	"./fi": 648,
	"./fi.js": 648,
	"./fo": 649,
	"./fo.js": 649,
	"./fr": 652,
	"./fr-ca": 650,
	"./fr-ca.js": 650,
	"./fr-ch": 651,
	"./fr-ch.js": 651,
	"./fr.js": 652,
	"./fy": 653,
	"./fy.js": 653,
	"./gd": 654,
	"./gd.js": 654,
	"./gl": 655,
	"./gl.js": 655,
	"./gom-latn": 656,
	"./gom-latn.js": 656,
	"./gu": 657,
	"./gu.js": 657,
	"./he": 658,
	"./he.js": 658,
	"./hi": 659,
	"./hi.js": 659,
	"./hr": 660,
	"./hr.js": 660,
	"./hu": 661,
	"./hu.js": 661,
	"./hy-am": 662,
	"./hy-am.js": 662,
	"./id": 663,
	"./id.js": 663,
	"./is": 664,
	"./is.js": 664,
	"./it": 665,
	"./it.js": 665,
	"./ja": 666,
	"./ja.js": 666,
	"./jv": 667,
	"./jv.js": 667,
	"./ka": 668,
	"./ka.js": 668,
	"./kk": 669,
	"./kk.js": 669,
	"./km": 670,
	"./km.js": 670,
	"./kn": 671,
	"./kn.js": 671,
	"./ko": 672,
	"./ko.js": 672,
	"./ky": 673,
	"./ky.js": 673,
	"./lb": 674,
	"./lb.js": 674,
	"./lo": 675,
	"./lo.js": 675,
	"./lt": 676,
	"./lt.js": 676,
	"./lv": 677,
	"./lv.js": 677,
	"./me": 678,
	"./me.js": 678,
	"./mi": 679,
	"./mi.js": 679,
	"./mk": 680,
	"./mk.js": 680,
	"./ml": 681,
	"./ml.js": 681,
	"./mr": 682,
	"./mr.js": 682,
	"./ms": 684,
	"./ms-my": 683,
	"./ms-my.js": 683,
	"./ms.js": 684,
	"./mt": 685,
	"./mt.js": 685,
	"./my": 686,
	"./my.js": 686,
	"./nb": 687,
	"./nb.js": 687,
	"./ne": 688,
	"./ne.js": 688,
	"./nl": 690,
	"./nl-be": 689,
	"./nl-be.js": 689,
	"./nl.js": 690,
	"./nn": 691,
	"./nn.js": 691,
	"./pa-in": 692,
	"./pa-in.js": 692,
	"./pl": 693,
	"./pl.js": 693,
	"./pt": 695,
	"./pt-br": 694,
	"./pt-br.js": 694,
	"./pt.js": 695,
	"./ro": 696,
	"./ro.js": 696,
	"./ru": 697,
	"./ru.js": 697,
	"./sd": 698,
	"./sd.js": 698,
	"./se": 699,
	"./se.js": 699,
	"./si": 700,
	"./si.js": 700,
	"./sk": 701,
	"./sk.js": 701,
	"./sl": 702,
	"./sl.js": 702,
	"./sq": 703,
	"./sq.js": 703,
	"./sr": 705,
	"./sr-cyrl": 704,
	"./sr-cyrl.js": 704,
	"./sr.js": 705,
	"./ss": 706,
	"./ss.js": 706,
	"./sv": 707,
	"./sv.js": 707,
	"./sw": 708,
	"./sw.js": 708,
	"./ta": 709,
	"./ta.js": 709,
	"./te": 710,
	"./te.js": 710,
	"./tet": 711,
	"./tet.js": 711,
	"./th": 712,
	"./th.js": 712,
	"./tl-ph": 713,
	"./tl-ph.js": 713,
	"./tlh": 714,
	"./tlh.js": 714,
	"./tr": 715,
	"./tr.js": 715,
	"./tzl": 716,
	"./tzl.js": 716,
	"./tzm": 718,
	"./tzm-latn": 717,
	"./tzm-latn.js": 717,
	"./tzm.js": 718,
	"./uk": 719,
	"./uk.js": 719,
	"./ur": 720,
	"./ur.js": 720,
	"./uz": 722,
	"./uz-latn": 721,
	"./uz-latn.js": 721,
	"./uz.js": 722,
	"./vi": 723,
	"./vi.js": 723,
	"./x-pseudo": 724,
	"./x-pseudo.js": 724,
	"./yo": 725,
	"./yo.js": 725,
	"./zh-cn": 726,
	"./zh-cn.js": 726,
	"./zh-hk": 727,
	"./zh-hk.js": 727,
	"./zh-tw": 728,
	"./zh-tw.js": 728
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1401;

/***/ }),
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","/home/runner/work/old-ai-web/old-ai-web"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"/home/runner/work/old-ai-web/old-ai-web","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 1480 */,
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1309)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02bdfc4b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1322)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1561),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28da6359",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1369)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dfae93c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d93ef2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1363)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c13aa242",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1350)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77370542",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1332)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1573),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4970e862",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1308)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01208bfb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1325)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cc2bbf1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1354)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7db8e578",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1331)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-496e56b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1315)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1553),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b472b23",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d34577e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dcc5825c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1562),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2924b444",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1358)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abb56b9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60e5aa2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(931),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1333)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(1574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50025ae5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1316)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(934),
  /* template */
  __webpack_require__(1555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1081e0af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(1576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-562bfc26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1324)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(1563),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29bd0260",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1372)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efa9d5ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1367)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(1612),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc7347ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1310)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0544cf6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1355)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(1599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-82d3edac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(1577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56376174",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1347)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72d4e8da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1373)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3141994",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1313)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-073d277e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1317)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1319)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1570),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1593),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1364)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1609),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(1580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1584),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68df02a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1311)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05580bca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1352)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1596),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(1560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1314)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a0f584e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1365)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ca33b1ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b23c44e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6942cf52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1359)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-adf46684",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1344)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(1588),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(1554),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1320)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(1559),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e18c11e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(1565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1362)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(1607),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1366)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(1611),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1357)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(1601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-991c5f26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-98eb05dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1371)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(1616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ecbc0098",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(1569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1337)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(1578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56b2196a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(1571),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4184600a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1370)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(1615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e13c096c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1343)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(1587),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(1566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33e81c3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1579),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57fac38a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-398e7239",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSupportedGrade) ? _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_assignment',
      "eventLabel": 'cat',
      "routeName": 'cat-domain-view'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "domain-list"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-domain"
  }, [_vm._m(0)]) : [(!_vm.isSupportedGrade) ? _c('div', {
    staticClass: "not-support-grade"
  }, [_c('div', {
    staticClass: "title px-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.sam_assignment')) + "\n          "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.previewDomainModal",
      modifiers: {
        "previewDomainModal": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title px-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))])])]) : (_vm.catDomains.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_domain_assignment')
    }
  }) : _vm._l((_vm.catDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "domain"
    }, [_c('div', {
      staticClass: "domain-subject"
    }, [_c('img', {
      style: ({
        'background': value.color_code
      }),
      attrs: {
        "src": value.icon_url,
        "alt": "subject-icon"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(value.name))])]), _vm._v(" "), _c('div', {
      staticClass: "domain-title"
    }, [_vm._v("\n          " + _vm._s(value.domain_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(value && !value.cat) ? [_c('div', {
      staticClass: "col-12 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.domain_id, true)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.first_problem_solve')) + " >\n              ")])])] : (value.cat && value.cat.is_completed) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_c('strong', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.score')) + " \n                "), _c('span', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                  " + _vm._s(value.proficiency_score || 0) + _vm._s(_vm.$t('common.score_value')) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.domain_id, false)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.problem_solve')) + " >\n              ")])])] : (value.cat && value.cat.is_first_cat) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_c('strong', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(_vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)) + "%\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url, true)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.continu_solve')) + " >\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 domain-progress-bar"
    }, [_c('progress-bar', {
      attrs: {
        "value": _vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count),
        "bgColor": value.color_code,
        "height": 6,
        "isBorderStyle": true
      }
    })], 1)] : (value.cat && !value.cat.is_completed) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('common.score')) + " \n              "), _c('span', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(value.proficiency_score || 0) + _vm._s(_vm.$t('common.score_value')) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.continu_solve')) + " >\n              ")])])] : _vm._e()], 2)])
  })], _vm._v(" "), (_vm.isPrimeModal) ? _c('PrimeModal', {
    attrs: {
      "benefitTitle": _vm.$t('prime.first_solve_complete'),
      "isUnsupportText": true
    },
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    staticClass: "preview-domain-modal",
    attrs: {
      "id": "previewDomainModal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "preview-domain"
  }, [_c('div', {
    staticClass: "preview-domain-header"
  }, [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))]), _vm._v(" "), _c('div', {
    staticClass: "preview-domain-body"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_sample_sam.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-domain-footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.confirmation')) + "\n            ")])])])])], 2)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dummy-domain-subject"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-domain-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-domain-action"
  })])
}]}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('bookmark.title')
    },
    slot: "sub-header"
  }, [_c('div', {
    attrs: {
      "slot": "sub-header-tab"
    },
    slot: "sub-header-tab"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.lecturesType,
      "isStaticTab": true,
      "selectedId": _vm.selectedLectureType
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bookmark row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce', {
    staticClass: "w-100"
  }) : [(_vm.selectedLectureType === _vm.videoLectureType) ? [(_vm.bookmarksLecture.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('bookmark.empty_vidoe_lecture')
    }
  }) : [_vm._l((_vm.bookmarksLecture), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
    }, [_c('VideoCard', {
      attrs: {
        "videoLecture": item,
        "eventLabel": 'bookmarked_video_lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.bookmarksLecture.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.selectedLectureType === _vm.cardLectureType) ? [(_vm.bookmarksLecture.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('empty_card_lecture')
    }
  }) : [_vm._l((_vm.bookmarksLecture), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "eventLabel": 'bookmarked_card_lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.bookmarksLecture.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()]] : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('div', {
    staticClass: "not-found-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('errors.not_found')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link-back-main"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cat-main'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.go_back_to_main')) + "\n      ")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(!_vm.hideHeader) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("modal-header", [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n              ")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [(_vm.isCloseButton) ? _c('button', {
    staticClass: "btn cl-btn close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.closeTitle) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn cl-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.okDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [(!_vm.okBusy) ? _c('span', [_vm._v(_vm._s(_vm.okTitle))]) : _c('LoadingBounce')], 1)])], 2)])])])])])
},staticRenderFns: []}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-score-container cl-card"
  }, [_c('div', {
    staticClass: "dummy-header"
  }), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "score-container cl-card"
  }, [_c('div', {
    staticClass: "score-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.ct_score')) + "\n      "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.catScoreGuide",
      modifiers: {
        "catScoreGuide": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row score-article"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "current-score"
  }, [(_vm.currentScore) ? [_c('strong', [_vm._v(_vm._s(_vm.currentScore || '-'))]), _vm._v(_vm._s(_vm.$t('common.score_value')) + "\n          ")] : [_vm._v("\n            " + _vm._s(_vm.$t('proficiency.need_cat')) + "\n          ")]], 2), _vm._v(" "), (_vm.changedScore !== 0 && _vm.currentScore) ? _c('div', {
    staticClass: "changed-score"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/" + (_vm.changedScoreResource.icon)),
      "alt": "changed-score"
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.changedScoreResource.color
    })
  }, [_vm._v(_vm._s(Math.abs(_vm.changedScore)) + _vm._s(_vm.$t('common.score_value')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "current-score-container"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.me')))]), _vm._v(" "), _c('div', {
    staticClass: "score-progress-bar"
  }, [_c('progress-bar', {
    attrs: {
      "value": _vm.currentScoreRate,
      "bgColor": _vm.selectedSubjectColor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value ml-2"
  }, [_vm._v("\n            " + _vm._s(_vm.currentScore || '-') + _vm._s(_vm.$t('common.score_value')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "average-score-container"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.average')))]), _vm._v(" "), _c('div', {
    staticClass: "score-progress-bar"
  }, [_c('progress-bar', {
    attrs: {
      "value": _vm.averageScoreRate,
      "bgColor": '#a4a4a4'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value ml-2"
  }, [_vm._v("\n            " + _vm._s(_vm.averageScore || '-') + _vm._s(_vm.$t('common.score_value')) + "\n          ")])])])])]), _vm._v(" "), _c('CatScoreGuide', {
    attrs: {
      "id": "catScoreGuide"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row dummy-article"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-current-score"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-progress-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-progress-bar"
  })])])
}]}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('common.detail'),
      "isBackground": false
    },
    slot: "sub-header"
  }, [_c('div', {
    staticClass: "content-report-container",
    attrs: {
      "slot": "sub-header-tab"
    },
    on: {
      "click": function($event) {
        _vm.reportContentModalIsShown = true
      }
    },
    slot: "sub-header-tab"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-more-active.svg",
      "alt": "content-report-icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce') : [_c('Lvideo', {
    staticClass: "video",
    attrs: {
      "videoId": _vm.videoId,
      "isVideoAutoState": _vm.isVideoAutoState,
      "isCourseCard": _vm.isCourseCard,
      "courseId": _vm.courseId,
      "videoUrl": _vm.videoUrl,
      "nextVideoId": _vm.nextVideoId,
      "savedPreviewVideoLecture": _vm.savedPreviewVideoLecture
    },
    on: {
      "openPrimeModal": _vm.openPrimeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-title"
  }, [_vm._v("\n        " + _vm._s(_vm.videoTitle) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-publisher-name"
  }, [_vm._v("\n        " + _vm._s(_vm.publisherName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-subject"
  }, [_vm._v("\n        " + _vm._s(_vm.videoGrade) + "\n        " + _vm._s(_vm.videoSubjectName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-view-count"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.videoViewCount) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-like-count"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getToCommas(_vm.videoLikeCount)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-description",
    domProps: {
      "innerHTML": _vm._s(_vm.videoDescription)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.videoCreatedDate) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-actions"
  }, [_c('a', {
    class: [_vm.isLikeVideoLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleLike()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_post_light" + (_vm.isLikeVideoLecture ? '_active' : '_normal') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.like_up')) + "\n        ")]), _vm._v(" "), _c('a', {
    class: [_vm.isBookmarkVideoLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleBookmark()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_bookmark" + (_vm.isBookmarkVideoLecture ? '_active' : '') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.bookmark')) + "\n        ")])]), _vm._v(" "), (_vm.isVideoCourse) ? _c('div', {
    staticClass: "video-course"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.videoCourse,
      "isVideoCourse": true
    },
    on: {
      "click": function($event) {
        return _vm.viewCourse(_vm.videoCourse.id)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-relation"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(_vm._s(_vm.isCourseCard ? _vm.$t('course.video_lecture') : _vm.$t('video_lecture.relation_video_lecture')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  }, [_c('ToggleSwitch', {
    on: {
      "change": _vm.change
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-8"
  }, [_vm._l((_vm.videoLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-6 col-md-6 col-sm-12 px-6 mb-2"
    }, [_c('LeftImageCard', {
      attrs: {
        "videoLecture": item,
        "isCurrentCard": _vm.isCurrentCard(item.id),
        "isCourseCard": _vm.isCourseCard,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 2)])], _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.okSnackBar()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrmieModal) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal",
    attrs: {
      "hide-header": true,
      "closeTitle": _vm.$t('prime.lecture_notice.cancel'),
      "okTitle": _vm.$t('prime.lecture_notice.confirm')
    },
    on: {
      "ok": function($event) {
        return _vm.okPrimeModal()
      },
      "cancel": function($event) {
        return _vm.closePrimeModal()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('prime.lecture_notice.description'))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reportContentModalIsShown && _vm.videoLecture) ? _c('ReportContentModal', {
    staticClass: "content-report-modal",
    attrs: {
      "videoLecture": _vm.videoLecture
    },
    on: {
      "ok": function($event) {
        return _vm.onContentReportSent()
      },
      "cancel": function($event) {
        _vm.reportContentModalIsShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentReportSuccessModalIsShown) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": true,
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.contentReportSuccessModalIsShown = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('common.error_report'))
    }
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.emptyContentImage,
      "alt": "empty-content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.emptyContentText)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-rank-container cl-card"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "rank-container cl-card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("TOP\n            "), (_vm.isSchoolTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.schoolRate) || 0) + "%")])] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [(_vm.isSchoolTotal) ? [_vm._v(_vm._s(_vm.schoolName) + " " + _vm._s(_vm.$t('common.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2), _vm._v(" "), _c('div', {
    staticClass: "school-icon-container"
  }, [_c('div', {
    staticClass: "background-icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-school-bg.svg',
      "alt": "school"
    }
  }), _vm._v(" "), (_vm.isSchoolTotal) ? _c('div', {
    staticClass: "icon",
    style: ({
      'margin-top': _vm.changedIcon(_vm.schoolRate).margin,
      'height': _vm.changedIcon(_vm.schoolRate).height
    })
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic_level_school_bg.svg',
      "alt": "school"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("TOP \n            "), (_vm.isGradeTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.gradeRate) || 0) + "%")])] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [(_vm.isGradeTotal) ? [_vm._v(_vm._s(_vm.$t('proficiency.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2), _vm._v(" "), _c('div', {
    staticClass: "grade-icon-container"
  }, [_c('div', {
    staticClass: "background-icon"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-total-bg.svg',
      "alt": "grade"
    }
  }), _vm._v(" "), (_vm.isGradeTotal) ? _c('div', {
    staticClass: "icon",
    style: ({
      'margin-top': _vm.changedIcon(_vm.gradeRate).margin,
      'height': _vm.changedIcon(_vm.gradeRate).height
    })
  }, [_c('img', {
    attrs: {
      "src": '/static/images/ic-level-total-100.svg',
      "alt": "grade"
    }
  })]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row dummy-body"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-current-score"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-current-score"
  })])])
}]}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-bounce"
  }, [_c('div', {
    staticClass: "child-bounce loading-bounce-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "child-bounce loading-bounce-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "child-bounce loading-bounce-3"
  })])
}]}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-learning-element"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "learning-element-header"
  }, [_c('div', {
    staticClass: "cl-container header-title"
  }, [_vm._v(_vm._s(_vm.domainName))])]), _vm._v(" "), (_vm.busy) ? [_c('LoadingBounce')] : [_c('div', {
    staticClass: "learning-element-container"
  }, [_c('div', {
    staticClass: "row align-items-top"
  }, [_c('CatDomainRank'), _vm._v(" "), (_vm.learningElement) ? _c('CatElement', {
    attrs: {
      "learningElement": _vm.learningElement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLearningElement) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 1)])]], 2)
},staticRenderFns: []}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header",
    class: {
      'colored-app-header': _vm.coloredAppHeader
    }
  }, [(!_vm.hideArrowBackBtn && !_vm.isBrowserView) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "float-left app-header-icon mdl-button mdl-js-button mdl-button--icon mr-24",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-header__header-row",
    class: {
      'float-left': !_vm.isBrowserView, 'text-center': _vm.isBrowserView, 'w-100': _vm.isBrowserView
    }
  }, [_c('span', {
    staticClass: "app-header-title"
  }, [_vm._v(_vm._s(_vm.headerTitle))])]), _vm._v(" "), (!_vm.hideCloseBtn && !_vm.isBrowserView) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "float-right app-header-icon mdl-button mdl-js-button mdl-button--icon",
    on: {
      "click": _vm.close
    }
  }, [(_vm.coloredAppHeader) ? _c('img', {
    attrs: {
      "src": "/static/images/close-white-54.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/close-black-54.svg"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "learning-tutorial",
    attrs: {
      "id": _vm.id,
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "carousel-caption-container"
  }, [_c('button', {
    ref: "prevIcon",
    staticClass: "prev-icon",
    attrs: {
      "type": "button",
      "disabled": _vm.slide === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-right-arrow-copy.svg"
    }
  })]), _vm._v(" "), _c('button', {
    ref: "nextIcon",
    staticClass: "next-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-right-arrow.svg"
    }
  })])]), _vm._v(" "), _c('b-carousel', {
    ref: "carousel",
    attrs: {
      "id": "carousel",
      "navigationNextLabel": "NEXT",
      "background": "#ababab",
      "interval": 0,
      "img-width": "1024",
      "img-height": "1024"
    },
    model: {
      value: (_vm.slide),
      callback: function($$v) {
        _vm.slide = $$v
      },
      expression: "slide"
    }
  }, [_c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_1.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('tutorial.step_1.greeting')) + " " + _vm._s(_vm.isParentUser ? _vm.$t('common.parent') : ("" + _vm.userName + (_vm.$t('common.student')) + "!"))), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_1.description'))
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-01.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.next")))])])])]), _vm._v(" "), (!_vm.isParentUser) ? _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t("tutorial.step_2.title")))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_2.description'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-setting row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "school-label"
  }, [_vm._v(_vm._s(_vm.$t('common.school_info')))]), _vm._v(" "), _c('div', {
    staticClass: "school-value"
  }, [_vm._v(_vm._s(_vm.userSchool || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "school-label"
  }, [_vm._v(_vm._s(_vm.$t('common.grade_info')))]), _vm._v(" "), _c('div', {
    staticClass: "school-value"
  }, [_vm._v(_vm._s(_vm.userGrade || '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "setting-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openClassting()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_2.update_school')))]), _vm._v(" "), _c('button', {
    ref: "nextButton",
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]) : _vm._e(), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_3.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_3.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-02.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_4.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_4.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-03.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tutorial.step_5.title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_5.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-04.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modalHide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_5.end_tutorial')))])])])], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', {
    staticClass: "basic-card w-100 min-h-auto"
  }, [_c('div', {
    staticClass: "mdl-card__section basic-card-header"
  }, [_c('div', {
    staticClass: "mdl-typography--body-1 typography--font-weight-600 typography--color-primary"
  }, [_vm._v("\n      " + _vm._s(_vm.headerTitle) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__section basic-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__section basic-card-footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-video"
  }, [_c('iframe', {
    ref: "video",
    staticStyle: {
      "background-color": "#000000"
    },
    attrs: {
      "src": _vm.videoParseUrl,
      "frameborder": "0",
      "width": "100%",
      "height": "100%",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": "",
      "fullscreen": "",
      "allow": "autoplay"
    },
    on: {
      "load": _vm.loadVideo
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-subheader"
  }, [_c('div', {
    staticClass: "desktop-subheader__container mx-auto"
  }, [_c('div', {
    staticClass: "desktop-subheader-title"
  }, [_vm._v("\n      " + _vm._s(_vm.subheaderTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "desktop-subheader-nav"
  }, [_vm._t("subheader-nav")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('common.detail'),
      "isBackground": false
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "cat-card-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce') : [_c('div', {
    staticClass: "row m-0 mt-14"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-4 col-6 p-0"
  }, [_c('ImageCard', {
    attrs: {
      "cardLecture": _vm.cardLecture,
      "isCourseCard": _vm.isCourseCard,
      "courseId": _vm.courseId,
      "likeCount": _vm.cardLikeCount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-8 col-6 p-0 card-container"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n            " + _vm._s(_vm.cardTitle) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-publisher"
  }, [_vm._v("\n            " + _vm._s(_vm.publisherName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-subject"
  }, [_vm._v("\n            " + _vm._s(_vm.cardGrade) + "\n            " + _vm._s(_vm.cardSubjectName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-page-count"
  }, [_vm._v("\n            " + _vm._s(_vm.cardPageCount || 0) + " " + _vm._s(_vm.$t('card_lecture.page_count')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-action-container"
  }, [_c('button', {
    staticClass: "cl-btn-lg",
    on: {
      "click": function($event) {
        return _vm.moveCardViewer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.learning')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-action-sub-container"
  }, [_c('button', {
    staticClass: "cl-btn-lg",
    on: {
      "click": function($event) {
        return _vm.moveCardViewer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.learning')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.cardGoal)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.cardCreatedDate) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    class: [_vm.isLikeCardLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleLike()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_post_light" + (_vm.isLikeCardLecture ? '_active' : '_normal') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.like_up')) + "\n        ")]), _vm._v(" "), _c('a', {
    class: [_vm.isBookmarkCardLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleBookmark()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_bookmark" + (_vm.isBookmarkCardLecture ? '_active' : '') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.bookmark')) + "\n        ")])]), _vm._v(" "), (_vm.isCardCourse) ? _c('div', {
    staticClass: "card-course"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.cardCourse
    },
    on: {
      "click": function($event) {
        return _vm.viewCourse(_vm.cardCourse.id)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-relation"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(" " + _vm._s(_vm.isCourseCard ? _vm.$t('course.card_lecture') : _vm.$t('card_lecture.relation_card_lecture')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row px-8"
  }, [_vm._l((_vm.cardLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-6 px-6 mb-2 mt-6"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "isCurrentCard": _vm.isCurrentCard(item.id),
        "isCourseCard": _vm.isCourseCard,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), (_vm.cardLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)])], _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.okSnackBar()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cat"
  }, [(_vm.isTutorialChecked) ? _c('CatTutorial') : _vm._e(), _vm._v(" "), (_vm.isOpenPrimeModal) ? _c('PrimeModal', {
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('NavigationBar'), _vm._v(" "), _c('CatHeader'), _vm._v(" "), (!_vm.isParentUser) ? [_c('ActiveAssignment'), _vm._v(" "), _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_recommend_video_lecture',
      "routeName": 'recommend-video-lecture'
    }
  }), _vm._v(" "), _c('VideoLecture'), _vm._v(" "), _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_recommend_card_lecture',
      "routeName": 'recommend-card-lecture'
    }
  }), _vm._v(" "), _c('CardLecture'), _vm._v(" "), _c('CatDomain', {
    staticClass: "cl-container"
  })] : _vm._e(), _vm._v(" "), (!_vm.isParentUser) ? [_c('CatProficiency')] : _vm._e(), _vm._v(" "), (_vm.isParentUser) ? [_c('CatParentView')] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('course.title'),
      "isBackground": false
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-course-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce', {
    staticClass: "w-100"
  }) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 px-12 mt-6 px-6"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.cardCourse,
      "isCardList": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n        " + _vm._s(_vm.courseDescription) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "course-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.courseCreatedDate) + "\n      ")]), _vm._v(" "), (_vm.cardCourseLectures.length > 0) ? _c('div', {
    staticClass: "course-lectures"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title px-0"
  }, [_vm._v(_vm._s(_vm.$t('course.card_lecture')) + " " + _vm._s(_vm.cardLectureCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action px-0"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.cardCourseLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-6 px-6 mb-2 mt-6"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "eventLabel": 'card_course.lecture',
        "isCourseCard": true,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), (_vm.cardCourseLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)]) : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "learning-guide-modal",
    attrs: {
      "id": _vm.id,
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "domain-guide-container"
  }, [_c('div', {
    staticClass: "domain-guide-header"
  }, [_vm._v(_vm._s(_vm.$t('domain.tutorial.title')))]), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('domain.tutorial.section'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-example"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img-sam-info-card.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "domain-guide-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/group-3.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('domain.tutorial.button')))])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-layout unselectable"
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "bs-b"
  }, [_c('DesktopHeader', {
    attrs: {
      "nav-state": _vm.navState
    }
  }), _vm._v(" "), _vm._t("desktop-subheader")], 2) : _c('AppHeader', {
    attrs: {
      "header-title": _vm.headerTitle,
      "hide-arrow-back-btn": _vm.hideArrowBackBtn,
      "hide-close-btn": _vm.hideCloseBtn,
      "colored-app-header": _vm.coloredAppHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    class: {
      'pt-25': _vm.isDesktop
    }
  }, [_vm._t("layout-body")], 2), _vm._v(" "), _vm._t("modal-area")], 2)
},staticRenderFns: []}

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: [_vm.isList ? 'list' : ''],
    style: (_vm.videoPicture),
    on: {
      "click": function($event) {
        return _vm.watchVideo(_vm.videoLecture.id)
      }
    }
  }, [_c('div', {
    staticClass: "card-gradient",
    style: (_vm.gradientStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.videoSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-subtitle mb-2"
  }, [_vm._v(_vm._s(_vm.videoTitle))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-action"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-video-play.svg",
      "alt": "play icon"
    }
  })])
}]}

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    on: {
      "click": function($event) {
        return _vm.watchVideo(_vm.videoLecture.id)
      }
    }
  }, [_c('div', {
    staticClass: "card-img-container"
  }, [(_vm.videoPicture) ? _c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.videoPicture
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-img-info"
  }, [_vm._v(_vm._s(_vm.videoDuration))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.videoTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-1"
  }, [_vm._v(_vm._s(_vm.videoPublisher))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-2"
  }, [_vm._v(_vm._s(_vm.videoGrade) + " " + _vm._s(_vm.videoSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-3"
  }, [_vm._v(_vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.getFormatCount(_vm.videoViewsCount)))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-4"
  }, [_vm._v(_vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getFormatCount(_vm.videoLikesCount)))])])])
},staticRenderFns: []}

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oauth-callback"
  }, [_c('LoadingBounce')], 1)
},staticRenderFns: []}

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-form-field mdc-radio-container"
  }, [(_vm.leftLabel) ? _c('label', {
    staticClass: "typography--body-3 typography--color-secondary clickable",
    attrs: {
      "id": (_vm.id + "-left-label"),
      "for": _vm.id
    }
  }, [_vm._t("left-label")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdc-radio"
  }, [_c('input', {
    staticClass: "mdc-radio__native-control",
    attrs: {
      "id": _vm.id,
      "type": "radio"
    },
    domProps: {
      "checked": _vm.state
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.leftLabel) ? _c('label', {
    staticClass: "typography--body-3 typography--color-secondary clickable",
    attrs: {
      "id": (_vm.id + "-label"),
      "for": _vm.id
    }
  }, [_vm._t("label")], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-radio__background"
  }, [_c('div', {
    staticClass: "mdc-radio__outer-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdc-radio__inner-circle"
  })])
}]}

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid mdl-grid--no-spacing line-gauge-container"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-label mdl-typography--body-1 typography--color-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-box"
  }, [_c('LineGauge', {
    attrs: {
      "value": _vm.value,
      "bg-color": _vm.bgColor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--middle lg-position-num mdl-typography--body-1 typography--color-secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + _vm._s(_vm.unit) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header",
    class: [_vm.isBackground ? 'active' : '']
  }, [_c('div', {
    staticClass: "sub-header-container"
  }, [(_vm.title) ? _c('div', {
    staticClass: "title px-0"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("sub-header-tab")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-parent-view"
  }, [(_vm.busy) ? _c('LoadingBounce') : [(_vm.isUserChildrentList) ? [(_vm.isSupportedChildGrade) ? [_c('div', {
    staticClass: "row parent-header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(_vm._s(_vm.$t('proficiency.title', {
    user: _vm.selectedChild.name
  })))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.viewChildProficiency()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.more')) + ">")])])]), _vm._v(" "), _c('CatProficiency')] : _c('div', {
    staticClass: "proficiency-container"
  }, [_c('div', {
    staticClass: "not-support-grade"
  }, [_c('div', {
    staticClass: "title px-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('proficiency.title', {
    user: _vm.selectedChild.name
  })) + "\n            "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.previewProficiencyModal",
      modifiers: {
        "previewProficiencyModal": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title px-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))])])])])] : _vm._e(), _vm._v(" "), (!_vm.isUserChildrentList) ? [_c('div', {
    staticClass: "empty-parent"
  }, [_c('div', {
    staticClass: "empty-parent-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('parent.main.title')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "empty-parent-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('parent.main.subtitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "empty-parent-icon-container"
  }, [_c('img', {
    staticClass: "empty-parent-icon",
    attrs: {
      "src": "/static/images/img-main-sam@2x.png"
    }
  })])])] : _vm._e()], _vm._v(" "), _c('b-modal', {
    ref: "modal",
    staticClass: "preview-proficiency-modal",
    attrs: {
      "id": "previewProficiencyModal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "preview-proficiency"
  }, [_c('div', {
    staticClass: "preview-proficiency-header"
  }, [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-body"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_sample_level.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.confirmation')) + "\n          ")])])])])], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-card cl-container"
  }, [(_vm.busy) ? [_vm._m(0), _vm._v(" "), _vm._m(1)] : _vm._l((_vm.recommendCardLectures), function(item, index) {
    return _c('ImageCard', {
      key: index,
      attrs: {
        "cardLecture": item,
        "isList": true
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
}]}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6 cat-school-rank"
  }, [_c('CatProficiencyRank')], 1)
},staticRenderFns: []}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)) + " "), (_vm.count) ? _c('strong', [_vm._v(_vm._s(_vm.count))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  }, [_c('span', {
    on: {
      "click": _vm.viewDetail
    }
  }, [_vm._v(_vm._s(_vm.$t('common.more')) + " >")])])])
},staticRenderFns: []}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-proficiency"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "proficiency-header"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('proficiency.title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n    ")]), _vm._v(" "), _c('SubHeaderTab', {
    attrs: {
      "items": _vm.filterSubjects,
      "selectedId": _vm.selectedSubjectId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1), _vm._v(" "), (_vm.busy) ? [_c('LoadingBounce')] : [_c('div', {
    staticClass: "proficiency-container"
  }, [_c('div', {
    staticClass: "chart-container",
    style: ({
      'background-color': _vm.selectedChartBackgroundColor
    })
  }, [_c('div', {
    staticClass: "chart-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('proficiency.chart_title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n        ")]), _vm._v(" "), _c('CatProficiencyChart', {
    attrs: {
      "chartData": _vm.chartData,
      "chartFontColor": _vm.chartFontColor,
      "height": 160
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('CatScore', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubject,
      "selectedSubjectColor": _vm.selectedChartBackgroundColor
    }
  }), _vm._v(" "), _c('CatSubjectRank', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubject
    }
  })], 1), _vm._v(" "), _c('CatRankPolicy'), _vm._v(" "), (_vm.isSelectedSubjectId) ? [(_vm.filterCatSubjectDomains.length > 0) ? _c('div', {
    staticClass: "domain-container"
  }, [_c('div', {
    staticClass: "cl-title"
  }, [_vm._v(_vm._s(_vm.$t('common.domain')) + " " + _vm._s(_vm.filterCatSubjectDomains.length))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.filterCatSubjectDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-xs-12 col-md-12 px-6 domain",
      on: {
        "click": function($event) {
          return _vm.goToLearningElement(value.id)
        }
      }
    }, [_c('div', {
      staticClass: "cl-card"
    }, [_c('div', {
      staticClass: "domain-name"
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" "), _c('div', {
      staticClass: "domain-state"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.score')) + " "), _c('span', [_vm._v(_vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')))]), _vm._v("     " + _vm._s(_vm.$t('common.rank')) + "\n                  "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', [_vm._v(_vm._s(_vm.ratioValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%")])] : [_c('span', {
      style: ({
        'color': '#00C896'
      })
    }, [_vm._v("-%")]), _vm._v(" " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                  ")]], 2)])])
  }), _vm._v(" "), (_vm.isFilterCatSubjectDomains) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)]) : _vm._e()] : _vm._e()], 2)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('div', {
    staticClass: "un-authorized-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('errors.unauthorized')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('a', {
    on: {
      "click": _vm.goToClassting
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.go_back_to_other_app')) + "\n      ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CustomModal', {
    staticClass: "basic-modal",
    attrs: {
      "id": "report-content-modal",
      "title": _vm.$t('common.report'),
      "close-title": _vm.$t('common.cancel'),
      "ok-title": _vm.$t('common.confirmation'),
      "ok-busy": _vm.busy,
      "okDisabled": _vm.isDisabled
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      },
      "ok": function($event) {
        return _vm.reportContent()
      }
    }
  }, [_c('div', [_c('Radio', {
    attrs: {
      "id": "option-content-has-error",
      "model-value": _vm.reportIssue,
      "check-value": 1
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.error) + "\n      ")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "id": "option-content-is-inappropriate",
      "model-value": _vm.reportIssue,
      "check-value": 2
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.inappropriate) + "\n      ")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "id": "option-content-input-text",
      "model-value": _vm.reportIssue,
      "check-value": 3
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.inputText) + "\n      ")])]), _vm._v(" "), (_vm.isReportInputText) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportContentMessage),
      expression: "reportContentMessage"
    }],
    staticClass: "report-input-text",
    attrs: {
      "maxlength": "500",
      "rows": "10",
      "cols": "50"
    },
    domProps: {
      "value": (_vm.reportContentMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportContentMessage = $event.target.value
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-switch"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('video_lecture.auto_play')))]), _vm._v(" "), _c('label', {
    staticClass: "switch",
    class: {
      'checked': _vm.value
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : (_vm.value)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.value = $$c
        }
      }, function($event) {
        return _vm.$emit('change', $event.target.checked)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch-track"
  }), _vm._v(" "), _c('div', {
    staticClass: "switch-thumb"
  }), _vm._v(" "), _c('div', {
    staticClass: "switch-focus-ring"
  })])])
},staticRenderFns: []}

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6 cat-element"
  }, [_c('div', {
    staticClass: "cl-card"
  }, [_c('div', {
    staticClass: "element-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('elements.subtitle')) + " " + _vm._s(_vm.learningElementLangth) + "\n    ")]), _vm._v(" "), _vm._l((_vm.learningElement), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "element"
    }, [_c('div', {
      staticClass: "element-completed"
    }, [_c('div', {
      staticClass: "icon",
      class: {
        'active': _vm.isCorrectAnswerRatio(item.correct_count, item.total_count)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "element-container"
    }, [_c('div', {
      staticClass: "element-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "element-grade"
    }, [_vm._v(_vm._s(_vm.getTranslatedName(_vm.gradeMap[item.grade_id])) + " |")]), _vm._v(" "), _c('div', {
      staticClass: "element-correct-answers"
    }, [_vm._v(_vm._s(_vm.$t('common.answers_rate')) + " "), _c('span', [_vm._v(_vm._s(_vm.correctAnswer(item.correct_count, item.total_count)) + "%")])])]), _vm._v(" "), (!_vm.isParentUser) ? _c('div', {
      staticClass: "element-action"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.goToLearningStore(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.learning')) + " >")])]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank-policy"
  }, [_vm._v("\n  " + _vm._s(_vm.$t('proficiency.standard_update', {
    month: _vm.proficiencyUpdateDate.month,
    day: _vm.proficiencyUpdateDate.day
  })) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-header-layout unselectable"
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "bs-b"
  }, [_c('DesktopHeader', {
    attrs: {
      "nav-state": _vm.navState
    }
  }), _vm._v(" "), _vm._t("desktop-subheader")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_vm._t("layout-body")], 2), _vm._v(" "), _vm._t("modal-area")], 2)
},staticRenderFns: []}

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card flex-row flex-wrap",
    class: [_vm.isCardList ? 'list' : ''],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.courseProfileImage,
      "alt": "publisher-profile"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block px-2"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.courseTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.courseOwnerName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.courseGrade) + " " + _vm._s(_vm.courseSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.isVideoCourse ? '강의수' : '참고서') + " " + _vm._s(_vm.courseLectureCount || 0))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "card-action"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/" + (_vm.subscriptionResources().icon))
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.subscriptionResources().color
    })
  }, [_vm._v("구독")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card flex-row flex-wrap",
    on: {
      "click": function($event) {
        return _vm.watchVideo(_vm.videoLecture.id)
      }
    }
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [(_vm.videoPicture) ? _c('img', {
    attrs: {
      "src": _vm.videoPicture,
      "alt": "publisher-profile"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCurrentCard) ? _c('div', {
    staticClass: "card-state-text"
  }, [_vm._v(_vm._s(_vm.$t('common.during_learning')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-img-info"
  }, [_vm._v(_vm._s(_vm.videoDuration))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block px-2"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.videoTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-1"
  }, [_vm._v(_vm._s(_vm.videoPublisher))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-2"
  }, [_vm._v(_vm._s(_vm.videoGrade) + " " + _vm._s(_vm.videoSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-3"
  }, [_vm._v(_vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.getFormatCount(_vm.videoViewsCount)))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-4"
  }, [_vm._v(_vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getFormatCount(_vm.videoLikesCount)))])])])
},staticRenderFns: []}

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subheader-nav-item clickable",
    class: {
      'subheader-nav-item--active': _vm.isActive
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-gauge"
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "lg-position",
    style: (_vm.styleBindings)
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-assignment"
  }, [(_vm.isTutorialChecked) ? _c('CatTutorial') : _vm._e(), _vm._v(" "), _c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "assignment-header"
  }, [_c('div', {
    staticClass: "cl-container title"
  }, [_vm._v(_vm._s(_vm.$t('common.class_assignment')))])]), _vm._v(" "), _c('div', {
    staticClass: "row assignment-container"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-xs-12 px-6"
  }, [_c('div', {
    staticClass: "cl-card row assignment-class-filter"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.selectedClassName,
      "variant": "variant"
    }
  }, _vm._l((_vm.filterClasses), function(item) {
    return _c('b-dropdown-item', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.selectClass(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), (_vm.selectedClassId !== 0) ? _c('div', {
    staticClass: "row assignment-stats-score"
  }, [_c('div', {
    staticClass: "col-6 user-score"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('assignment.user_score')) + " "), _c('strong', [_vm._v("    " + _vm._s(_vm.userScore || 0) + _vm._s(_vm.$t('common.score_value')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 class-score"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('assignment.class_average_score')) + " "), _c('strong', [_vm._v("  " + _vm._s(_vm.classScore || 0) + _vm._s(_vm.$t('common.score_value')) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cl-card assignment-stats-filter row"
  }, _vm._l((_vm.filterAssignmentStats), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "col-3 assignment-stats",
      class: {
        'active': _vm.selectedStats === item.code
      },
      on: {
        "click": function($event) {
          return _vm.selectStats(item.code)
        }
      }
    }, [_c('div', {
      staticClass: "assignment-count"
    }, [_vm._v(_vm._s(item.value || 0))]), _vm._v(" "), _c('div', {
      staticClass: "assignment-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? [_c('div', {
    style: ({
      'padding': '24px'
    })
  }, [_c('LoadingBounce')], 1)] : [(_vm.isFilterAssignments) ? [_c('Assignment', {
    attrs: {
      "eventLabel": 'assignment',
      "assignments": _vm.filterAssignments,
      "isBlock": true
    }
  }), _vm._v(" "), (_vm.filterAssignments.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()] : [_c('div', {
    staticClass: "empty-assignment"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_empty_assignment.png",
      "alt": "empty-assignment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.empty_assignment')))])])]]], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isSupportedGrade && !_vm.isParentUser) ? _c('div', {
    staticClass: "proficiency-container"
  }, [_c('div', {
    staticClass: "not-support-grade"
  }, [_c('div', {
    staticClass: "title px-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.user_proficiency')) + "\n        "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.previewProficiencyModal",
      modifiers: {
        "previewProficiencyModal": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title px-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))])])])]) : [(!_vm.isParentUser) ? _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.user_proficiency',
      "eventLabel": 'levels.view_more',
      "routeName": 'cat-proficiency'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "proficiency-container"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.filterSubjects,
      "selectedId": _vm.selectedSubjectId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('CatScore', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubjectId,
      "selectedSubjectColor": _vm.selectedSubjectColor
    }
  }), _vm._v(" "), _c('CatRank', {
    attrs: {
      "selectedSubjectId": _vm.selectedSubjectId
    }
  })], 1), _vm._v(" "), _c('CatRankPolicy')], 1)], _vm._v(" "), _c('b-modal', {
    ref: "modal",
    staticClass: "preview-proficiency-modal",
    attrs: {
      "id": "previewProficiencyModal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "preview-proficiency"
  }, [_c('div', {
    staticClass: "preview-proficiency-header"
  }, [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-body"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_sample_level.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-proficiency-footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.confirmation')) + "\n          ")])])])])], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('licence.title'),
      "isBackground": true
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-licence-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "user-licence"
  }, [_c('img', {
    staticClass: "licence-icon",
    attrs: {
      "src": "/static/images/ic-license-code.svg"
    }
  }), _vm._v(" "), (_vm.isUserLicence) ? _c('h5', {
    staticClass: "licence-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('licence.register_confirm', {
        user: _vm.currentUserName
      }))
    }
  }) : _c('h4', {
    staticClass: "licence-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('licence.form_title'))
    }
  }), _vm._v(" "), (_vm.isUserLicence) ? _c('div', {
    staticClass: "licence-card"
  }, [_c('h5', {
    staticClass: "licence-card-title"
  }, [_vm._v(_vm._s(_vm.$t('licence.sub_title')))]), _vm._v(" "), _c('div', {
    staticClass: "licence-card-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('licence.register_period')))]), _vm._v(" "), _c('div', {
    staticClass: "licence-card-date"
  }, [_vm._v(_vm._s(_vm.licenceStartDate) + "~" + _vm._s(_vm.licenceEndDate))])]) : _c('div', {
    staticClass: "row form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenceCode),
      expression: "licenceCode"
    }],
    staticClass: "form-control licence-code-field",
    attrs: {
      "type": "text",
      "placeholder": _vm.fieldPlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.licenceCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenceCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "licence-code-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.isLicenceCode || _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.submitLicenceCode()
      }
    }
  }, [(_vm.busy) ? _c('LoadingBounce') : [_vm._v(_vm._s(_vm.$t('licence.register')))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "licence-benefit"
  }, [_c('h5', {
    staticClass: "benefit-title"
  }, [_vm._v(_vm._s(_vm.$t('licence.benefit_title')))]), _vm._v(" "), _vm._l((_vm.benefitItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "benefit-item"
    }, [_c('img', {
      attrs: {
        "src": "/static/images/ic-check.svg",
        "alt": "icon"
      }
    }), _vm._v(" " + _vm._s(item) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.isSuccess) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": false,
      "title": _vm.$t('licence.register_success'),
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.isSuccess = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.successText)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": true,
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.isError = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "primeModal",
    attrs: {
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "body-class": "prime-body",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "prime-container"
  }, [_c('img', {
    staticClass: "prime-logo",
    attrs: {
      "src": "/static/images/logo-prime.svg",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prime-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.benefitTitle))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prime-section"
  }, [(_vm.isUnsupportText) ? _c('div', {
    staticClass: "unsupport-text"
  }, [_vm._v(" " + _vm._s(_vm.unsupportText))]) : _vm._l((_vm.benefitItems), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "benefit-items"
    }, [_c('img', {
      staticClass: "check-icon",
      attrs: {
        "src": value.icon,
        "alt": "icon"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "benefit-text"
    }, [_vm._v("\n          " + _vm._s(value.text) + "\n        ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "prime-btn-container"
  }, [_c('button', {
    staticClass: "prime-ok-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('okModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.notice.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "prime-close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.notice.cancel')))])])])])
},staticRenderFns: []}

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalContainer', {
    staticClass: "basic-modal"
  }, [_c('Card', {
    staticClass: "modal-content mx-auto"
  }, [_c('div', {
    staticClass: "mdl-card__title typography--color-primary typography--font-weight-500 basic-modal-header",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (!_vm.hideBody) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-typography--body-1 basic-modal-body"
  }, [_vm._t("default", [_vm._v("body")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions text-right basic-modal-actions"
  }, [(!_vm.hideCancel) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n        취소\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": _vm.okDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_vm._v("\n        확인\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-assignment"
  }, [_c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.class_assignment',
      "count": _vm.activeAssignments.length,
      "routeName": 'cat-assignment',
      "eventLabel": 'assignments.view_more'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " cl-container"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-assignment"
  }, [_c('div', {
    staticClass: "dummy-assignment-image"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dummy-assignment-date"
  })]) : [(!_vm.isActiveAssignments) ? _c('div', {
    staticClass: "empty-assignment"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/img_empty_assignment.png',
      "alt": "empty-assignment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.empty_assignment')))])]) : _c('Assignment', {
    attrs: {
      "eventLabel": 'assignment',
      "assignments": _vm.filterActiveAssginments,
      "isBlock": false
    }
  })]], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-assignment-content"
  }, [_c('div', {
    staticClass: "dummy-assignment-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-assignment-subtitle"
  })])
}]}

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank-container"
  }, [_c('div', {
    staticClass: "cl-card"
  }, [_c('div', {
    staticClass: "rank"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "rank-title"
  }, [_vm._v(_vm._s(_vm.$t('common.rank')))]), _vm._v(" "), _c('div', {
    staticClass: "rank-stats"
  }, [(_vm.isSchoolTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.schoolRate)) + "%")]), _vm._v(" "), (_vm.changedSchoolRate !== 0) ? _c('div', {
    staticClass: "changed"
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/" + (_vm.changedRateResource(_vm.changedSchoolRate).icon)),
      "alt": "changed-score"
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.changedRateResource(_vm.changedSchoolRate).color
    })
  }, [_vm._v(_vm._s(_vm.changedRateScore(_vm.changedSchoolRate)) + "%")])]) : _vm._e()] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "rank-standard"
  }, [(_vm.isSchoolTotal) ? [_vm._v(_vm._s(_vm.schoolName) + " " + _vm._s(_vm.$t('common.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "rank"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "rank-title"
  }, [_vm._v(_vm._s(_vm.$t('common.rank')))]), _vm._v(" "), _c('div', {
    staticClass: "rank-stats"
  }, [(_vm.isDistrictTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.districtRate)) + "%")]), _vm._v(" "), (_vm.changedDistrictRate !== 0) ? _c('div', {
    staticClass: "changed"
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/" + (_vm.changedRateResource(_vm.changedDistrictRate).icon)),
      "alt": "changed-score"
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.changedRateResource(_vm.changedDistrictRate).color
    })
  }, [_vm._v(_vm._s(_vm.changedRateScore(_vm.changedDistrictRate)) + "%")])]) : _vm._e()] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "rank-standard"
  }, [(_vm.isDistrictTotal) ? [_vm._v(_vm._s(_vm.regionName) + " " + _vm._s(_vm.$t('common.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "rank"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "rank-title"
  }, [_vm._v(_vm._s(_vm.$t('common.rank')))]), _vm._v(" "), _c('div', {
    staticClass: "rank-stats"
  }, [(_vm.isGradeTotal) ? [_c('strong', [_vm._v(_vm._s(_vm.rateScore(_vm.gradeRate)) + "%")]), _vm._v(" "), (_vm.changedGradeRate !== 0) ? _c('div', {
    staticClass: "changed"
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/" + (_vm.changedRateResource(_vm.changedGradeRate).icon)),
      "alt": "changed-score"
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.changedRateResource(_vm.changedGradeRate).color
    })
  }, [_vm._v(_vm._s(_vm.changedRateScore(_vm.changedGradeRate)) + "%")])]) : _vm._e()] : _c('strong', [_vm._v("-%")])], 2), _vm._v(" "), _c('div', {
    staticClass: "rank-standard"
  }, [(_vm.isGradeTotal) ? [_vm._v(_vm._s(_vm.$t('proficiency.standard')))] : [_vm._v(_vm._s(_vm.$t('common.standard_before_update')))]], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-info-school.svg",
      "alt": "school-rank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-info-location.svg",
      "alt": "school-rank"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-info-grade.svg",
      "alt": "school-rank"
    }
  })])
}]}

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "desktop-header"
  }, [_c('div', {
    staticClass: "desktop-header__container mx-auto"
  }, [_c('div', {
    staticClass: "desktop-header-logo float-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ct-learning-logo.png",
      "alt": "app logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "desktop-header-nav float-left"
  }, [_c('nav', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item",
    class: {
      'desktop-header-nav__item--active': _vm.navState === 'perf'
    }
  }, [_vm._v("\n            학습 분석\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/badges"
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item",
    class: {
      'desktop-header-nav__item--active': _vm.navState === 'badges'
    }
  }, [_vm._v("\n            미션 현황\n          ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.ctStoreUrl
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item"
  }, [_vm._v("맞춤 학습")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "desktop-header-profile float-right"
  }, [_c('a', {
    staticClass: "desktop-header-profile__image",
    style: (_vm.profileImageStyle),
    attrs: {
      "href": _vm.userProfileUrl,
      "target": "_blank"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "learning-guide-modal",
    attrs: {
      "id": _vm.id,
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "score-guide-container"
  }, [_c('div', {
    staticClass: "score-guide-header"
  }, [_vm._v(_vm._s(_vm.$t('ct_score.title')))]), _vm._v(" "), _c('div', {
    staticClass: "score-guide-article",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ct_score.description'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "standard-container"
  }, _vm._l((_vm.gradeScores), function(item) {
    return _c('div', {
      key: item.grade,
      staticClass: "standard-article"
    }, [_c('div', {
      staticClass: "grade"
    }, [_vm._v(_vm._s(item.grade))]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_vm._v(_vm._s(item.score))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('ct_score.score_confirm')))])])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-header"
  }, [_c('div', {
    staticClass: "row align-items-center cat-header-container"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12 col-xs-12 px-6"
  }, [(_vm.isUserChildrentList || !_vm.isParentUser) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cat-body"
  }, [(!_vm.catComment) ? [_c('span', {
    staticClass: "cat-title"
  }, [_vm._v(_vm._s(_vm.$t('common.sam_loading')))])] : [_c('span', {
    staticClass: "cat-title"
  }, [_vm._v(_vm._s(_vm.$t('common.sam_hello')) + "\n            " + _vm._s(_vm.isParentUser ?
    _vm.$t('common.sam_parent_greeting', {
      user: _vm.selectedChildName
    }) :
    _vm.$t('common.sam_student_greeting', {
      user: _vm.userName
    })) + ",")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "cat-description"
  }, [_vm._v("\n            " + _vm._s(_vm.catComment()) + "\n          ")])]], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-12 col-xs-12 p-14"
  }, [(_vm.isPremiumSchool) ? [_c('span', {
    staticClass: "premium-school-text"
  }, [_vm._v(_vm._s(_vm.$t('common.premium_school')))])] : _vm._e(), _vm._v(" "), (_vm.isParentUser) ? [_c('div', {
    staticClass: "child-filter"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.selectedChildName,
      "variant": "variant"
    }
  }, [_vm._l((_vm.userChildrenList), function(item) {
    return _c('b-dropdown-item', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.selectChild(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.openChildSettings()
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('common.child_add')))])], 2)], 1)] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-icon"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/img-main-sam.png",
      "alt": "sam"
    }
  })])
}]}

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('div', {
    staticClass: "not-found-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('errors.not_support_country')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link-back-main"
  }, [_c('a', {
    attrs: {
      "href": _vm.classtingUrl,
      "target": "_brank"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.go_back_to_other_app')))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card flex-row flex-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block px-2"
  }, [_c('div', {
    staticClass: "card-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('prime.recommend_notice.description'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    staticClass: "btn cl-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeSnackBar')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.recommend_notice.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn cl-btn close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('okSnackBar')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.recommend_notice.confirm')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header border-0"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/ic-snackbar-sam.png",
      "alt": "publisher-profile"
    }
  })])
}]}

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNavigationBar) ? _c('header', {
    staticClass: "row navigation-bar align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-6"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": _vm.aiLink
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ct_ai_logo.png",
      "alt": "app logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-6 text-right"
  }, [(!_vm.isParentUser && !_vm.isTeacherUser) ? _c('img', {
    staticClass: "licence-icon",
    attrs: {
      "src": ("/static/images/" + _vm.isActiveLicenceUser)
    },
    on: {
      "click": function($event) {
        return _vm.userLicence()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrime) ? _c('img', {
    staticClass: "prime-icon",
    attrs: {
      "src": "/static/images/ic-prime-24.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navigation-dropdown",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "link",
      "no-caret": "",
      "right": true
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "user-profile",
    attrs: {
      "src": _vm.userProfileImage,
      "alt": "profile"
    }
  })]), _vm._v(" "), (!_vm.isParentUser && !_vm.isTeacherUser) ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userBookmarkUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.bookmark')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userLanguageUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.update_language')) + "\n        ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.userProfileUrl()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.go_to_ct')) + "            \n        ")])], 2)], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oauth-callback"
  }, [_c('LoadingBounce')], 1)
},staticRenderFns: []}

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6 cat-school-rank"
  }, [_c('CatProficiencyRank'), _vm._v(" "), _c('CatRankPolicy')], 1)
},staticRenderFns: []}

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn",
    attrs: {
      "id": "open-licence-modal",
      "hide-header": false,
      "title": _vm.$t('not_support_prime.title'),
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('not_support_prime.description'))
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('NavigationBar'), _vm._v(" "), _vm._t("sub-header"), _vm._v(" "), _vm._t("body")], 2)
},staticRenderFns: []}

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.assignments), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "assignment",
      class: [_vm.isBlock ? 'block' : 'inline'],
      on: {
        "click": function($event) {
          return _vm.openAssignmentViewer(value.viewer_url)
        }
      }
    }, [_c('div', {
      staticClass: "assignment-cover-container"
    }, [_c('img', {
      staticClass: "assignment-cover",
      attrs: {
        "src": value.assigned_card.cover_image,
        "alt": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "assignment-gradient"
    })]), _vm._v(" "), _c('div', {
      staticClass: "assignment-description"
    }, [_c('img', {
      staticClass: "assignment-profile",
      attrs: {
        "src": value.assigned_by_profile_image,
        "alt": "profile-image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "assignment-title"
    }, [_vm._v(_vm._s(value.assigned_card.title))]), _vm._v(" "), _c('div', {
      staticClass: "assignment-subtitle"
    }, [_vm._v(_vm._s(value.assigned_card.grade_name) + " " + _vm._s(value.assigned_card.subject_name) + " " + _vm._s(value.assigned_card.chapter_name))])]), _vm._v(" "), _c('div', {
      staticClass: "assignment-date",
      style: ({
        'color': _vm.dueDate(value.due_date).color
      })
    }, [(_vm.remainingDay(value.due_date)) ? _c('strong', [_vm._v("D-" + _vm._s(_vm.remainingDay(value.due_date)))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.dueDate(value.due_date).dueDate) + "\n    ")]), _vm._v(" "), (_vm.isBlock) ? _c('div', {
      staticClass: "assignment-state"
    }, [(_vm.isDueDate(value.due_date) && !_vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-active"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('assignment.assignment_solve')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.isGraded(value.submissions) && _vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-graded"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('assignment.stats.in_review_count')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isGraded(value.submissions) && _vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-score"
    }, [
      [_vm._v(_vm._s(_vm.$t('assignment.user')) + " "), _c('span', [_vm._v(_vm._s(_vm.userScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))], _vm._v(" "), [_vm._v(_vm._s(_vm.$t('assignment.class')) + " "), _c('span', [_vm._v(_vm._s(_vm.classScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))]
    ], 2) : _vm._e(), _vm._v(" "), (!_vm.isDueDate(value.due_date) && !_vm.isSubmitted(value.submissions)) ? _c('div', {
      staticClass: "assignment-state-score"
    }, [
      [_vm._v(_vm._s(_vm.$t('assignment.non_submission')))], _vm._v(" "), [_vm._v(_vm._s(_vm.$t('assignment.class')) + " "), _c('span', [_vm._v(_vm._s(_vm.classScore(value)))]), _vm._v(_vm._s(_vm.$t('common.score_value')))]
    ], 2) : _vm._e()]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalContainer', {
    staticClass: "basic-modal mission-achieved-modal"
  }, [_c('Card', {
    staticClass: "modal-content mx-auto"
  }, [_c('div', {
    staticClass: "mdl-card__title typography--color-primary typography--font-weight-bold text-center mission-achieved-modal__header"
  }, [_vm._v("\n      미션 완료!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mission-achieved-modal__body"
  }, [_vm._l((_vm.achievedMissions), function(mission) {
    return (_vm.achievedMissions.length === 1) ? _c('div', {
      key: mission.id,
      staticClass: "mission-achieved-modal__body--single"
    }, [_c('div', {
      staticClass: "achieved-mission__image text-center"
    }, [_c('img', {
      attrs: {
        "src": mission.image_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "typography--color-primary achieved-mission__title text-center"
    }, [_vm._v("\n          " + _vm._s(mission.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "typography--color-secondary achieved-mission__description text-center"
    }, [_vm._v("\n          + " + _vm._s(mission.description) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.achievedMissions.length > 1) ? _c('div', {
    staticClass: "mission-achieved-modal__body--multiple"
  }, _vm._l((_vm.achievedMissions), function(mission) {
    return _c('div', {
      key: mission.id,
      staticClass: "achieved-mission"
    }, [_c('div', {
      staticClass: "achieved-mission__image"
    }, [_c('img', {
      attrs: {
        "src": mission.image_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "achieved-mission__info"
    }, [_c('div', {
      staticClass: "typography--color-primary achieved-mission__title"
    }, [_vm._v("\n              " + _vm._s(mission.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "typography--color-secondary achieved-mission__description"
    }, [_vm._v("\n              + " + _vm._s(mission.description) + "\n            ")])])])
  }), 0) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mission-achieved-modal__actions"
  }, [(!_vm.hideGoToBadges) ? _c('div', {
    staticClass: "mission-achieved-modal__btn"
  }, [_c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect w-100",
    on: {
      "click": function($event) {
        return _vm.goToBadgesPage()
      }
    }
  }, [_vm._v("\n          미션 현황 보기\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mission-achieved-modal__btn",
    class: {
      'mx-auto': _vm.hideGoToBadges, 'float-none': _vm.hideGoToBadges
    }
  }, [_c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect w-100",
    on: {
      "click": function($event) {
        return _vm.clearNewlyAchievedMissions()
      }
    }
  }, [_vm._v("\n          확인\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-domain"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "domain-header"
  }, [_c('div', {
    staticClass: "cl-container title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.sam_assignment')) + "\n      "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.catDomainGuide",
      modifiers: {
        "catDomainGuide": true
      }
    }],
    staticClass: "icon",
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('SubHeaderTab', {
    attrs: {
      "items": _vm.catSubjects,
      "selectedId": _vm.selectedSubject
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1), _vm._v(" "), (_vm.busy) ? _c('LoadingBounce') : [_c('div', {
    staticClass: "domain-cover"
  }, [_c('div', {
    staticClass: "cl-container cover-container"
  }, [_c('div', {
    staticClass: "cover-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img-main-sam.png",
      "alt": "sam"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-description"
  }, [(_vm.busy) ? _c('span', [_vm._v(_vm._s(_vm.$t('common.sam_loading')))]) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCatDescription)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "domain-container"
  }, [_c('div', {
    staticClass: "domain-title"
  }, [_vm._v(_vm._s(_vm.$t('common.domain')) + " " + _vm._s(_vm.catSubjectDomainsLength))]), _vm._v(" "), _c('div', {
    staticClass: "row px-14"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "col-lg-12 col-xs-12 col-md-12"
  }, [_c('LoadingBounce')], 1) : [(_vm.catSubjectDomainsLength === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_domain_assignment')
    }
  }) : _vm._l((_vm.filterCatSubjectDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-6 col-xs-12 col-md-12 domain"
    }, [(value.cat && (value.cat.is_first_cat || !value.cat.is_completed)) ? _c('div', {
      staticClass: "domain-state-icon",
      style: ({
        'border-bottom-color': _vm.selectedSubjectColor
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cl-card"
    }, [_c('div', {
      staticClass: "domain-name"
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" "), _c('div', {
      staticClass: "domain-state"
    }, [(!value.cat) ? [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-8 domain-progress"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('domain.need_first_problem_solve')) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.id, true)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.first_problem_solve')) + " >\n                      ")])])]), _vm._v(" "), _c('progress-bar', {
      staticClass: "domain-progress-bar",
      attrs: {
        "value": 0,
        "bgColor": _vm.selectedSubjectColor,
        "height": 6
      }
    })] : (value.cat && value.cat.is_completed) ? [_c('div', {
      staticClass: "row",
      style: ({
        'padding': '16px 0px 16px 0px'
      })
    }, [_c('div', {
      staticClass: "col-8 domain-score"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.recent_score')) + " \n                      "), _c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                        " + _vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')) + "\n                      ")]), _vm._v(" \n                      " + _vm._s(_vm.$t('common.rank')) + "\n                      "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                          " + _vm._s(_vm.quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%\n                        ")])] : [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("-%")]), _vm._v(" \n                        " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                      ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': '#00C896'
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.id, false)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.problem_solve')) + " >\n                      ")])])])] : (value.cat && value.cat.is_first_cat) ? [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-8 domain-progress",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                      " + _vm._s(_vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)) + "% \n                      " + _vm._s(_vm.$t('common.first_problem_prgress')) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url, true)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.continu_solve')) + " >\n                      ")])])]), _vm._v(" "), _c('progress-bar', {
      staticClass: "domain-progress-bar",
      attrs: {
        "value": _vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count),
        "bgColor": _vm.selectedSubjectColor,
        "height": 6
      }
    })] : (value.cat && !value.cat.is_completed) ? [_c('div', {
      staticClass: "row",
      style: ({
        'padding': '16px 0px 16px 0px'
      })
    }, [_c('div', {
      staticClass: "col-8 domain-score"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.recent_score')) + " \n                      "), _c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                        " + _vm._s(value.proficiency_score || '-') + _vm._s(_vm.$t('common.score_value')) + "\n                      ")]), _vm._v(" \n                      " + _vm._s(_vm.$t('common.rank')) + "\n                      "), (_vm.isGradeTotal(value.rank && value.rank.grade_total)) ? [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("\n                          " + _vm._s(_vm.quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-') + "%\n                        ")])] : [_c('span', {
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_vm._v("-%")]), _vm._v(" " + _vm._s(_vm.$t('common.standard_before_update')) + "\n                      ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4 domain-action",
      style: ({
        'color': _vm.selectedSubjectColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.continu_solve')) + " >\n                      ")])])])] : _vm._e()], 2)])])
  })], _vm._v(" "), (_vm.filterCatSubjectDomains.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)])], _vm._v(" "), _c('CatDomainGuide', {
    attrs: {
      "id": "catDomainGuide"
    }
  }), _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.okSnackBar()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrimeModal) ? _c('PrimeModal', {
    attrs: {
      "benefitTitle": _vm.$t('prime.first_solve_complete'),
      "isUnsupportText": true
    },
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPositionLegend) ? _c('div', {
    staticClass: "mdl-typography--caption typography--color-secondary number-line-legend-container text-left"
  }, [_c('span', {
    staticClass: "position-label"
  }), _vm._v("\n    평균 점수\n    "), _c('span', {
    staticClass: "typography--font-weight-500 position-score"
  }, [_vm._v(_vm._s(_vm.avgScore) + "점")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "number-line-container"
  }, [_c('div', {
    staticClass: "nl-baseline"
  }, [_vm._l((11), function(_, index) {
    return _c('div', {
      key: index,
      staticClass: "nl-tick",
      style: ({
        left: ((index * 10) + "%")
      })
    })
  }), _vm._v(" "), _c('small', {
    staticClass: "nl-start-label typography--color-disabled"
  }, [_vm._v("0점")]), _vm._v(" "), _c('small', {
    staticClass: "nl-end-label typography--color-disabled"
  }, [_vm._v("100점")]), _vm._v(" "), _c('div', {
    staticClass: "nl-my-position",
    style: ({
      left: (_vm.myScore + "%")
    })
  }, [_c('div', {
    staticClass: "position-icon"
  }), _vm._v(" "), (_vm.showPositionLabel) ? _c('small', {
    staticClass: "nl-position-label"
  }, [_vm._v("나")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nl-avg-position",
    style: ({
      left: (_vm.avgScore + "%")
    })
  }, [_c('div', {
    staticClass: "position-icon"
  })])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: [_vm.isList ? 'list' : ''],
    on: {
      "click": function($event) {
        return _vm.viewCard(_vm.cardLecture.id)
      }
    }
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.cardImage,
      "alt": "Card image cap"
    }
  }), _vm._v(" "), (_vm.isCurrentCard) ? _c('div', {
    staticClass: "card-state-text"
  }, [_vm._v(_vm._s(_vm.$t('common.during_learning')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.cardTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-1"
  }, [_vm._v(_vm._s(_vm.cardPublisher))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-2"
  }, [_vm._v(_vm._s(_vm.cardGrade) + " " + _vm._s(_vm.cardSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-3"
  }, [_vm._v(_vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.getFormatCount(_vm.cardViewsCount)))]), _vm._v(" "), _c('div', {
    staticClass: "card-text-4"
  }, [_vm._v(_vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getFormatCount(_vm.cardLikeCount)))])])])
},staticRenderFns: []}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog modal-container"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('domain_lecture.title')
    },
    slot: "sub-header"
  }, [_c('div', {
    attrs: {
      "slot": "sub-header-tab"
    },
    slot: "sub-header-tab"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.lecturesType,
      "isStaticTab": true,
      "selectedId": _vm.selectedLectureType
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [
    [_c('div', {
      staticClass: "domain-lectures-cover"
    }, [_c('div', {
      staticClass: "cover-container"
    }, [_c('div', {
      staticClass: "cover-icon"
    }, [_c('img', {
      attrs: {
        "src": "/static/images/img-main-sam.png",
        "alt": "sam"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "cover-body"
    }, [(_vm.busy) ? _c('span', [_vm._v(_vm._s(_vm.$t('common.sam_loading')))]) : _c('span', [_c('span', {
      staticClass: "subejct",
      style: ({
        'background': _vm.domainSubjectColor
      })
    }, [_vm._v(_vm._s(_vm.domainSubjectName))]), _vm._v(" "), _c('span', {
      staticClass: "domain"
    }, [_vm._v(_vm._s(_vm.domainName))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(_vm.catDescription))])])])])]), _vm._v(" "), (_vm.busy) ? _c('LoadingBounce') : _c('div', {
      staticClass: "domain-lectures row"
    }, [(_vm.selectedLectureType === _vm.videoLectureType) ? [(_vm.domainLectures.length === 0) ? _c('EmptyContent', {
      attrs: {
        "emptyContentText": _vm.emptyVideoLectureText
      }
    }) : [_vm._l((_vm.domainLectures), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
      }, [_c('VideoCard', {
        attrs: {
          "videoLecture": item,
          "eventLabel": 'more_lectures.video_lecture'
        }
      })], 1)
    }), _vm._v(" "), (_vm.domainLectures.length >= 10) ? _c('InfiniteLoading', {
      staticClass: "w-100",
      on: {
        "infinite": _vm.infiniteHandler
      }
    }, [_c('div', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-results"
      },
      slot: "no-results"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })]) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.selectedLectureType === _vm.cardLectureType) ? [(_vm.domainLectures.length === 0) ? _c('EmptyContent', {
      attrs: {
        "emptyContentText": _vm.emptyCardLectureText
      }
    }) : [_vm._l((_vm.domainLectures), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
      }, [_c('ImageCard', {
        attrs: {
          "cardLecture": item,
          "eventLabel": 'more_lectures.card_lecture'
        }
      })], 1)
    }), _vm._v(" "), (_vm.domainLectures.length >= 10) ? _c('InfiniteLoading', {
      staticClass: "w-100",
      on: {
        "infinite": _vm.infiniteHandler
      }
    }, [_c('div', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-results"
      },
      slot: "no-results"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })]) : _vm._e()]] : _vm._e()], 2)]
  ], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-video cl-container"
  }, [(_vm.busy) ? [_vm._m(0), _vm._v(" "), _vm._m(1)] : _vm._l((_vm.recommendVideoLectures), function(item, index) {
    return _c('TextCard', {
      key: index,
      attrs: {
        "videoLecture": item,
        "isList": true
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
}]}

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('common.sam_recommend_card_lecture')
    },
    slot: "sub-header"
  }, [_c('div', {
    attrs: {
      "slot": "sub-header-tab"
    },
    slot: "sub-header-tab"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.cardLectureSubjects,
      "selectedId": _vm.selectedId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1)]), _vm._v(" "), (_vm.busy) ? _c('LoadingBounce', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }) : _c('div', {
    staticClass: "recommend-card-lecture row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.cardLectures.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_card_lecture')
    }
  }) : _vm._l((_vm.cardLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-2"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "eventLabel": 'video_lectrues.lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.showPrime()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cardLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header-tab"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "item",
      class: {
        'active': _vm.selectedId === parseInt(item.id)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selected(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getTabName(item)) + "\n    ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-arrow-left-menu.svg",
      "alt": "prev"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-arrow-right-menu.svg",
      "alt": "next"
    }
  })])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cl-progress-bar-container"
  }, [_c('div', {
    staticClass: "cl-progress-bar",
    style: (_vm.progressBarStyle)
  }, [_c('div', {
    staticClass: "cl-progress",
    style: (_vm.progressStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('course.title'),
      "isBackground": false
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-course-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce', {
    staticClass: "w-100"
  }) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 px-12 mt-6 px-6"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.videoCourse,
      "isCardList": true,
      "isVideoCourse": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n        " + _vm._s(_vm.videoCourseDescription) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "course-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.videoCourseCreatedDate) + "\n      ")]), _vm._v(" "), (_vm.videoCourseLectures.length > 0) ? _c('div', {
    staticClass: "course-lectures"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title px-0"
  }, [_vm._v(_vm._s(_vm.$t('course.video_lecture')) + " " + _vm._s(_vm.videoLectureCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action px-0"
  }, [_vm._v(_vm._s(_vm.$t('course.video_lecture_time')) + " " + _vm._s(_vm.videoCourseDuration))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.videoCourseLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-6 px-6"
    }, [_c('VideoCard', {
      attrs: {
        "videoLecture": item,
        "eventLabel": 'video_course.lecture',
        "isCourseCard": true,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), (_vm.videoCourseLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)]) : _vm._e()]], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('common.sam_recommend_video_lecture')
    },
    slot: "sub-header"
  }, [_c('div', {
    attrs: {
      "slot": "sub-header-tab"
    },
    slot: "sub-header-tab"
  }, [_c('SubHeaderTab', {
    attrs: {
      "items": _vm.videoLectureSubjects,
      "selectedId": _vm.selectedId
    },
    on: {
      "selectedTab": _vm.selectedTab
    }
  })], 1)]), _vm._v(" "), (_vm.busy) ? _c('LoadingBounce', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }) : _c('div', {
    staticClass: "recommend-video-lecture row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.videoLectures.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_video_lecture')
    }
  }) : _vm._l((_vm.videoLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 px-6 mb-2 mt-6"
    }, [_c('VideoCard', {
      attrs: {
        "videoLecture": item,
        "eventLabel": 'video_lectrues.lecture'
      }
    })], 1)
  }), _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.showPrime()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */
/***/ (function(module, exports) {

module.exports = {"common":{"more":"더보기","assignment_title":"클래스 과제","class_assignment":"클래스 과제","sam_recommend_video_lecture":"Sam 추천 강의","sam_recommend_card_lecture":"Sam 추천 참고서","sam_assignment":"Sam 과제","user_proficiency":"나의 수준","classting_score":"클래스팅 점수","continu_solve":"이어풀기","problem_solve":"문제풀기","first_problem_solve":"진단하기","empty_assignment":"클래스 과제가 없어요!","bookmark":"즐겨찾기","go_to_classting":"클래스팅으로 이동","sam_loading":"잠깐만요~","sam_student_hello":"안녕하세요!","sam_student_greeting":"{user} 학생","sam_parent_greeting":"{user} 학부모님,","sam_growth_comment":"{subjectName} 점수가 {score}점이나 상승했네요. 대단해요~","sam_not_growth_comment":"{subjectName} 점수가 {score}점이 떨어졌어요. 기초가 중요!","sam_assignment_comment":"클래스 과제가 {assignment}개 있어요! 과제는 미리미리~","sam_comment_1":"오늘도 러닝과 함께 즐거운 하루 보내요!","sam_comment_2":"오늘도 저와 함께 열심히 공부해볼까요?","sam_comment_3":"제가 내준 과제로 기본기를 탄탄히 다져보아요.","sam_comment_4":"클래스 과제는 미루지 말고 바로 푸는게 중요해요.","sam_comment_5":"클래스 과제가 없네요. Sam이 내준 과제를 해볼까요?","sam_parent_comment":"자녀의 학습 결과를 한 눈에 확인해보세요!","sam_return_visit":"오랜만이에요. 저를 잘 따라오고 있나요~?","score":"점수","score_value":"점","video_lecture":"강의","card_lecture":"참고서","premium_school":"현재 학교 IP로 접속중입니다.","child_add":"자녀 추가하기","ct_score":"클래스팅 점수","first_problem_prgress":"진단중","go_to_ct":"클래스팅으로 이동","subscription_course":"구독코스","sam_hello":"안녕하세요!","sam_return_visit_comment":"오랜만이에요. 저를 잘 따라오고 있나요~?","recent_score":"최근점수","created_date":"등록일","domain":"영역","rank":"상위","answers_rate":"정답률","learning":"학습하기","like_up":"빛내기","view_count":"조회수","basic_subject":"전체","confirmation":"확인","error_report":"오류 신고 접수가 완료되었습니다.","during_learning":"학습중","standard_before_update":"집계중","standard":"기준","parent":"학부모님","student":"학생","next":"다음","prev":"이전","school_info":"학교정보","grade_info":"학년정보","child":"자녀","me":"나","all_grade":"전체 학년","grade_placeholder":"학년 선택","others":"기타","average":"평균","detail":"상세보기","report":"신고하기","cancel":"취소","go_back_to_main":"클래스팅 AI로 돌아가기","go_back_to_other_app":"클래스팅 웹으로 돌아가기","update_app":"최신버전 앱 다운로드 받기","update_language":"언어설정","after_update_language":"클래스팅 웹에서 언어 설정 이후 새로 고침 해주세요.","not_support_cat":"Sam 과제를 지원하지 않는 학년 입니다","empty_video_lecture":"추천 강의가 없어요!","empty_card_lecture":"추천 참고서가 없어요!","not_support_grade":"초 3학년부터 제공되는 기능입니다.","fake_domain":{"title":"Sam 진단과제 예시 화면입니다."},"fake_proficiency":{"title":"나의 수준 예시 화면입니다."},"empty_domain_assignment":"Sam 과제가 없어요!"},"licence":{"title":"AI 제품 등록하기","licence_placeholder":"정확한 제품 등록 번호를 입력하세요","sub_title":"클래스팅 AI 이용권","register_period":"이용 기간 안내","register_confirm":"{user}님은<br/>클래스팅 AI를 이용하고 있습니다.","form_title":"AI 제품 등록 번호를<br/>입력해 주세요.","field_placeholder":"XXXXXXXX","register_button":"등록하기","benefit_title":"클래스팅 AI 학습 패키지","benefit_item_1":"국·영·수·사·과 전과목 맞춤 학습","benefit_item_2":"핵심 개념별 동영상 보충 학습","benefit_item_3":"AI 튜터의 실시간 성취도 분석","benefit_item_4":"친절한 문제별 해설과 오답 노트","register":"등록하기","register_success":"등록 완료","success_message":"라이센스 코드 등록이 완료되었습니다.<br> 이용 기간은 {startDate} ~ {endDate} 까지 입니다.<br><br>모바일 앱에서도 동일하게 혜택을 볼 수 있습니다.","error_message_1":"해당 등록 번호가 존재하지 않습니다.<br>정확한 제품 등록 번호를 입력해주세요.","error_message_2":"이미 등록된 코드입니다.<br>등록된 코드는 중복으로 사용할 수 없습니다.","benefit_item_5":"학습 동기를 부여하는 게임 요소"},"proficiency":{"standard":"전체 기준","standard_before_update":"집계중","standard_update":"{month}월 {day}일 업데이트 기준, 같은 학년 대비 백분율(%) 정보입니다.","title":"{user}의 수준","chart_title":"{user}의 수준 변화","need_cat":"진단필요"},"tutorial":{"step_1":{"title":"클래스팅 AI 시작하기","greeting":"반가워요","description":"저는 과제 학습을 도와줄 Sam이라고 해요.<br/>저와 함께 클래스팅 AI를 살펴볼까요?"},"step_2":{"title":"시작하기 전에!","update_school":"학교 정보 수정하기","description":"맞춤 과제를 구성하기 위해<br/>간단한 학습 정보가 필요해요.<br/>등록된 학교/학년 정보가 맞나요?"},"step_3":{"title":"클래스 과제 풀기","description":"학교에서 선생님이 내준 과제를 확인하고<br/>과제 결과를 확인할 수 있어요."},"step_4":{"title":"Sam의 과제 풀기","description":"인공지능 선생님 Sam이<br>나를 진단하고 분석하여 실력 향상을 위한 최적화된 문제를 과제로 내주어요."},"step_5":{"title":"{user}의 수준 파악하기","description":"클래스팅 점수로 과목별, 영역별, 요소별로<br/>아주 상세하게 나의 수준을 파악할 수 있어요.","end_tutorial":"클래스팅 AI 시작하기"}},"assignment":{"title":"클래스 과제","all_class":"모든 클래스","stats":{"total_count":"전체","todo_count":"진행중","in_review_count":"채점중","ended_count":"종료"},"class_average_score":"클래스 평균 성취도","user_score":"내 성취도","assignment_solve":"과제 풀기","assignment_in_review":"진행중","user":"나","class":"클래스","non_submission":"미제출","period_submission":"{date}까지","end_submission":"{date}에 종료됨"},"video_lecture":{"title":"상세보기","relation_video_lecture":"관련강의","auto_play":"자동재생","lecture_count":"강의수"},"card_lecture":{"title":"상세보기","page_count":"페이지","relation_card_lecture":"관련 참고서"},"course":{"title":"코스 전체보기","video_lecture":"전체 강의","video_lecture_time":"총 학습시간","card_lecture":"전체 참고서"},"elements":{"subtitle":"내용 요소"},"domain_lecture":{"title":"더 공부하기","domain_lecture_comment":"해당 영역과 연관된 추천 학습 자료입니다","element_lecture_comment":"{user}에게 필요한 학습요소를 모아두었어요","empty_video_lecture":"관련 강의가 없어요!","empty_card_lecture":"관련 참고서가 없어요!"},"domain":{"tutorial":{"title":"Sam의 과제 풀기","section":"인공지능 선생님 Sam이 나의 실력 향상을 위해<br>과목 별 배워야 할 진단 과제를 내주어요.<br><br>진단 이후, 나의 수준에 딱 맞는<br>문제를 풀면서 함께 실력을 키워볼까요?","button":"진단 과제 풀러가기"},"complete_problem":"{count}영역 진단을 완료했어요. 나에게 딱맞는 문제를 풀어볼까요?","current_problem_count":"지금까지 {count}개의 진단 과제를 풀었어요!<br/>대단해요.","need_first_problem_solve":"진단이 필요합니다."},"bookmark":{"title":"즐겨찾기","empty_vidoe_lecture":"즐겨찾기하신 강의가 없어요!","empty_card_lecture":"즐겨찾기하신 참고서가 없어요!"},"ct_score":{"title":"클래스팅 점수란?","description":"학생의 수준에 맞춰 제공되는 문제를 푸는 과정을 통해<br>\n나의 수준을 판단할 수 있게 고안된 평가 체계입니다.<br><br>\n점수를 통해 내가 어떤 학년에서 어느 정도 수준인지<br>직관적으로 알 수 있습니다.","score_label_1":"초등학교 1학년 수준","score_label_2":"초등학교 2학년 수준","score_label_3":"초등학교 3학년 수준","score_label_4":"초등학교 4학년 수준","score_label_5":"초등학교 5학년 수준","score_label_6":"초등학교 6학년 수준","score_label_7":"중학교 1학년 수준","score_label_8":"중학교 2학년 수준","score_label_9":"중학교 3학년 수준","score_label_10":"고등학교 1학년 수준","score_label_11":"고등학교 2학년 수준","score_label_12":"고등학교 3학년 수준","score_value_1":"100 ~ 199점","score_value_2":"200 ~ 299점","score_value_3":"300 ~ 399점","score_value_4":"400 ~ 499점","score_value_5":"500 ~ 599점","score_value_6":"600 ~ 699점","score_value_7":"700 ~ 799점","score_value_8":"800 ~ 899점","score_value_9":"900 ~ 999점","score_value_10":"1000 ~ 1099점","score_value_11":"1100 ~ 1199점","score_value_12":"1200 ~ 1299점","score_confirm":"나의 수준 확인하기"},"not_support_prime":{"title":"AI 라이센스 회원이 아니신가요?","description":"학교/담당 선생님께 AI 라이센스 문의 또는 등록 후 이용 가능합니다.","link":"클래스팅 AI 학습 패키지"},"report_content":{"error":"콘텐츠에 오류가 있습니다","inappropriate":"콘텐츠에 부적절한 내용이 있습니다","input_text":"직접입력 (신고내용을 작성해주세요)"},"prime":{"first_solve_complete":"학습 진단 1회 무료제공 완료!<br><strong>프라임 멤버십</strong>으로 더 많은<br>AI 자동분석 학습진단을 경험하세요.","notice":{"confirm":"프라임 멤버십 자세히 보기","cancel":"나중에 보기"},"benefit":{"title":"맞춤형 학습 리포트를 확인하려면?<br><strong>클래스팅 프라임을 구독해보세요!</strong>","item_1":"AI 첫 진단 과제 무제한","item_2":"AI 추천 참고서 동영상 강의 무제한","item_3":"실시간 학습분석 리포트 제공","item_4":"광고 제거 기능 및 오프라인 혜택"},"not_support":"일반 회원은 영역별 1회 무료제공 됩니다.","lecture_notice":{"description":"무료회원은 하루에 한개 동영상 시청이 가능합니다.<br />\n해당 콘텐츠를 계속 학습하고 싶다면?<br />\n클래스팅 프라임을 구독해보세요.","confirm":"자세히","cancel":"다음에"},"recommend_notice":{"description":" 인공지능 선생님 Sam이 추천하는 풍부한<br/>영상강의/참고서로 맞춤 학습하세요!","confirm":"프라임 보기","cancel":"나중에 보기"}},"errors":{"not_found":"주소가 잘못 입력되었거나 변경되어<br>페이지를 찾을 수 없습니다.","not_support_country":"지원하지 않는 국가 입니다.","unauthorized":"선생님 역할은 AI 기능을 지원하지 않습니다.<br>학생/학부모 역할로 로그인하여 AI를 체험해보세요.","not_support_user":"클래스팅AI를 지원하지 않는 버전 입니다."},"parent":{"main":{"title":"내 자녀의 학습 수준은?\n","subtitle":"과제 결과를 바탕으로<br>\n아이의 학습 수준을 볼 수 있습니다.<br>\n자녀를 연결해 결과를 확인하세요."}}}

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports = {"common":{"more":"閱讀更多","assignment_title":"班級作業","class_assignment":"班級作業","sam_recommend_video_lecture":"Sam 推薦課程","sam_recommend_card_lecture":"Sam 推薦參考書","sam_assignment":"Sam 作業","user_proficiency":"我的程度","classting_score":"Classting 評分","continu_solve":"接著看","problem_solve":"前往課題","first_problem_solve":"診斷","empty_assignment":"無班級作業","bookmark":"我的最愛","go_to_classting":"前往Classting","sam_loading":"請稍待一會兒~","sam_student_hello":"您好！","sam_student_greeting":"學生{user} ","sam_parent_greeting":"{user} 家長","sam_growth_comment":"{subjectName}進步{score}分，厲害呦~","sam_not_growth_comment":"{subjectName}退步{score}分，基礎打穩很重要喔！","sam_assignment_comment":"有班級作業{assignment}！快前往~","sam_comment_1":"祝福今天學習愉快！","sam_comment_2":"今天和我一起努力學習嗎？","sam_comment_3":"正在努力打穩學習基礎知識","sam_comment_4":"別拖延班級作業，盡快完成！","sam_comment_5":"沒有班級作業，要不要看看Sam老師出的作業？","sam_parent_comment":"一目了然地查看孩子的學習成果！","sam_return_visit":"好久不見~真著我一起前進吧！","score":"評分","score_value":"分","video_lecture":"課程","card_lecture":"參考書","premium_school":"目前已連接到學校IP","child_add":"添加子女","ct_score":"Classting評分","first_problem_prgress":"診斷中","go_to_ct":"前往Classting","subscription_course":"訂閱課程","sam_hello":"您好！","sam_return_visit_comment":"好久不見~跟著我一起學習嗎？","recent_score":"最近評分","created_date":"登錄日","domain":"英語","rank":"排名","answers_rate":"正答率","learning":"學習","like_up":"點燈","view_count":"參考","basic_subject":"全部","confirmation":"確定","error_report":"錯誤報告已收到","during_learning":"學習中","standard_before_update":"計算中","standard":"基準","parent":"家長","student":"學生","next":"下一個","prev":"前","school_info":"學校資訊","grade_info":"學年資訊","child":"子女","me":"我的","all_grade":"所有年級","grade_placeholder":"選擇年級","others":"其他","average":"平均","detail":"詳細內容","report":"錯誤報告","cancel":"取消","go_back_to_main":"回到Classting AI","go_back_to_other_app":"回到Classting網站","update_app":"下載最新版本的APP","update_language":"語言設置","after_update_language":"在Classting網頁上設置語言後請刷新。","not_support_cat":"本年級不支援人工智慧老師的Sam作業","empty_video_lecture":"沒有推薦課程","empty_card_lecture":"沒有推薦參考書","not_support_grade":"從小學3年級開始提供的功能","fake_domain":{"title":"Sam診斷學習的舉例畫面"},"fake_proficiency":{"title":"我的學習水平的舉例畫面"},"empty_domain_assignment":"沒有Sam留的作業！"},"licence":{"title":"AI許可代碼登錄","licence_placeholder":"請輸入正確的許可代碼","sub_title":"Classting AI 許可","register_period":"使用期間訊息","register_confirm":"{user}<br/>使用Classting AI許可中","form_title":"Classting AI 許可<br/>請輸入<strong>登錄代碼</strong>","field_placeholder":"請輸入正確的許可證代碼","register_button":"登錄","benefit_title":"AI許可成員的好處！","benefit_item_1":"AI Sam 提供無限診斷任務","benefit_item_2":"超過5,000個影片課程及部分參考書","benefit_item_3":"提供即時學習分析報告","benefit_item_4":"根據診斷結果推薦影片課程和參考書建議","register":"登錄","register_success":"登錄完成","success_message":"許可代碼註冊已完成<br>使用期間 {startDate} ~ {endDate} <br><br>也可透過行動載具使用","error_message_1":"此代碼不存在<br>請輸入正確許可代碼。","error_message_2":"此代碼已註冊<br>代碼不可重複使用","benefit_item_5":""},"proficiency":{"standard":"全部標準","standard_before_update":"計算中","standard_update":"{month}月 {day}日更新為準，同年級相比百分比(%)","title":"{user}的程度","chart_title":"{user}的程度變化","need_cat":"需診斷"},"tutorial":{"step_1":{"title":"開始 Classting AI","greeting":"您好！","description":"我是學習指導Sam <br/>要與我一起看看Classting AI嗎？"},"step_2":{"title":"開始前！","update_school":"編輯學校資訊","description":"為提供最合適的學習課題<br/>需要學習相關資訊<br/>目前登錄的學校/學年正確嗎？"},"step_3":{"title":"查看班級課程","description":"我可以確認學校作業<br/>並檢查作業的結果"},"step_4":{"title":"查看Sam的課題","description":"人工智慧老師Sam<br/>診斷並分析我的實力並提供優化改進問題。"},"step_5":{"title":"了解{user}的程度","description":"透過Classting評分，您可以按主題、領域和單元來詳細掌握學習程度","end_tutorial":"開始Classting AI"}},"assignment":{"title":"課程作業","all_class":"所有課程","stats":{"total_count":"全部","todo_count":"進行中","in_review_count":"評分中","ended_count":"結束"},"class_average_score":"班級平均成績","user_score":"我的成績","assignment_solve":"作業查看","assignment_in_review":"進行中","user":"我","class":"班級","non_submission":"未繳交","period_submission":"{date}為止","end_submission":"{date}結束"},"video_lecture":{"title":"詳細了解","relation_video_lecture":"相關課程","auto_play":"自動播放","lecture_count":"客成數"},"card_lecture":{"title":"查看詳情","page_count":"頁面","relation_card_lecture":"相關參考書"},"course":{"title":"查看所有課程","video_lecture":"全部課程","video_lecture_time":"總學習時間","card_lecture":"全部參考書"},"elements":{"subtitle":"內容單元"},"domain_lecture":{"title":"學習更多","domain_lecture_comment":"推薦該領域相關學習資料","element_lecture_comment":"集合{user}所需的所有學習單元","empty_video_lecture":"無相關課程！","empty_card_lecture":"無相關參考書！"},"domain":{"tutorial":{"title":"Sam的作業","section":"為更了解我的程度<br>人工智慧老師Sam會提供各科目診斷。<br><br>診斷後，提供符合學習程度的課題<br>讓學習及解決課題時也提升學習程度與能力。","button":"前往診斷作業"},"complete_problem":"{count} 診斷完成。是否前往符合學習程度的課題？","current_problem_count":"目前為止完成了{count}個診斷任務<br/>太厲害了！","need_first_problem_solve":"需診斷"},"bookmark":{"title":"我的最愛","empty_vidoe_lecture":"我的最愛無內容","empty_card_lecture":"沒有我的最愛參考書！"},"ct_score":{"title":"Classting評分？","description":"透過學生解題的過程<br>\n診斷學習程度<br>\n<br>\n透過診斷系統確實評斷學習程度","score_label_1":"國小一年級程度","score_label_2":"國小二年級程度","score_label_3":"國小三年級程度","score_label_4":"國小四年級程度","score_label_5":"國小五年級程度","score_label_6":"國小六年級程度","score_label_7":"七年級程度","score_label_8":"八年級程度","score_label_9":"九年級程度","score_label_10":"高中一年級程度","score_label_11":"高中二年級程度","score_label_12":"高中三年級程度","score_value_1":"100 ~ 199分","score_value_2":"200 ~ 299分","score_value_3":"300 ~ 399分","score_value_4":"400 ~ 499分","score_value_5":"500 ~ 599分","score_value_6":"600 ~ 699分","score_value_7":"700 ~ 799分","score_value_8":"800 ~ 899分","score_value_9":"900 ~ 999分","score_value_10":"1000 ~ 1099分","score_value_11":"1100 ~ 1199分","score_value_12":"1200 ~ 1299分","score_confirm":"確定我的程度"},"not_support_prime":{"title":"非AI許可會員嗎？","description":"AI許可登錄後，學校/教師可使用","link":"AI許可優勢"},"report_content":{"error":"內容錯誤","inappropriate":"不當內容","input_text":"直接輸入(請詳細說明)"},"prime":{"first_solve_complete":"免費體驗學習診斷已完成!<br/>欲再使用AI學習診斷分析<br>請加入<strong>進階會員</strong>","notice":{"confirm":"詳細查看進階會員內容","cancel":"稍後再看"},"benefit":{"title":"想查看進階學習報告嗎？<br><strong>現在就加入Classting進階會員!</strong>","item_1":"無限次AI初步診斷","item_2":"無限量AI推薦影片教學與參考書","item_3":"即時學習分析報告","item_4":"去廣告和離線使用"},"not_support":"一般會員可免費體驗一回","lecture_notice":{"description":"想繼續學習內容嗎？<br/>加入我們的進階會員吧！","confirm":"了解更多","cancel":"下一個"},"recommend_notice":{"description":"人工智慧老師Sam推薦<br/>合適的影片課程及參考書","confirm":"查看進階","cancel":"稍後再看"}},"errors":{"not_found":"輸入不正確或已更改，<br>找不到網頁。","not_support_country":"此國家/地區不受支持。","unauthorized":"教師角色無法登陸AI功能。<br>請以學生/家長角色登錄並體驗AI。","not_support_user":"這個版本不支持Classting AI。"},"parent":{"main":{"title":"我孩子的學習水平是多少？","subtitle":"您可以看到以學習結果為基礎<br>\n得到的孩子的學習水平<br>\n자녀를 연결해 결과를 확인하세요."}}}

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[896]);


// WEBPACK FOOTER //
// static/js/app.b095065088ff0feef813.js